// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/registry_records.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { RegistryRef } from "./registry_resolve_pb";
/**
 * ======================= shared =======================
 *
 * @generated from message mono.datagateway.v1.RegistryAppearanceCard
 */ export class RegistryAppearanceCard extends Message {
    static fromBinary(bytes, options) {
        return new RegistryAppearanceCard().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryAppearanceCard().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryAppearanceCard().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryAppearanceCard, a, b);
    }
    constructor(data){
        super(), /**
   * GROWTH | PROPOSAL | DELIVERY | MARKET | VEHICLES
   *
   * @generated from field: string plane = 1;
   */ _define_property(this, "plane", ""), /**
   * "OMEGA Recompete", "Competitor on 2 pursuits"
   *
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * "5 touchpoints · named in RFI #2 notice"
   *
   * @generated from field: string summary = 3;
   */ _define_property(this, "summary", ""), /**
   * link target of the card; empty kind = no link
   *
   * @generated from field: mono.datagateway.v1.RegistryRef primary = 4;
   */ _define_property(this, "primary", void 0), /**
   * up to 3 named contexts
   *
   * @generated from field: repeated mono.datagateway.v1.RegistryRef contexts = 5;
   */ _define_property(this, "contexts", []), /**
   * count over VISIBLE rows only
   *
   * @generated from field: int32 visible_count = 6;
   */ _define_property(this, "visibleCount", 0), /**
   * @generated from field: google.protobuf.Timestamp sort_at = 7;
   */ _define_property(this, "sortAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryAppearanceCard, "runtime", proto3);
_define_property(RegistryAppearanceCard, "typeName", "mono.datagateway.v1.RegistryAppearanceCard");
_define_property(RegistryAppearanceCard, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "plane",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "primary",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 5,
            name: "contexts",
            kind: "message",
            T: RegistryRef,
            repeated: true
        },
        {
            no: 6,
            name: "visible_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "sort_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegistrySourceLabel
 */ export class RegistrySourceLabel extends Message {
    static fromBinary(bytes, options) {
        return new RegistrySourceLabel().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistrySourceLabel().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistrySourceLabel().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistrySourceLabel, a, b);
    }
    constructor(data){
        super(), /**
   * "OMEGA COR appointment letter, Feb 2024"
   *
   * @generated from field: string text = 1;
   */ _define_property(this, "text", ""), /**
   * artifact / pricing sheet / notice; empty = none
   *
   * @generated from field: mono.datagateway.v1.RegistryRef source = 2;
   */ _define_property(this, "source", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistrySourceLabel, "runtime", proto3);
_define_property(RegistrySourceLabel, "typeName", "mono.datagateway.v1.RegistrySourceLabel");
_define_property(RegistrySourceLabel, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source",
            kind: "message",
            T: RegistryRef
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RestrictedRateTrail
 */ export class RestrictedRateTrail extends Message {
    static fromBinary(bytes, options) {
        return new RestrictedRateTrail().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RestrictedRateTrail().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RestrictedRateTrail().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RestrictedRateTrail, a, b);
    }
    constructor(data){
        super(), /**
   * always "RESTRICTED" in this package (D5)
   *
   * @generated from field: string state = 1;
   */ _define_property(this, "state", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RestrictedRateTrail, "runtime", proto3);
_define_property(RestrictedRateTrail, "typeName", "mono.datagateway.v1.RestrictedRateTrail");
_define_property(RestrictedRateTrail, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.EmploymentSpan
 */ export class EmploymentSpan extends Message {
    static fromBinary(bytes, options) {
        return new EmploymentSpan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EmploymentSpan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EmploymentSpan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EmploymentSpan, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string employment_id = 1;
   */ _define_property(this, "employmentId", ""), /**
   * COMPANY or GOVERNMENT_ORG
   *
   * @generated from field: mono.datagateway.v1.RegistryRef employer = 2;
   */ _define_property(this, "employer", void 0), /**
   * GOVERNMENT | INDUSTRY | OURS
   *
   * @generated from field: string sector = 3;
   */ _define_property(this, "sector", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: google.protobuf.Timestamp start_date = 5;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 6;
   */ _define_property(this, "endDate", void 0), /**
   * "" | MOVED | RETIRED | LAID_OFF | ACQUISITION | DECEASED | UNKNOWN
   *
   * @generated from field: string end_reason = 7;
   */ _define_property(this, "endReason", ""), /**
   * @generated from field: string departure_destination_text = 8;
   */ _define_property(this, "departureDestinationText", ""), /**
   * @generated from field: mono.datagateway.v1.RegistrySourceLabel source = 9;
   */ _define_property(this, "source", void 0), /**
   * @generated from field: string seat_id = 10;
   */ _define_property(this, "seatId", ""), /**
   * employer == the record being viewed
   *
   * @generated from field: bool is_here = 11;
   */ _define_property(this, "isHere", false), /**
   * synthetic span from contacts.company_profile_id / government_organization_id / organization (no employment rows); employment_id ""
   *
   * @generated from field: bool from_contact_form = 12;
   */ _define_property(this, "fromContactForm", false), /**
   * free-text employer (contacts.organization) when employer ref is empty
   *
   * @generated from field: string employer_text = 13;
   */ _define_property(this, "employerText", ""), /**
   * v2.1 (OD-100, DAT-07); unset until DAT-07 lands
   *
   * @generated from field: google.protobuf.Timestamp observed_from = 14;
   */ _define_property(this, "observedFrom", void 0), /**
   * v2.1 (OD-100, DAT-07); unset until DAT-07 lands
   *
   * @generated from field: google.protobuf.Timestamp observed_to = 15;
   */ _define_property(this, "observedTo", void 0), /**
   * stated | observed | inferred | unknown (DAT-07 read contract)
   *
   * @generated from field: string date_basis = 16;
   */ _define_property(this, "dateBasis", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EmploymentSpan, "runtime", proto3);
_define_property(EmploymentSpan, "typeName", "mono.datagateway.v1.EmploymentSpan");
_define_property(EmploymentSpan, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "employment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "employer",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 3,
            name: "sector",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "end_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "departure_destination_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "source",
            kind: "message",
            T: RegistrySourceLabel
        },
        {
            no: 10,
            name: "seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "is_here",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "from_contact_form",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "employer_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "observed_from",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "observed_to",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "date_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RateCell
 */ export class RateCell extends Message {
    static fromBinary(bytes, options) {
        return new RateCell().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateCell().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateCell().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateCell, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: double amount = 1;
   */ _define_property(this, "amount", 0), /**
   * @generated from field: string observation_id = 2;
   */ _define_property(this, "observationId", ""), /**
   * "MAS sheet 2025", "CCSS subK", "CALC+ table"
   *
   * @generated from field: string source_label = 3;
   */ _define_property(this, "sourceLabel", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef source = 4;
   */ _define_property(this, "source", void 0), /**
   * CEILING: number of generations (highest shown); executed types: >1 ⇒ lowest shown, count disclosed
   *
   * @generated from field: int32 observation_count = 5;
   */ _define_property(this, "observationCount", 0), /**
   * verbatim
   *
   * @generated from field: string period_label = 6;
   */ _define_property(this, "periodLabel", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateCell, "runtime", proto3);
_define_property(RateCell, "typeName", "mono.datagateway.v1.RateCell");
_define_property(RateCell, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 5,
            name: "observation_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ======================= list summaries =======================
 *
 * @generated from message mono.datagateway.v1.ListCompanyRegistrySummariesRequest
 */ export class ListCompanyRegistrySummariesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanyRegistrySummariesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanyRegistrySummariesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanyRegistrySummariesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanyRegistrySummariesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * the company ids the tab is rendering (≤ 200)
   *
   * @generated from field: repeated string ids = 6;
   */ _define_property(this, "ids", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanyRegistrySummariesRequest, "runtime", proto3);
_define_property(ListCompanyRegistrySummariesRequest, "typeName", "mono.datagateway.v1.ListCompanyRegistrySummariesRequest");
_define_property(ListCompanyRegistrySummariesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 6,
            name: "ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CompanyRelationshipToUs
 */ export class CompanyRelationshipToUs extends Message {
    static fromBinary(bytes, options) {
        return new CompanyRelationshipToUs().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyRelationshipToUs().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyRelationshipToUs().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyRelationshipToUs, a, b);
    }
    constructor(data){
        super(), /**
   * COMPETITOR | TEAMMATE | PRIME_WE_SUB_TO | OUR_SUB | PART_OF | OURS
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * pursuit / program / contract / parent company
   *
   * @generated from field: mono.datagateway.v1.RegistryRef context = 2;
   */ _define_property(this, "context", void 0), /**
   * "former sub on CCSS"
   *
   * @generated from field: string qualifier = 3;
   */ _define_property(this, "qualifier", ""), /**
   * @generated from field: google.protobuf.Timestamp since = 4;
   */ _define_property(this, "since", void 0), /**
   * unset = current
   *
   * @generated from field: google.protobuf.Timestamp until = 5;
   */ _define_property(this, "until", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyRelationshipToUs, "runtime", proto3);
_define_property(CompanyRelationshipToUs, "typeName", "mono.datagateway.v1.CompanyRelationshipToUs");
_define_property(CompanyRelationshipToUs, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "context",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 3,
            name: "qualifier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "since",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "until",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.VehicleHoldingChip
 */ export class VehicleHoldingChip extends Message {
    static fromBinary(bytes, options) {
        return new VehicleHoldingChip().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VehicleHoldingChip().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VehicleHoldingChip().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VehicleHoldingChip, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryRef vehicle = 1;
   */ _define_property(this, "vehicle", void 0), /**
   * @generated from field: string access_type = 2;
   */ _define_property(this, "accessType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(VehicleHoldingChip, "runtime", proto3);
_define_property(VehicleHoldingChip, "typeName", "mono.datagateway.v1.VehicleHoldingChip");
_define_property(VehicleHoldingChip, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicle",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 2,
            name: "access_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CompanyLineageStatus
 */ export class CompanyLineageStatus extends Message {
    static fromBinary(bytes, options) {
        return new CompanyLineageStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyLineageStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyLineageStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyLineageStatus, a, b);
    }
    constructor(data){
        super(), /**
   * "" | ACQUIRED_BY | MERGED_INTO | RENAMED_TO | PART_OF (absorbed side of the latest live lineage edge, REG-05)
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef other = 2;
   */ _define_property(this, "other", void 0), /**
   * @generated from field: google.protobuf.Timestamp effective = 3;
   */ _define_property(this, "effective", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyLineageStatus, "runtime", proto3);
_define_property(CompanyLineageStatus, "typeName", "mono.datagateway.v1.CompanyLineageStatus");
_define_property(CompanyLineageStatus, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "other",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 3,
            name: "effective",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CompanyRegistrySummary
 */ export class CompanyRegistrySummary extends Message {
    static fromBinary(bytes, options) {
        return new CompanyRegistrySummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyRegistrySummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyRegistrySummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyRegistrySummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: bool is_own_company = 3;
   */ _define_property(this, "isOwnCompany", false), /**
   * @generated from field: string cage_code = 4;
   */ _define_property(this, "cageCode", ""), /**
   * @generated from field: string uei = 5;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: string business_size = 6;
   */ _define_property(this, "businessSize", ""), /**
   * @generated from field: mono.datagateway.v1.CompanyLineageStatus lineage_status = 7;
   */ _define_property(this, "lineageStatus", void 0), /**
   * all eras; FE picks primary pill
   *
   * @generated from field: repeated mono.datagateway.v1.CompanyRelationshipToUs relationships = 8;
   */ _define_property(this, "relationships", []), /**
   * @generated from field: repeated mono.datagateway.v1.VehicleHoldingChip vehicle_holdings = 9;
   */ _define_property(this, "vehicleHoldings", []), /**
   * non-corrected CEILING, contact_id IS NULL
   *
   * @generated from field: int32 ceiling_count = 10;
   */ _define_property(this, "ceilingCount", 0), /**
   * SUBK_AGREED + BILLED + AWARDED, contact_id IS NULL
   *
   * @generated from field: int32 real_rate_count = 11;
   */ _define_property(this, "realRateCount", 0), /**
   * @generated from field: int32 known_people_current = 12;
   */ _define_property(this, "knownPeopleCurrent", 0), /**
   * @generated from field: int32 known_people_total = 13;
   */ _define_property(this, "knownPeopleTotal", 0), /**
   * @generated from field: int32 visible_pursuit_count = 14;
   */ _define_property(this, "visiblePursuitCount", 0), /**
   * @generated from field: int32 visible_contract_count = 15;
   */ _define_property(this, "visibleContractCount", 0), /**
   * vehicle families with this company's non-person CEILING rows (fallback when no holding row)
   *
   * @generated from field: repeated mono.datagateway.v1.RegistryRef price_list_vehicles = 16;
   */ _define_property(this, "priceListVehicles", []), /**
   * v2.1 (OD-49): SAM size beside the analyst tier (REG-04 column; "" until it lands)
   *
   * @generated from field: string sam_business_size = 17;
   */ _define_property(this, "samBusinessSize", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyRegistrySummary, "runtime", proto3);
_define_property(CompanyRegistrySummary, "typeName", "mono.datagateway.v1.CompanyRegistrySummary");
_define_property(CompanyRegistrySummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "is_own_company",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "cage_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "business_size",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "lineage_status",
            kind: "message",
            T: CompanyLineageStatus
        },
        {
            no: 8,
            name: "relationships",
            kind: "message",
            T: CompanyRelationshipToUs,
            repeated: true
        },
        {
            no: 9,
            name: "vehicle_holdings",
            kind: "message",
            T: VehicleHoldingChip,
            repeated: true
        },
        {
            no: 10,
            name: "ceiling_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 11,
            name: "real_rate_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "known_people_current",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "known_people_total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 14,
            name: "visible_pursuit_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 15,
            name: "visible_contract_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 16,
            name: "price_list_vehicles",
            kind: "message",
            T: RegistryRef,
            repeated: true
        },
        {
            no: 17,
            name: "sam_business_size",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCompanyRegistrySummariesResponse
 */ export class ListCompanyRegistrySummariesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanyRegistrySummariesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanyRegistrySummariesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanyRegistrySummariesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanyRegistrySummariesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CompanyRegistrySummary rows = 1;
   */ _define_property(this, "rows", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanyRegistrySummariesResponse, "runtime", proto3);
_define_property(ListCompanyRegistrySummariesResponse, "typeName", "mono.datagateway.v1.ListCompanyRegistrySummariesResponse");
_define_property(ListCompanyRegistrySummariesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: CompanyRegistrySummary,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContactRegistrySummariesRequest
 */ export class ListContactRegistrySummariesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListContactRegistrySummariesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactRegistrySummariesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactRegistrySummariesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactRegistrySummariesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * the contact ids the tab is rendering (≤ 200)
   *
   * @generated from field: repeated string ids = 7;
   */ _define_property(this, "ids", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactRegistrySummariesRequest, "runtime", proto3);
_define_property(ListContactRegistrySummariesRequest, "typeName", "mono.datagateway.v1.ListContactRegistrySummariesRequest");
_define_property(ListContactRegistrySummariesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 7,
            name: "ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContactLastTouch
 */ export class ContactLastTouch extends Message {
    static fromBinary(bytes, options) {
        return new ContactLastTouch().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContactLastTouch().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContactLastTouch().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContactLastTouch, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: google.protobuf.Timestamp at = 1;
   */ _define_property(this, "at", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryRef context = 3;
   */ _define_property(this, "context", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContactLastTouch, "runtime", proto3);
_define_property(ContactLastTouch, "typeName", "mono.datagateway.v1.ContactLastTouch");
_define_property(ContactLastTouch, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "context",
            kind: "message",
            T: RegistryRef
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContactRegistrySummary
 */ export class ContactRegistrySummary extends Message {
    static fromBinary(bytes, options) {
        return new ContactRegistrySummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContactRegistrySummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContactRegistrySummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContactRegistrySummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contact_id = 1;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: bool is_active = 3;
   */ _define_property(this, "isActive", false), /**
   * @generated from field: bool has_platform_account = 4;
   */ _define_property(this, "hasPlatformAccount", false), /**
   * CUSTOMER | COMPETITOR | TEAMMATE | INTERNAL | OTHER — contact_type first (GOVERNMENT⇒CUSTOMER, INTERNAL⇒INTERNAL)
   *
   * @generated from field: string display_type = 5;
   */ _define_property(this, "displayType", ""), /**
   * open employments, else one from_contact_form span
   *
   * @generated from field: repeated mono.datagateway.v1.EmploymentSpan current = 6;
   */ _define_property(this, "current", []), /**
   * dedup, newest first, max 3
   *
   * @generated from field: repeated mono.datagateway.v1.RegistryRef prior_employers = 7;
   */ _define_property(this, "priorEmployers", []), /**
   * @generated from field: int32 visible_appearance_count = 8;
   */ _define_property(this, "visibleAppearanceCount", 0), /**
   * max 2
   *
   * @generated from field: repeated mono.datagateway.v1.RegistryRef top_appearances = 9;
   */ _define_property(this, "topAppearances", []), /**
   * unset when none visible
   *
   * @generated from field: mono.datagateway.v1.ContactLastTouch last_touch = 10;
   */ _define_property(this, "lastTouch", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContactRegistrySummary, "runtime", proto3);
_define_property(ContactRegistrySummary, "typeName", "mono.datagateway.v1.ContactRegistrySummary");
_define_property(ContactRegistrySummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "is_active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "has_platform_account",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "display_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "current",
            kind: "message",
            T: EmploymentSpan,
            repeated: true
        },
        {
            no: 7,
            name: "prior_employers",
            kind: "message",
            T: RegistryRef,
            repeated: true
        },
        {
            no: 8,
            name: "visible_appearance_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "top_appearances",
            kind: "message",
            T: RegistryRef,
            repeated: true
        },
        {
            no: 10,
            name: "last_touch",
            kind: "message",
            T: ContactLastTouch
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContactRegistrySummariesResponse
 */ export class ListContactRegistrySummariesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListContactRegistrySummariesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactRegistrySummariesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactRegistrySummariesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactRegistrySummariesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContactRegistrySummary rows = 1;
   */ _define_property(this, "rows", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactRegistrySummariesResponse, "runtime", proto3);
_define_property(ListContactRegistrySummariesResponse, "typeName", "mono.datagateway.v1.ListContactRegistrySummariesResponse");
_define_property(ListContactRegistrySummariesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: ContactRegistrySummary,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListGovernmentOrgRegistrySummariesRequest
 */ export class ListGovernmentOrgRegistrySummariesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListGovernmentOrgRegistrySummariesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGovernmentOrgRegistrySummariesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGovernmentOrgRegistrySummariesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGovernmentOrgRegistrySummariesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * ≤ 200
   *
   * @generated from field: repeated string ids = 5;
   */ _define_property(this, "ids", []), /**
   * ignore ids; return orgs referenced by our work (cap 500, name order)
   *
   * @generated from field: bool referenced_only = 6;
   */ _define_property(this, "referencedOnly", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGovernmentOrgRegistrySummariesRequest, "runtime", proto3);
_define_property(ListGovernmentOrgRegistrySummariesRequest, "typeName", "mono.datagateway.v1.ListGovernmentOrgRegistrySummariesRequest");
_define_property(ListGovernmentOrgRegistrySummariesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 5,
            name: "ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "referenced_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GovernmentOrgRegistrySummary
 */ export class GovernmentOrgRegistrySummary extends Message {
    static fromBinary(bytes, options) {
        return new GovernmentOrgRegistrySummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovernmentOrgRegistrySummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovernmentOrgRegistrySummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovernmentOrgRegistrySummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string org_id = 1;
   */ _define_property(this, "orgId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string acronym = 3;
   */ _define_property(this, "acronym", ""), /**
   * @generated from field: string org_type = 4;
   */ _define_property(this, "orgType", ""), /**
   * DEPARTMENT (cabinet) | COMPONENT (agency) | CONTRACTING_OFFICE (office/sub_office with office_code) | OFFICE (office/sub_office) | OTHER
   *
   * @generated from field: string display_type = 5;
   */ _define_property(this, "displayType", ""), /**
   * v2.3: root of the registry parent_id chain (REG-58 tree); never materialized_path
   *
   * @generated from field: mono.datagateway.v1.RegistryRef top_ancestor = 6;
   */ _define_property(this, "topAncestor", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.RegistryRef vehicles_awarded = 7;
   */ _define_property(this, "vehiclesAwarded", []), /**
   * @generated from field: repeated mono.datagateway.v1.VehicleUsedVia vehicles_used_via = 8;
   */ _define_property(this, "vehiclesUsedVia", []), /**
   * @generated from field: int32 visible_program_count = 9;
   */ _define_property(this, "visibleProgramCount", 0), /**
   * @generated from field: int32 known_people_count = 10;
   */ _define_property(this, "knownPeopleCount", 0), /**
   * @generated from field: string office_code = 11;
   */ _define_property(this, "officeCode", ""), /**
   * tenant_id = '_system'
   *
   * @generated from field: bool read_only_reference = 12;
   */ _define_property(this, "readOnlyReference", false), /**
   * max 3, newest first
   *
   * @generated from field: repeated mono.datagateway.v1.RegistryRef visible_programs = 13;
   */ _define_property(this, "visiblePrograms", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovernmentOrgRegistrySummary, "runtime", proto3);
_define_property(GovernmentOrgRegistrySummary, "typeName", "mono.datagateway.v1.GovernmentOrgRegistrySummary");
_define_property(GovernmentOrgRegistrySummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "org_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "display_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "top_ancestor",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 7,
            name: "vehicles_awarded",
            kind: "message",
            T: RegistryRef,
            repeated: true
        },
        {
            no: 8,
            name: "vehicles_used_via",
            kind: "message",
            T: VehicleUsedVia,
            repeated: true
        },
        {
            no: 9,
            name: "visible_program_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "known_people_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 11,
            name: "office_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "read_only_reference",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "visible_programs",
            kind: "message",
            T: RegistryRef,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.VehicleUsedVia
 */ export class VehicleUsedVia extends Message {
    static fromBinary(bytes, options) {
        return new VehicleUsedVia().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VehicleUsedVia().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VehicleUsedVia().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VehicleUsedVia, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryRef vehicle = 1;
   */ _define_property(this, "vehicle", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryRef via_org = 2;
   */ _define_property(this, "viaOrg", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(VehicleUsedVia, "runtime", proto3);
_define_property(VehicleUsedVia, "typeName", "mono.datagateway.v1.VehicleUsedVia");
_define_property(VehicleUsedVia, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicle",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 2,
            name: "via_org",
            kind: "message",
            T: RegistryRef
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListGovernmentOrgRegistrySummariesResponse
 */ export class ListGovernmentOrgRegistrySummariesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListGovernmentOrgRegistrySummariesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGovernmentOrgRegistrySummariesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGovernmentOrgRegistrySummariesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGovernmentOrgRegistrySummariesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.GovernmentOrgRegistrySummary rows = 1;
   */ _define_property(this, "rows", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGovernmentOrgRegistrySummariesResponse, "runtime", proto3);
_define_property(ListGovernmentOrgRegistrySummariesResponse, "typeName", "mono.datagateway.v1.ListGovernmentOrgRegistrySummariesResponse");
_define_property(ListGovernmentOrgRegistrySummariesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: GovernmentOrgRegistrySummary,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListVehicleRegistrySummariesRequest
 */ export class ListVehicleRegistrySummariesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListVehicleRegistrySummariesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVehicleRegistrySummariesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVehicleRegistrySummariesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVehicleRegistrySummariesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * ≤ 200
   *
   * @generated from field: repeated string ids = 7;
   */ _define_property(this, "ids", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVehicleRegistrySummariesRequest, "runtime", proto3);
_define_property(ListVehicleRegistrySummariesRequest, "typeName", "mono.datagateway.v1.ListVehicleRegistrySummariesRequest");
_define_property(ListVehicleRegistrySummariesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 7,
            name: "ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.VehicleOurStatus
 */ export class VehicleOurStatus extends Message {
    static fromBinary(bytes, options) {
        return new VehicleOurStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VehicleOurStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VehicleOurStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VehicleOurStatus, a, b);
    }
    constructor(data){
        super(), /**
   * HOLDER | THROUGH | NOT_ON_IT
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * THROUGH only
   *
   * @generated from field: mono.datagateway.v1.RegistryRef via_company = 2;
   */ _define_property(this, "viaCompany", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(VehicleOurStatus, "runtime", proto3);
_define_property(VehicleOurStatus, "typeName", "mono.datagateway.v1.VehicleOurStatus");
_define_property(VehicleOurStatus, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "via_company",
            kind: "message",
            T: RegistryRef
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PricingGenerationChip
 */ export class PricingGenerationChip extends Message {
    static fromBinary(bytes, options) {
        return new PricingGenerationChip().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingGenerationChip().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingGenerationChip().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingGenerationChip, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string generation_id = 1;
   */ _define_property(this, "generationId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: int32 generation = 3;
   */ _define_property(this, "generation", 0), /**
   * COMPANY | GOVERNMENT
   *
   * @generated from field: string issuer_kind = 4;
   */ _define_property(this, "issuerKind", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef issuer_company = 5;
   */ _define_property(this, "issuerCompany", void 0), /**
   * @generated from field: int32 companies_with_ceilings = 6;
   */ _define_property(this, "companiesWithCeilings", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingGenerationChip, "runtime", proto3);
_define_property(PricingGenerationChip, "typeName", "mono.datagateway.v1.PricingGenerationChip");
_define_property(PricingGenerationChip, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "generation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "generation",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "issuer_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "issuer_company",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 6,
            name: "companies_with_ceilings",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.VehicleRegistrySummary
 */ export class VehicleRegistrySummary extends Message {
    static fromBinary(bytes, options) {
        return new VehicleRegistrySummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VehicleRegistrySummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VehicleRegistrySummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VehicleRegistrySummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string vehicle_id = 1;
   */ _define_property(this, "vehicleId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string full_name = 3;
   */ _define_property(this, "fullName", ""), /**
   * @generated from field: string vehicle_type = 4;
   */ _define_property(this, "vehicleType", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef awarding_org = 5;
   */ _define_property(this, "awardingOrg", void 0), /**
   * @generated from field: string ordering_eligibility = 6;
   */ _define_property(this, "orderingEligibility", ""), /**
   * @generated from field: mono.datagateway.v1.VehicleOurStatus our_status = 7;
   */ _define_property(this, "ourStatus", void 0), /**
   * @generated from field: int32 holder_count = 8;
   */ _define_property(this, "holderCount", 0), /**
   * @generated from field: mono.datagateway.v1.PricingGenerationChip latest_generation = 9;
   */ _define_property(this, "latestGeneration", void 0), /**
   * @generated from field: google.protobuf.Timestamp ordering_start = 10;
   */ _define_property(this, "orderingStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp ordering_end = 11;
   */ _define_property(this, "orderingEnd", void 0), /**
   * @generated from field: string status = 12;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(VehicleRegistrySummary, "runtime", proto3);
_define_property(VehicleRegistrySummary, "typeName", "mono.datagateway.v1.VehicleRegistrySummary");
_define_property(VehicleRegistrySummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "full_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "vehicle_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "awarding_org",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 6,
            name: "ordering_eligibility",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "our_status",
            kind: "message",
            T: VehicleOurStatus
        },
        {
            no: 8,
            name: "holder_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "latest_generation",
            kind: "message",
            T: PricingGenerationChip
        },
        {
            no: 10,
            name: "ordering_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "ordering_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListVehicleRegistrySummariesResponse
 */ export class ListVehicleRegistrySummariesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListVehicleRegistrySummariesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVehicleRegistrySummariesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVehicleRegistrySummariesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVehicleRegistrySummariesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.VehicleRegistrySummary rows = 1;
   */ _define_property(this, "rows", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVehicleRegistrySummariesResponse, "runtime", proto3);
_define_property(ListVehicleRegistrySummariesResponse, "typeName", "mono.datagateway.v1.ListVehicleRegistrySummariesResponse");
_define_property(ListVehicleRegistrySummariesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: VehicleRegistrySummary,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRegistryContractSummariesRequest
 */ export class ListRegistryContractSummariesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRegistryContractSummariesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRegistryContractSummariesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRegistryContractSummariesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRegistryContractSummariesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * ≤ 200
   *
   * @generated from field: repeated string ids = 7;
   */ _define_property(this, "ids", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRegistryContractSummariesRequest, "runtime", proto3);
_define_property(ListRegistryContractSummariesRequest, "typeName", "mono.datagateway.v1.ListRegistryContractSummariesRequest");
_define_property(ListRegistryContractSummariesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 7,
            name: "ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegistryContractValue
 */ export class RegistryContractValue extends Message {
    static fromBinary(bytes, options) {
        return new RegistryContractValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryContractValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryContractValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryContractValue, a, b);
    }
    constructor(data){
        super(), /**
   * (value_json #>> '{}')::numeric of the resolved fact (bare JSON decimal)
   *
   * @generated from field: double amount = 1;
   */ _define_property(this, "amount", 0), /**
   * "obligations" (fact key measure=obligations, scope=prime, period=FY of award start, unit=USD — registrycontract constants shared with DAT-01); FE label "Obligations to date", never "rate", never "obligated"
   *
   * @generated from field: string measure = 2;
   */ _define_property(this, "measure", ""), /**
   * sam_awards | usaspending | held_document | reviewed_program
   *
   * @generated from field: string source = 3;
   */ _define_property(this, "source", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryContractValue, "runtime", proto3);
_define_property(RegistryContractValue, "typeName", "mono.datagateway.v1.RegistryContractValue");
_define_property(RegistryContractValue, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "measure",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegistryContractNextRound
 */ export class RegistryContractNextRound extends Message {
    static fromBinary(bytes, options) {
        return new RegistryContractNextRound().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryContractNextRound().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryContractNextRound().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryContractNextRound, a, b);
    }
    constructor(data){
        super(), /**
   * set when a visible pursuit exists (program_opportunity_links.contract_id → opportunity → capture_projects.opportunity_id)
   *
   * @generated from field: mono.datagateway.v1.RegistryRef pursuit = 1;
   */ _define_property(this, "pursuit", void 0), /**
   * @generated from field: string pursuit_stage = 2;
   */ _define_property(this, "pursuitStage", ""), /**
   * @generated from field: google.protobuf.Timestamp expected_open_at = 3;
   */ _define_property(this, "expectedOpenAt", void 0), /**
   * "pursuit" | "recompete horizon"
   *
   * @generated from field: string basis = 4;
   */ _define_property(this, "basis", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryContractNextRound, "runtime", proto3);
_define_property(RegistryContractNextRound, "typeName", "mono.datagateway.v1.RegistryContractNextRound");
_define_property(RegistryContractNextRound, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pursuit",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 2,
            name: "pursuit_stage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "expected_open_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegistryContractSummary
 */ export class RegistryContractSummary extends Message {
    static fromBinary(bytes, options) {
        return new RegistryContractSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryContractSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryContractSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryContractSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contract_id = 1;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string piid = 2;
   */ _define_property(this, "piid", ""), /**
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef holder = 4;
   */ _define_property(this, "holder", void 0), /**
   * PRIME | SUB | NONE
   *
   * @generated from field: string our_role = 5;
   */ _define_property(this, "ourRole", ""), /**
   * live staffing lines on the linked VISIBLE program
   *
   * @generated from field: int32 our_visible_seat_count = 6;
   */ _define_property(this, "ourVisibleSeatCount", 0), /**
   * @generated from field: mono.datagateway.v1.RegistryRef customer = 7;
   */ _define_property(this, "customer", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryRef vehicle = 8;
   */ _define_property(this, "vehicle", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryContractValue value = 9;
   */ _define_property(this, "value", void 0), /**
   * @generated from field: google.protobuf.Timestamp pop_end = 10;
   */ _define_property(this, "popEnd", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryContractNextRound next_round = 11;
   */ _define_property(this, "nextRound", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryContractSummary, "runtime", proto3);
_define_property(RegistryContractSummary, "typeName", "mono.datagateway.v1.RegistryContractSummary");
_define_property(RegistryContractSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "piid",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "holder",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 5,
            name: "our_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "our_visible_seat_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "customer",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 8,
            name: "vehicle",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 9,
            name: "value",
            kind: "message",
            T: RegistryContractValue
        },
        {
            no: 10,
            name: "pop_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "next_round",
            kind: "message",
            T: RegistryContractNextRound
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRegistryContractSummariesResponse
 */ export class ListRegistryContractSummariesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRegistryContractSummariesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRegistryContractSummariesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRegistryContractSummariesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRegistryContractSummariesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RegistryContractSummary rows = 1;
   */ _define_property(this, "rows", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRegistryContractSummariesResponse, "runtime", proto3);
_define_property(ListRegistryContractSummariesResponse, "typeName", "mono.datagateway.v1.ListRegistryContractSummariesResponse");
_define_property(ListRegistryContractSummariesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: RegistryContractSummary,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCapabilityRegistrySummariesRequest
 */ export class ListCapabilityRegistrySummariesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCapabilityRegistrySummariesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapabilityRegistrySummariesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapabilityRegistrySummariesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapabilityRegistrySummariesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * ≤ 200
   *
   * @generated from field: repeated string ids = 5;
   */ _define_property(this, "ids", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapabilityRegistrySummariesRequest, "runtime", proto3);
_define_property(ListCapabilityRegistrySummariesRequest, "typeName", "mono.datagateway.v1.ListCapabilityRegistrySummariesRequest");
_define_property(ListCapabilityRegistrySummariesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 5,
            name: "ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CapabilityRegistrySummary
 */ export class CapabilityRegistrySummary extends Message {
    static fromBinary(bytes, options) {
        return new CapabilityRegistrySummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapabilityRegistrySummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapabilityRegistrySummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapabilityRegistrySummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capability_id = 1;
   */ _define_property(this, "capabilityId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string category = 3;
   */ _define_property(this, "category", ""), /**
   * @generated from field: string status = 4;
   */ _define_property(this, "status", ""), /**
   * artifacts linked with entity_type='capability', max 3 — v2.1: visible delivery.capability_proofs rows (REG-47)
   *
   * @generated from field: repeated mono.datagateway.v1.RegistryRef proof = 5;
   */ _define_property(this, "proof", []), /**
   * @generated from field: int32 proof_count = 6;
   */ _define_property(this, "proofCount", 0), /**
   * via program_capabilities, VISIBLE only, max 3
   *
   * @generated from field: repeated mono.datagateway.v1.RegistryRef visible_programs = 7;
   */ _define_property(this, "visiblePrograms", []), /**
   * @generated from field: int32 visible_program_count = 8;
   */ _define_property(this, "visibleProgramCount", 0), /**
   * v2.1 (REG-47): "" | NO_PROOF_AS_PRIME (over visible proofs only)
   *
   * @generated from field: string gap = 9;
   */ _define_property(this, "gap", ""), /**
   * v2.1 (REG-46), visible only, max 3
   *
   * @generated from field: repeated mono.datagateway.v1.CapabilityAskedForIn asked_for_in = 10;
   */ _define_property(this, "askedForIn", []), /**
   * @generated from field: int32 asked_for_in_count = 11;
   */ _define_property(this, "askedForInCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapabilityRegistrySummary, "runtime", proto3);
_define_property(CapabilityRegistrySummary, "typeName", "mono.datagateway.v1.CapabilityRegistrySummary");
_define_property(CapabilityRegistrySummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "proof",
            kind: "message",
            T: RegistryRef,
            repeated: true
        },
        {
            no: 6,
            name: "proof_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "visible_programs",
            kind: "message",
            T: RegistryRef,
            repeated: true
        },
        {
            no: 8,
            name: "visible_program_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "gap",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "asked_for_in",
            kind: "message",
            T: CapabilityAskedForIn,
            repeated: true
        },
        {
            no: 11,
            name: "asked_for_in_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * Defined here so CapabilityRegistrySummary compiles; REG-46 owns the links
 * and its RPCs (50-registries.md REG-46).
 *
 * @generated from message mono.datagateway.v1.CapabilityAskedForIn
 */ export class CapabilityAskedForIn extends Message {
    static fromBinary(bytes, options) {
        return new CapabilityAskedForIn().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapabilityAskedForIn().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapabilityAskedForIn().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapabilityAskedForIn, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string link_id = 1;
   */ _define_property(this, "linkId", ""), /**
   * @generated from field: string target_kind = 2;
   */ _define_property(this, "targetKind", ""), /**
   * "RFI #2 Q2" | "Section C.3.1"
   *
   * @generated from field: string label = 3;
   */ _define_property(this, "label", ""), /**
   * RFI project title | proposal name
   *
   * @generated from field: string context_name = 4;
   */ _define_property(this, "contextName", ""), /**
   * RFI_RESPONSE or PROPOSAL (href built by registryHref)
   *
   * @generated from field: mono.datagateway.v1.RegistryRef context = 5;
   */ _define_property(this, "context", void 0), /**
   * first 160 chars of interpretation/original_text or requirement text
   *
   * @generated from field: string excerpt = 6;
   */ _define_property(this, "excerpt", ""), /**
   * @generated from field: google.protobuf.Timestamp linked_at = 7;
   */ _define_property(this, "linkedAt", void 0), /**
   * @generated from field: string linked_by_name = 8;
   */ _define_property(this, "linkedByName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapabilityAskedForIn, "runtime", proto3);
_define_property(CapabilityAskedForIn, "typeName", "mono.datagateway.v1.CapabilityAskedForIn");
_define_property(CapabilityAskedForIn, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "context_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "context",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 6,
            name: "excerpt",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "linked_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "linked_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCapabilityRegistrySummariesResponse
 */ export class ListCapabilityRegistrySummariesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCapabilityRegistrySummariesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapabilityRegistrySummariesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapabilityRegistrySummariesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapabilityRegistrySummariesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CapabilityRegistrySummary rows = 1;
   */ _define_property(this, "rows", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapabilityRegistrySummariesResponse, "runtime", proto3);
_define_property(ListCapabilityRegistrySummariesResponse, "typeName", "mono.datagateway.v1.ListCapabilityRegistrySummariesResponse");
_define_property(ListCapabilityRegistrySummariesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: CapabilityRegistrySummary,
            repeated: true
        }
    ]));
/**
 * ======================= Person =======================
 *
 * @generated from message mono.datagateway.v1.GetContactDossierRequest
 */ export class GetContactDossierRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetContactDossierRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetContactDossierRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetContactDossierRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetContactDossierRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contact_id = 1;
   */ _define_property(this, "contactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetContactDossierRequest, "runtime", proto3);
_define_property(GetContactDossierRequest, "typeName", "mono.datagateway.v1.GetContactDossierRequest");
_define_property(GetContactDossierRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContactWhoKnows
 */ export class ContactWhoKnows extends Message {
    static fromBinary(bytes, options) {
        return new ContactWhoKnows().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContactWhoKnows().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContactWhoKnows().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContactWhoKnows, a, b);
    }
    constructor(data){
        super(), /**
   * or empty when only a user
   *
   * @generated from field: string internal_contact_id = 1;
   */ _define_property(this, "internalContactId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * visible touchpoints together
   *
   * @generated from field: int32 meeting_count = 4;
   */ _define_property(this, "meetingCount", 0), /**
   * @generated from field: google.protobuf.Timestamp last_met_at = 5;
   */ _define_property(this, "lastMetAt", void 0), /**
   * "program reviews"
   *
   * @generated from field: string context_hint = 6;
   */ _define_property(this, "contextHint", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContactWhoKnows, "runtime", proto3);
_define_property(ContactWhoKnows, "typeName", "mono.datagateway.v1.ContactWhoKnows");
_define_property(ContactWhoKnows, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "internal_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "meeting_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "last_met_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "context_hint",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContactInterest
 */ export class ContactInterest extends Message {
    static fromBinary(bytes, options) {
        return new ContactInterest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContactInterest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContactInterest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContactInterest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string statement = 1;
   */ _define_property(this, "statement", ""), /**
   * INFERRED_NEED | ASSESSMENT | HOT_BUTTON
   *
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: mono.datagateway.v1.RegistrySourceLabel source = 3;
   */ _define_property(this, "source", void 0), /**
   * @generated from field: google.protobuf.Timestamp at = 4;
   */ _define_property(this, "at", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContactInterest, "runtime", proto3);
_define_property(ContactInterest, "typeName", "mono.datagateway.v1.ContactInterest");
_define_property(ContactInterest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "statement",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source",
            kind: "message",
            T: RegistrySourceLabel
        },
        {
            no: 4,
            name: "at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetContactDossierResponse
 */ export class GetContactDossierResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetContactDossierResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetContactDossierResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetContactDossierResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetContactDossierResponse, a, b);
    }
    constructor(data){
        super(), /**
   * resolved through merged_into_id (survivor id)
   *
   * @generated from field: string contact_id = 1;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: bool has_platform_account = 3;
   */ _define_property(this, "hasPlatformAccount", false), /**
   * @generated from field: bool is_active = 4;
   */ _define_property(this, "isActive", false), /**
   * @generated from field: bool is_placeholder = 5;
   */ _define_property(this, "isPlaceholder", false), /**
   * @generated from field: repeated mono.datagateway.v1.EmploymentSpan current = 6;
   */ _define_property(this, "current", []), /**
   * @generated from field: repeated mono.datagateway.v1.RegistryAppearanceCard appearances = 7;
   */ _define_property(this, "appearances", []), /**
   * newest first, every employment
   *
   * @generated from field: repeated mono.datagateway.v1.EmploymentSpan career = 8;
   */ _define_property(this, "career", []), /**
   * @generated from field: repeated mono.datagateway.v1.ContactWhoKnows who_knows = 9;
   */ _define_property(this, "whoKnows", []), /**
   * @generated from field: repeated mono.datagateway.v1.ContactInterest interests = 10;
   */ _define_property(this, "interests", []), /**
   * @generated from field: int32 visible_touchpoint_count = 11;
   */ _define_property(this, "visibleTouchpointCount", 0), /**
   * FE shows "Merged into …" banner
   *
   * @generated from field: bool requested_id_was_merged = 12;
   */ _define_property(this, "requestedIdWasMerged", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetContactDossierResponse, "runtime", proto3);
_define_property(GetContactDossierResponse, "typeName", "mono.datagateway.v1.GetContactDossierResponse");
_define_property(GetContactDossierResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "has_platform_account",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "is_active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "is_placeholder",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "current",
            kind: "message",
            T: EmploymentSpan,
            repeated: true
        },
        {
            no: 7,
            name: "appearances",
            kind: "message",
            T: RegistryAppearanceCard,
            repeated: true
        },
        {
            no: 8,
            name: "career",
            kind: "message",
            T: EmploymentSpan,
            repeated: true
        },
        {
            no: 9,
            name: "who_knows",
            kind: "message",
            T: ContactWhoKnows,
            repeated: true
        },
        {
            no: 10,
            name: "interests",
            kind: "message",
            T: ContactInterest,
            repeated: true
        },
        {
            no: 11,
            name: "visible_touchpoint_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "requested_id_was_merged",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContactTouchpointsUnifiedRequest
 */ export class ListContactTouchpointsUnifiedRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListContactTouchpointsUnifiedRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactTouchpointsUnifiedRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactTouchpointsUnifiedRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactTouchpointsUnifiedRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contact_id = 1;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string after_id = 2;
   */ _define_property(this, "afterId", ""), /**
   * default 20
   *
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactTouchpointsUnifiedRequest, "runtime", proto3);
_define_property(ListContactTouchpointsUnifiedRequest, "typeName", "mono.datagateway.v1.ListContactTouchpointsUnifiedRequest");
_define_property(ListContactTouchpointsUnifiedRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "after_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnifiedTouchpoint
 */ export class UnifiedTouchpoint extends Message {
    static fromBinary(bytes, options) {
        return new UnifiedTouchpoint().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnifiedTouchpoint().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnifiedTouchpoint().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnifiedTouchpoint, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * GROWTH | DELIVERY
   *
   * @generated from field: string plane = 2;
   */ _define_property(this, "plane", ""), /**
   * growth: interaction_date; delivery: date_of_briefing
   *
   * @generated from field: google.protobuf.Timestamp at = 3;
   */ _define_property(this, "at", void 0), /**
   * growth: title (only with view_sensitive); delivery: coalesce(brief_description, left(summary_and_action_items,200)); "" when masked
   *
   * @generated from field: string summary = 4;
   */ _define_property(this, "summary", ""), /**
   * PURSUIT or PROGRAM
   *
   * @generated from field: mono.datagateway.v1.RegistryRef context = 6;
   */ _define_property(this, "context", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryRef affiliation_at_time = 7;
   */ _define_property(this, "affiliationAtTime", void 0), /**
   * growth row on a pursuit without capture view_sensitive: date + context only
   *
   * @generated from field: bool masked = 8;
   */ _define_property(this, "masked", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnifiedTouchpoint, "runtime", proto3);
_define_property(UnifiedTouchpoint, "typeName", "mono.datagateway.v1.UnifiedTouchpoint");
_define_property(UnifiedTouchpoint, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "plane",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "context",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 7,
            name: "affiliation_at_time",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 8,
            name: "masked",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContactTouchpointsUnifiedResponse
 */ export class ListContactTouchpointsUnifiedResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListContactTouchpointsUnifiedResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactTouchpointsUnifiedResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactTouchpointsUnifiedResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactTouchpointsUnifiedResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.UnifiedTouchpoint touchpoints = 1;
   */ _define_property(this, "touchpoints", []), /**
   * @generated from field: int32 visible_total = 2;
   */ _define_property(this, "visibleTotal", 0), /**
   * @generated from field: string next_after_id = 3;
   */ _define_property(this, "nextAfterId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactTouchpointsUnifiedResponse, "runtime", proto3);
_define_property(ListContactTouchpointsUnifiedResponse, "typeName", "mono.datagateway.v1.ListContactTouchpointsUnifiedResponse");
_define_property(ListContactTouchpointsUnifiedResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "touchpoints",
            kind: "message",
            T: UnifiedTouchpoint,
            repeated: true
        },
        {
            no: 2,
            name: "visible_total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "next_after_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListEntityDocumentsRequest
 */ export class ListEntityDocumentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListEntityDocumentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEntityDocumentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEntityDocumentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEntityDocumentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * CONTACT (program_documents.contact_id + REG-49 links) | COMPANY (artifact_entity_links entity_type='company_profile' + its pricing sheets) | VEHICLE (pricing sheets in the family + REG-49 links) | GOVERNMENT_ORG | LCAT_ANCHOR (REG-49 links)
   *
   * @generated from field: string entity_kind = 1;
   */ _define_property(this, "entityKind", ""), /**
   * @generated from field: string entity_id = 2;
   */ _define_property(this, "entityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListEntityDocumentsRequest, "runtime", proto3);
_define_property(ListEntityDocumentsRequest, "typeName", "mono.datagateway.v1.ListEntityDocumentsRequest");
_define_property(ListEntityDocumentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entity_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "entity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.EntityDocument
 */ export class EntityDocument extends Message {
    static fromBinary(bytes, options) {
        return new EntityDocument().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EntityDocument().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EntityDocument().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EntityDocument, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * artifacts.artifacts.filename (there is no title column)
   *
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * LIBRARY | PROGRAM | PRICING_SHEET
   *
   * @generated from field: string home = 3;
   */ _define_property(this, "home", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef home_ref = 4;
   */ _define_property(this, "homeRef", void 0), /**
   * @generated from field: google.protobuf.Timestamp linked_at = 5;
   */ _define_property(this, "linkedAt", void 0), /**
   * v2.1 (OD-93): REG-49 link the viewer may remove
   *
   * @generated from field: bool unlinkable = 6;
   */ _define_property(this, "unlinkable", false), /**
   * v2.1 (OD-93): REG-49 linker (latest registry.document_link.create audit event)
   *
   * @generated from field: string linked_by_name = 7;
   */ _define_property(this, "linkedByName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EntityDocument, "runtime", proto3);
_define_property(EntityDocument, "typeName", "mono.datagateway.v1.EntityDocument");
_define_property(EntityDocument, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "home",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "home_ref",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 5,
            name: "linked_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "unlinkable",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "linked_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListEntityDocumentsResponse
 */ export class ListEntityDocumentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListEntityDocumentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEntityDocumentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEntityDocumentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEntityDocumentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.EntityDocument documents = 1;
   */ _define_property(this, "documents", []), /**
   * deprecated: always false since REG-49 (every kind has a link writer)
   *
   * @generated from field: bool links_not_recorded = 2;
   */ _define_property(this, "linksNotRecorded", false), /**
   * v2.1 (OD-93): REG-49 write gate for this record
   *
   * @generated from field: bool can_link = 3;
   */ _define_property(this, "canLink", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListEntityDocumentsResponse, "runtime", proto3);
_define_property(ListEntityDocumentsResponse, "typeName", "mono.datagateway.v1.ListEntityDocumentsResponse");
_define_property(ListEntityDocumentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "documents",
            kind: "message",
            T: EntityDocument,
            repeated: true
        },
        {
            no: 2,
            name: "links_not_recorded",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "can_link",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * REG-49: record document links. Kinds: CONTACT | COMPANY | VEHICLE | GOVERNMENT_ORG | LCAT_ANCHOR.
 *
 * @generated from message mono.datagateway.v1.LinkRecordDocumentRequest
 */ export class LinkRecordDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkRecordDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkRecordDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkRecordDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkRecordDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string entity_kind = 1;
   */ _define_property(this, "entityKind", ""), /**
   * @generated from field: string entity_id = 2;
   */ _define_property(this, "entityId", ""), /**
   * @generated from field: string artifact_id = 3;
   */ _define_property(this, "artifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkRecordDocumentRequest, "runtime", proto3);
_define_property(LinkRecordDocumentRequest, "typeName", "mono.datagateway.v1.LinkRecordDocumentRequest");
_define_property(LinkRecordDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entity_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "entity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkRecordDocumentResponse
 */ export class LinkRecordDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkRecordDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkRecordDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkRecordDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkRecordDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.EntityDocument document = 1;
   */ _define_property(this, "document", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkRecordDocumentResponse, "runtime", proto3);
_define_property(LinkRecordDocumentResponse, "typeName", "mono.datagateway.v1.LinkRecordDocumentResponse");
_define_property(LinkRecordDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: EntityDocument
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnlinkRecordDocumentRequest
 */ export class UnlinkRecordDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkRecordDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkRecordDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkRecordDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkRecordDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string entity_kind = 1;
   */ _define_property(this, "entityKind", ""), /**
   * @generated from field: string entity_id = 2;
   */ _define_property(this, "entityId", ""), /**
   * @generated from field: string artifact_id = 3;
   */ _define_property(this, "artifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkRecordDocumentRequest, "runtime", proto3);
_define_property(UnlinkRecordDocumentRequest, "typeName", "mono.datagateway.v1.UnlinkRecordDocumentRequest");
_define_property(UnlinkRecordDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entity_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "entity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnlinkRecordDocumentResponse
 */ export class UnlinkRecordDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkRecordDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkRecordDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkRecordDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkRecordDocumentResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkRecordDocumentResponse, "runtime", proto3);
_define_property(UnlinkRecordDocumentResponse, "typeName", "mono.datagateway.v1.UnlinkRecordDocumentResponse");
_define_property(UnlinkRecordDocumentResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.SearchLinkableDocumentsRequest
 */ export class SearchLinkableDocumentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new SearchLinkableDocumentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchLinkableDocumentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchLinkableDocumentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchLinkableDocumentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string query = 1;
   */ _define_property(this, "query", ""), /**
   * default 20, max 50 
   *
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchLinkableDocumentsRequest, "runtime", proto3);
_define_property(SearchLinkableDocumentsRequest, "typeName", "mono.datagateway.v1.SearchLinkableDocumentsRequest");
_define_property(SearchLinkableDocumentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkableDocument
 */ export class LinkableDocument extends Message {
    static fromBinary(bytes, options) {
        return new LinkableDocument().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkableDocument().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkableDocument().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkableDocument, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * LIBRARY | PROGRAM | PURSUIT | PROPOSAL | RFI
   *
   * @generated from field: string home = 3;
   */ _define_property(this, "home", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef home_ref = 4;
   */ _define_property(this, "homeRef", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkableDocument, "runtime", proto3);
_define_property(LinkableDocument, "typeName", "mono.datagateway.v1.LinkableDocument");
_define_property(LinkableDocument, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "home",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "home_ref",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 5,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SearchLinkableDocumentsResponse
 */ export class SearchLinkableDocumentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new SearchLinkableDocumentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchLinkableDocumentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchLinkableDocumentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchLinkableDocumentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.LinkableDocument documents = 1;
   */ _define_property(this, "documents", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchLinkableDocumentsResponse, "runtime", proto3);
_define_property(SearchLinkableDocumentsResponse, "typeName", "mono.datagateway.v1.SearchLinkableDocumentsResponse");
_define_property(SearchLinkableDocumentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "documents",
            kind: "message",
            T: LinkableDocument,
            repeated: true
        }
    ]));
/**
 * ======================= Company =======================
 *
 * @generated from message mono.datagateway.v1.GetCompanyDossierRequest
 */ export class GetCompanyDossierRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCompanyDossierRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCompanyDossierRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCompanyDossierRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCompanyDossierRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCompanyDossierRequest, "runtime", proto3);
_define_property(GetCompanyDossierRequest, "typeName", "mono.datagateway.v1.GetCompanyDossierRequest");
_define_property(GetCompanyDossierRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CompanyPricingSheetRow
 */ export class CompanyPricingSheetRow extends Message {
    static fromBinary(bytes, options) {
        return new CompanyPricingSheetRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyPricingSheetRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyPricingSheetRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyPricingSheetRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string generation_id = 1;
   */ _define_property(this, "generationId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef vehicle = 3;
   */ _define_property(this, "vehicle", void 0), /**
   * @generated from field: string issuer_kind = 4;
   */ _define_property(this, "issuerKind", ""), /**
   * @generated from field: int32 generation = 5;
   */ _define_property(this, "generation", 0), /**
   * generation title, else the artifact filename (titles are empty today)
   *
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * @generated from field: google.protobuf.Timestamp uploaded_at = 7;
   */ _define_property(this, "uploadedAt", void 0), /**
   * COMMITTED (Applied, not superseded) | HISTORY (superseded) | IN_REVIEW (Staged / In review) | REJECTED | CANCELLED — change-set states mapped explicitly, never defaulted
   *
   * @generated from field: string status = 8;
   */ _define_property(this, "status", ""), /**
   * observations across the generation lineage (re-uploads dedupe by fingerprint, so a committed generation can own 0 rows)
   *
   * @generated from field: int32 row_count_for_company = 9;
   */ _define_property(this, "rowCountForCompany", 0), /**
   * @generated from field: int32 pending_period_decisions = 10;
   */ _define_property(this, "pendingPeriodDecisions", 0), /**
   * REG-42
   *
   * @generated from field: int32 pending_burden_decisions = 11;
   */ _define_property(this, "pendingBurdenDecisions", 0), /**
   * e.g. "rows carried from generation 1" when this generation owns no rows
   *
   * @generated from field: string row_count_note = 12;
   */ _define_property(this, "rowCountNote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyPricingSheetRow, "runtime", proto3);
_define_property(CompanyPricingSheetRow, "typeName", "mono.datagateway.v1.CompanyPricingSheetRow");
_define_property(CompanyPricingSheetRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "generation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "vehicle",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 4,
            name: "issuer_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "generation",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "uploaded_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "row_count_for_company",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "pending_period_decisions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 11,
            name: "pending_burden_decisions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "row_count_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CompanyLineageRow
 */ export class CompanyLineageRow extends Message {
    static fromBinary(bytes, options) {
        return new CompanyLineageRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyLineageRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyLineageRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyLineageRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string relationship_id = 1;
   */ _define_property(this, "relationshipId", ""), /**
   * @generated from field: string relationship_type = 2;
   */ _define_property(this, "relationshipType", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef other = 3;
   */ _define_property(this, "other", void 0), /**
   * FROM_US | TO_US (relative to this company)
   *
   * @generated from field: string direction = 4;
   */ _define_property(this, "direction", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_start = 5;
   */ _define_property(this, "effectiveStart", void 0), /**
   * ended relationships remain as history
   *
   * @generated from field: google.protobuf.Timestamp effective_end = 6;
   */ _define_property(this, "effectiveEnd", void 0), /**
   * @generated from field: string source = 7;
   */ _define_property(this, "source", ""), /**
   * @generated from field: google.protobuf.Timestamp observed_as_of = 8;
   */ _define_property(this, "observedAsOf", void 0), /**
   * @generated from field: string end_basis = 9;
   */ _define_property(this, "endBasis", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyLineageRow, "runtime", proto3);
_define_property(CompanyLineageRow, "typeName", "mono.datagateway.v1.CompanyLineageRow");
_define_property(CompanyLineageRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "relationship_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "relationship_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "other",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 4,
            name: "direction",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "effective_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "effective_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "observed_as_of",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "end_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CompanyAwardRow
 */ export class CompanyAwardRow extends Message {
    static fromBinary(bytes, options) {
        return new CompanyAwardRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyAwardRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyAwardRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyAwardRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryRef contract = 1;
   */ _define_property(this, "contract", void 0), /**
   * "VA.gov sustainment"
   *
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryContractValue value = 3;
   */ _define_property(this, "value", void 0), /**
   * @generated from field: int32 year = 4;
   */ _define_property(this, "year", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyAwardRow, "runtime", proto3);
_define_property(CompanyAwardRow, "typeName", "mono.datagateway.v1.CompanyAwardRow");
_define_property(CompanyAwardRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "value",
            kind: "message",
            T: RegistryContractValue
        },
        {
            no: 4,
            name: "year",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCompanyDossierResponse
 */ export class GetCompanyDossierResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCompanyDossierResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCompanyDossierResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCompanyDossierResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCompanyDossierResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: bool is_own_company = 3;
   */ _define_property(this, "isOwnCompany", false), /**
   * @generated from field: string business_size = 4;
   */ _define_property(this, "businessSize", ""), /**
   * @generated from field: repeated mono.datagateway.v1.VehicleHoldingChip vehicle_holdings = 5;
   */ _define_property(this, "vehicleHoldings", []), /**
   * @generated from field: mono.datagateway.v1.CompanyLineageStatus lineage_status = 6;
   */ _define_property(this, "lineageStatus", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.CompanyRelationshipToUs relationships = 7;
   */ _define_property(this, "relationships", []), /**
   * @generated from field: repeated mono.datagateway.v1.RegistryAppearanceCard appearances = 8;
   */ _define_property(this, "appearances", []), /**
   * @generated from field: repeated mono.datagateway.v1.CompanyPricingSheetRow pricing_sheets = 9;
   */ _define_property(this, "pricingSheets", []), /**
   * @generated from field: repeated mono.datagateway.v1.CompanyLineageRow lineage = 10;
   */ _define_property(this, "lineage", []), /**
   * max 5, newest first
   *
   * @generated from field: repeated mono.datagateway.v1.CompanyAwardRow awards = 11;
   */ _define_property(this, "awards", []), /**
   * @generated from field: string sam_business_size = 12;
   */ _define_property(this, "samBusinessSize", ""), /**
   * header fallback when no live holdings exist
   *
   * @generated from field: repeated mono.datagateway.v1.RegistryRef price_list_vehicles = 13;
   */ _define_property(this, "priceListVehicles", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCompanyDossierResponse, "runtime", proto3);
_define_property(GetCompanyDossierResponse, "typeName", "mono.datagateway.v1.GetCompanyDossierResponse");
_define_property(GetCompanyDossierResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "is_own_company",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "business_size",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "vehicle_holdings",
            kind: "message",
            T: VehicleHoldingChip,
            repeated: true
        },
        {
            no: 6,
            name: "lineage_status",
            kind: "message",
            T: CompanyLineageStatus
        },
        {
            no: 7,
            name: "relationships",
            kind: "message",
            T: CompanyRelationshipToUs,
            repeated: true
        },
        {
            no: 8,
            name: "appearances",
            kind: "message",
            T: RegistryAppearanceCard,
            repeated: true
        },
        {
            no: 9,
            name: "pricing_sheets",
            kind: "message",
            T: CompanyPricingSheetRow,
            repeated: true
        },
        {
            no: 10,
            name: "lineage",
            kind: "message",
            T: CompanyLineageRow,
            repeated: true
        },
        {
            no: 11,
            name: "awards",
            kind: "message",
            T: CompanyAwardRow,
            repeated: true
        },
        {
            no: 12,
            name: "sam_business_size",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "price_list_vehicles",
            kind: "message",
            T: RegistryRef,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCompanyRateBookRequest
 */ export class GetCompanyRateBookRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCompanyRateBookRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCompanyRateBookRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCompanyRateBookRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCompanyRateBookRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * "" = all vehicles
   *
   * @generated from field: string vehicle_id = 2;
   */ _define_property(this, "vehicleId", ""), /**
   * empty = all; FY of the period midpoint (ratebook.FiscalYearOf)
   *
   * @generated from field: repeated int32 fiscal_years = 3;
   */ _define_property(this, "fiscalYears", []), /**
   * FE always sends true; false hides rows with mapping.status NONE
   *
   * @generated from field: bool include_unmapped = 4;
   */ _define_property(this, "includeUnmapped", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCompanyRateBookRequest, "runtime", proto3);
_define_property(GetCompanyRateBookRequest, "typeName", "mono.datagateway.v1.GetCompanyRateBookRequest");
_define_property(GetCompanyRateBookRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "fiscal_years",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            repeated: true
        },
        {
            no: 4,
            name: "include_unmapped",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CompanyRateBookMapping
 */ export class CompanyRateBookMapping extends Message {
    static fromBinary(bytes, options) {
        return new CompanyRateBookMapping().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyRateBookMapping().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyRateBookMapping().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyRateBookMapping, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string anchor_id = 1;
   */ _define_property(this, "anchorId", ""), /**
   * @generated from field: string anchor_title = 2;
   */ _define_property(this, "anchorTitle", ""), /**
   * @generated from field: string soc_code = 3;
   */ _define_property(this, "socCode", ""), /**
   * EQUIVALENT | BROADER | NARROWER | ""
   *
   * @generated from field: string relation = 4;
   */ _define_property(this, "relation", ""), /**
   * APPROVED | PENDING | REVIEW_NEEDED | NONE
   *
   * @generated from field: string status = 5;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyRateBookMapping, "runtime", proto3);
_define_property(CompanyRateBookMapping, "typeName", "mono.datagateway.v1.CompanyRateBookMapping");
_define_property(CompanyRateBookMapping, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "anchor_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "soc_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CompanyRateBookGap
 */ export class CompanyRateBookGap extends Message {
    static fromBinary(bytes, options) {
        return new CompanyRateBookGap().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyRateBookGap().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyRateBookGap().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyRateBookGap, a, b);
    }
    constructor(data){
        super(), /**
   * PERCENT | CEILING_ONLY | INFERRED_ONLY | NOT_COMPARABLE | NONE
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * (real − ceiling) / ceiling × 100, rounded 1dp; negative = under ceiling
   *
   * @generated from field: double percent = 2;
   */ _define_property(this, "percent", 0), /**
   * AGREED_VS_CEILING | BILLED_VS_CEILING | AWARDED_VS_CEILING
   *
   * @generated from field: string basis = 3;
   */ _define_property(this, "basis", ""), /**
   * verbatim reason strings of R/rateComparability.ts, e.g. "burden basis not stated", "different unit (hourly vs daily)"
   *
   * @generated from field: repeated string not_comparable_reasons = 4;
   */ _define_property(this, "notComparableReasons", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyRateBookGap, "runtime", proto3);
_define_property(CompanyRateBookGap, "typeName", "mono.datagateway.v1.CompanyRateBookGap");
_define_property(CompanyRateBookGap, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "not_comparable_reasons",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CompanyRateBookRow
 */ export class CompanyRateBookRow extends Message {
    static fromBinary(bytes, options) {
        return new CompanyRateBookRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyRateBookRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyRateBookRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyRateBookRow, a, b);
    }
    constructor(data){
        super(), /**
   * stable: head_entry|vehicle|period|worksite|burden|unit
   *
   * @generated from field: string row_key = 1;
   */ _define_property(this, "rowKey", ""), /**
   * head of the version chain
   *
   * @generated from field: string lcat_entry_id = 2;
   */ _define_property(this, "lcatEntryId", ""), /**
   * @generated from field: int32 entry_version = 3;
   */ _define_property(this, "entryVersion", 0), /**
   * @generated from field: string title_as_written = 4;
   */ _define_property(this, "titleAsWritten", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef vehicle = 5;
   */ _define_property(this, "vehicle", void 0), /**
   * @generated from field: mono.datagateway.v1.CompanyRateBookMapping mapping = 6;
   */ _define_property(this, "mapping", void 0), /**
   * @generated from field: string normalized_period_key = 7;
   */ _define_property(this, "normalizedPeriodKey", ""), /**
   * @generated from field: repeated string period_labels = 8;
   */ _define_property(this, "periodLabels", []), /**
   * @generated from field: string worksite = 9;
   */ _define_property(this, "worksite", ""), /**
   * @generated from field: string burden_basis = 10;
   */ _define_property(this, "burdenBasis", ""), /**
   * @generated from field: string rate_unit = 11;
   */ _define_property(this, "rateUnit", ""), /**
   * @generated from field: string currency = 12;
   */ _define_property(this, "currency", ""), /**
   * @generated from field: mono.datagateway.v1.RateCell ceiling = 13;
   */ _define_property(this, "ceiling", void 0), /**
   * SUBK_AGREED
   *
   * @generated from field: mono.datagateway.v1.RateCell agreed = 14;
   */ _define_property(this, "agreed", void 0), /**
   * @generated from field: mono.datagateway.v1.RateCell billed = 15;
   */ _define_property(this, "billed", void 0), /**
   * @generated from field: mono.datagateway.v1.RateCell awarded = 16;
   */ _define_property(this, "awarded", void 0), /**
   * company-level only; always labelled "estimate"
   *
   * @generated from field: mono.datagateway.v1.RateCell inferred = 17;
   */ _define_property(this, "inferred", void 0), /**
   * @generated from field: mono.datagateway.v1.CompanyRateBookGap gap = 18;
   */ _define_property(this, "gap", void 0), /**
   * "FY25" (midpoint fiscal year) | "Year 2" (ordinal-only) | verbatim label
   *
   * @generated from field: string period_display = 19;
   */ _define_property(this, "periodDisplay", ""), /**
   * executed row whose label could not be resolved to dates: own row, never matched to a ceiling
   *
   * @generated from field: bool unresolved_period = 20;
   */ _define_property(this, "unresolvedPeriod", false), /**
   * SAME_KEY | ORDINAL | DATE_OVERLAP | "" — how executed rows joined the ceiling period
   *
   * @generated from field: string period_match_basis = 21;
   */ _define_property(this, "periodMatchBasis", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyRateBookRow, "runtime", proto3);
_define_property(CompanyRateBookRow, "typeName", "mono.datagateway.v1.CompanyRateBookRow");
_define_property(CompanyRateBookRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "row_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "lcat_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "entry_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "title_as_written",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "vehicle",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 6,
            name: "mapping",
            kind: "message",
            T: CompanyRateBookMapping
        },
        {
            no: 7,
            name: "normalized_period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "period_labels",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "worksite",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "burden_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "rate_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "ceiling",
            kind: "message",
            T: RateCell
        },
        {
            no: 14,
            name: "agreed",
            kind: "message",
            T: RateCell
        },
        {
            no: 15,
            name: "billed",
            kind: "message",
            T: RateCell
        },
        {
            no: 16,
            name: "awarded",
            kind: "message",
            T: RateCell
        },
        {
            no: 17,
            name: "inferred",
            kind: "message",
            T: RateCell
        },
        {
            no: 18,
            name: "gap",
            kind: "message",
            T: CompanyRateBookGap
        },
        {
            no: 19,
            name: "period_display",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "unresolved_period",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 21,
            name: "period_match_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCompanyRateBookResponse
 */ export class GetCompanyRateBookResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCompanyRateBookResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCompanyRateBookResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCompanyRateBookResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCompanyRateBookResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CompanyRateBookRow rows = 1;
   */ _define_property(this, "rows", []), /**
   * pills: distinct vehicles in this company's book
   *
   * @generated from field: repeated mono.datagateway.v1.RegistryRef vehicles = 2;
   */ _define_property(this, "vehicles", []), /**
   * @generated from field: string suggestion_rule_id = 3;
   */ _define_property(this, "suggestionRuleId", ""), /**
   * @generated from field: string suggestion_rule_label = 4;
   */ _define_property(this, "suggestionRuleLabel", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCompanyRateBookResponse, "runtime", proto3);
_define_property(GetCompanyRateBookResponse, "typeName", "mono.datagateway.v1.GetCompanyRateBookResponse");
_define_property(GetCompanyRateBookResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: CompanyRateBookRow,
            repeated: true
        },
        {
            no: 2,
            name: "vehicles",
            kind: "message",
            T: RegistryRef,
            repeated: true
        },
        {
            no: 3,
            name: "suggestion_rule_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "suggestion_rule_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOrganizationPeopleRequest
 */ export class ListOrganizationPeopleRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOrganizationPeopleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOrganizationPeopleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOrganizationPeopleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOrganizationPeopleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * COMPANY | GOVERNMENT_ORG
   *
   * @generated from field: string employer_kind = 1;
   */ _define_property(this, "employerKind", ""), /**
   * @generated from field: string employer_id = 2;
   */ _define_property(this, "employerId", ""), /**
   * GOVERNMENT_ORG only
   *
   * @generated from field: bool include_descendants = 3;
   */ _define_property(this, "includeDescendants", false), /**
   * @generated from field: bool include_past = 4;
   */ _define_property(this, "includePast", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOrganizationPeopleRequest, "runtime", proto3);
_define_property(ListOrganizationPeopleRequest, "typeName", "mono.datagateway.v1.ListOrganizationPeopleRequest");
_define_property(ListOrganizationPeopleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "employer_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "employer_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "include_descendants",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "include_past",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.OrganizationPerson
 */ export class OrganizationPerson extends Message {
    static fromBinary(bytes, options) {
        return new OrganizationPerson().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OrganizationPerson().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OrganizationPerson().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OrganizationPerson, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contact_id = 1;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string title_here = 3;
   */ _define_property(this, "titleHere", ""), /**
   * CURRENT | PAST
   *
   * @generated from field: string here_status = 4;
   */ _define_property(this, "hereStatus", ""), /**
   * full career, oldest first
   *
   * @generated from field: repeated mono.datagateway.v1.EmploymentSpan employments = 5;
   */ _define_property(this, "employments", []), /**
   * derived: "Moved from Blue Ridge Analytics (our teammate) in 2024"
   *
   * @generated from field: string move_note = 6;
   */ _define_property(this, "moveNote", ""), /**
   * @generated from field: int32 visible_touchpoint_count = 7;
   */ _define_property(this, "visibleTouchpointCount", 0), /**
   * @generated from field: mono.datagateway.v1.RegistrySourceLabel source = 8;
   */ _define_property(this, "source", void 0), /**
   * @generated from field: mono.datagateway.v1.RestrictedRateTrail rate_trail = 9;
   */ _define_property(this, "rateTrail", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OrganizationPerson, "runtime", proto3);
_define_property(OrganizationPerson, "typeName", "mono.datagateway.v1.OrganizationPerson");
_define_property(OrganizationPerson, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title_here",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "here_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "employments",
            kind: "message",
            T: EmploymentSpan,
            repeated: true
        },
        {
            no: 6,
            name: "move_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "visible_touchpoint_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "source",
            kind: "message",
            T: RegistrySourceLabel
        },
        {
            no: 9,
            name: "rate_trail",
            kind: "message",
            T: RestrictedRateTrail
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOrganizationPeopleResponse
 */ export class ListOrganizationPeopleResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOrganizationPeopleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOrganizationPeopleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOrganizationPeopleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOrganizationPeopleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.OrganizationPerson people = 1;
   */ _define_property(this, "people", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOrganizationPeopleResponse, "runtime", proto3);
_define_property(ListOrganizationPeopleResponse, "typeName", "mono.datagateway.v1.ListOrganizationPeopleResponse");
_define_property(ListOrganizationPeopleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "people",
            kind: "message",
            T: OrganizationPerson,
            repeated: true
        }
    ]));
/**
 * ======================= Labor category =======================
 *
 * @generated from message mono.datagateway.v1.GetLaborCategoryAnchorDossierRequest
 */ export class GetLaborCategoryAnchorDossierRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLaborCategoryAnchorDossierRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLaborCategoryAnchorDossierRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLaborCategoryAnchorDossierRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLaborCategoryAnchorDossierRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string anchor_id = 1;
   */ _define_property(this, "anchorId", ""), /**
   * default all
   *
   * @generated from field: repeated string relations = 2;
   */ _define_property(this, "relations", []), /**
   * @generated from field: bool include_pending = 3;
   */ _define_property(this, "includePending", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLaborCategoryAnchorDossierRequest, "runtime", proto3);
_define_property(GetLaborCategoryAnchorDossierRequest, "typeName", "mono.datagateway.v1.GetLaborCategoryAnchorDossierRequest");
_define_property(GetLaborCategoryAnchorDossierRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "relations",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "include_pending",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AnchorFacts
 */ export class AnchorFacts extends Message {
    static fromBinary(bytes, options) {
        return new AnchorFacts().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnchorFacts().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnchorFacts().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnchorFacts, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string anchor_id = 1;
   */ _define_property(this, "anchorId", ""), /**
   * @generated from field: string soc_code = 2;
   */ _define_property(this, "socCode", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string onet_title = 4;
   */ _define_property(this, "onetTitle", ""), /**
   * @generated from field: string family = 5;
   */ _define_property(this, "family", ""), /**
   * @generated from field: string specialty = 6;
   */ _define_property(this, "specialty", ""), /**
   * @generated from field: string seniority = 7;
   */ _define_property(this, "seniority", ""), /**
   * @generated from field: string typical_education = 8;
   */ _define_property(this, "typicalEducation", ""), /**
   * -1 = unknown
   *
   * @generated from field: int32 typical_min_experience_years = 9;
   */ _define_property(this, "typicalMinExperienceYears", 0), /**
   * @generated from field: repeated string crosswalk_sources = 10;
   */ _define_property(this, "crosswalkSources", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnchorFacts, "runtime", proto3);
_define_property(AnchorFacts, "typeName", "mono.datagateway.v1.AnchorFacts");
_define_property(AnchorFacts, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "soc_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "onet_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "family",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "specialty",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "seniority",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "typical_education",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "typical_min_experience_years",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "crosswalk_sources",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AnchorCounts
 */ export class AnchorCounts extends Message {
    static fromBinary(bytes, options) {
        return new AnchorCounts().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnchorCounts().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnchorCounts().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnchorCounts, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 entry_versions = 1;
   */ _define_property(this, "entryVersions", 0), /**
   * @generated from field: int32 companies = 2;
   */ _define_property(this, "companies", 0), /**
   * @generated from field: int32 vehicles = 3;
   */ _define_property(this, "vehicles", 0), /**
   * contact_id IS NULL AND type <> PAY only
   *
   * @generated from field: int32 rate_observations = 4;
   */ _define_property(this, "rateObservations", 0), /**
   * @generated from field: int32 visible_people_filled = 5;
   */ _define_property(this, "visiblePeopleFilled", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnchorCounts, "runtime", proto3);
_define_property(AnchorCounts, "typeName", "mono.datagateway.v1.AnchorCounts");
_define_property(AnchorCounts, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entry_versions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "companies",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "vehicles",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "rate_observations",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "visible_people_filled",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AnchorQualComparison
 */ export class AnchorQualComparison extends Message {
    static fromBinary(bytes, options) {
        return new AnchorQualComparison().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnchorQualComparison().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnchorQualComparison().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnchorQualComparison, a, b);
    }
    constructor(data){
        super(), /**
   * SAME | ABOVE | BELOW | UNKNOWN
   *
   * @generated from field: string education = 1;
   */ _define_property(this, "education", ""), /**
   * entry − anchor typical; meaningful only when has_experience
   *
   * @generated from field: int32 experience_delta_years = 2;
   */ _define_property(this, "experienceDeltaYears", 0), /**
   * @generated from field: bool has_experience = 3;
   */ _define_property(this, "hasExperience", false), /**
   * @generated from field: string clearance_text = 4;
   */ _define_property(this, "clearanceText", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnchorQualComparison, "runtime", proto3);
_define_property(AnchorQualComparison, "typeName", "mono.datagateway.v1.AnchorQualComparison");
_define_property(AnchorQualComparison, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "education",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "experience_delta_years",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "has_experience",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "clearance_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AnchorEntryRow
 */ export class AnchorEntryRow extends Message {
    static fromBinary(bytes, options) {
        return new AnchorEntryRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnchorEntryRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnchorEntryRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnchorEntryRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string entry_id = 1;
   */ _define_property(this, "entryId", ""), /**
   * @generated from field: int32 version = 2;
   */ _define_property(this, "version", 0), /**
   * @generated from field: mono.datagateway.v1.RegistryRef company = 3;
   */ _define_property(this, "company", void 0), /**
   * @generated from field: bool company_is_own = 4;
   */ _define_property(this, "companyIsOwn", false), /**
   * @generated from field: string title_as_written = 5;
   */ _define_property(this, "titleAsWritten", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef vehicle = 6;
   */ _define_property(this, "vehicle", void 0), /**
   * COMPANY_LIST | VEHICLE_CATALOG | SOLICITATION
   *
   * @generated from field: string scope_kind = 7;
   */ _define_property(this, "scopeKind", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef issuing_org = 8;
   */ _define_property(this, "issuingOrg", void 0), /**
   * @generated from field: string solicitation_ref = 9;
   */ _define_property(this, "solicitationRef", ""), /**
   * @generated from field: string description = 10;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string qualifications_text = 11;
   */ _define_property(this, "qualificationsText", ""), /**
   * @generated from field: string clearance = 12;
   */ _define_property(this, "clearance", ""), /**
   * @generated from field: string certifications = 13;
   */ _define_property(this, "certifications", ""), /**
   * @generated from field: string parsed_education_level = 14;
   */ _define_property(this, "parsedEducationLevel", ""), /**
   * -1 = unknown
   *
   * @generated from field: int32 parsed_min_experience_years = 15;
   */ _define_property(this, "parsedMinExperienceYears", 0), /**
   * @generated from field: mono.datagateway.v1.AnchorQualComparison comparison = 16;
   */ _define_property(this, "comparison", void 0), /**
   * @generated from field: string mapping_id = 17;
   */ _define_property(this, "mappingId", ""), /**
   * @generated from field: string relation = 18;
   */ _define_property(this, "relation", ""), /**
   * APPROVED | PENDING | REVIEW_NEEDED
   *
   * @generated from field: string mapping_status = 19;
   */ _define_property(this, "mappingStatus", ""), /**
   * 0 when absent
   *
   * @generated from field: double confidence = 20;
   */ _define_property(this, "confidence", 0), /**
   * proposer's display name (identity.users). Nothing proposes mappings automatically today (only the ryugu UI); v2.1: "Mapping suggester" when proposed_by='system:lcat-suggester' (REG-50, OD-55)
   *
   * @generated from field: string proposed_by_label = 21;
   */ _define_property(this, "proposedByLabel", ""), /**
   * @generated from field: string decided_by_name = 22;
   */ _define_property(this, "decidedByName", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 23;
   */ _define_property(this, "decidedAt", void 0), /**
   * @generated from field: string review_note = 24;
   */ _define_property(this, "reviewNote", ""), /**
   * @generated from field: int32 mapped_version = 25;
   */ _define_property(this, "mappedVersion", 0), /**
   * @generated from field: int32 head_version = 26;
   */ _define_property(this, "headVersion", 0), /**
   * @generated from field: bool stale = 27;
   */ _define_property(this, "stale", false), /**
   * @generated from field: bool vehicle_mismatch = 28;
   */ _define_property(this, "vehicleMismatch", false), /**
   * @generated from field: mono.datagateway.v1.RegistrySourceLabel source = 29;
   */ _define_property(this, "source", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnchorEntryRow, "runtime", proto3);
_define_property(AnchorEntryRow, "typeName", "mono.datagateway.v1.AnchorEntryRow");
_define_property(AnchorEntryRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "company",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 4,
            name: "company_is_own",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "title_as_written",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "vehicle",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 7,
            name: "scope_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "issuing_org",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 9,
            name: "solicitation_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "qualifications_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "clearance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "certifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "parsed_education_level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "parsed_min_experience_years",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 16,
            name: "comparison",
            kind: "message",
            T: AnchorQualComparison
        },
        {
            no: 17,
            name: "mapping_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "mapping_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 21,
            name: "proposed_by_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "decided_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 24,
            name: "review_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "mapped_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 26,
            name: "head_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 27,
            name: "stale",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 28,
            name: "vehicle_mismatch",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 29,
            name: "source",
            kind: "message",
            T: RegistrySourceLabel
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AnchorMappingCounts
 */ export class AnchorMappingCounts extends Message {
    static fromBinary(bytes, options) {
        return new AnchorMappingCounts().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnchorMappingCounts().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnchorMappingCounts().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnchorMappingCounts, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 approved = 1;
   */ _define_property(this, "approved", 0), /**
   * PENDING + REVIEW_NEEDED
   *
   * @generated from field: int32 waiting = 2;
   */ _define_property(this, "waiting", 0), /**
   * @generated from field: int32 vehicle_mismatch = 3;
   */ _define_property(this, "vehicleMismatch", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnchorMappingCounts, "runtime", proto3);
_define_property(AnchorMappingCounts, "typeName", "mono.datagateway.v1.AnchorMappingCounts");
_define_property(AnchorMappingCounts, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "approved",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "waiting",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "vehicle_mismatch",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RelatedAnchor
 */ export class RelatedAnchor extends Message {
    static fromBinary(bytes, options) {
        return new RelatedAnchor().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RelatedAnchor().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RelatedAnchor().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RelatedAnchor, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string anchor_id = 1;
   */ _define_property(this, "anchorId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string relation = 3;
   */ _define_property(this, "relation", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RelatedAnchor, "runtime", proto3);
_define_property(RelatedAnchor, "typeName", "mono.datagateway.v1.RelatedAnchor");
_define_property(RelatedAnchor, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AnchorUsageRow
 */ export class AnchorUsageRow extends Message {
    static fromBinary(bytes, options) {
        return new AnchorUsageRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnchorUsageRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnchorUsageRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnchorUsageRow, a, b);
    }
    constructor(data){
        super(), /**
   * PURSUIT_REQUEST | PROGRAM_SEATS | BLACK_HAT | SOLICITATION_COUNT
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef context = 2;
   */ _define_property(this, "context", void 0), /**
   * "RFI #2 asks for 4", "6 staffed seats"
   *
   * @generated from field: string metric_text = 3;
   */ _define_property(this, "metricText", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnchorUsageRow, "runtime", proto3);
_define_property(AnchorUsageRow, "typeName", "mono.datagateway.v1.AnchorUsageRow");
_define_property(AnchorUsageRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "context",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 3,
            name: "metric_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetLaborCategoryAnchorDossierResponse
 */ export class GetLaborCategoryAnchorDossierResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLaborCategoryAnchorDossierResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLaborCategoryAnchorDossierResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLaborCategoryAnchorDossierResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLaborCategoryAnchorDossierResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AnchorFacts anchor = 1;
   */ _define_property(this, "anchor", void 0), /**
   * @generated from field: mono.datagateway.v1.AnchorCounts counts = 2;
   */ _define_property(this, "counts", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.AnchorEntryRow rows = 3;
   */ _define_property(this, "rows", []), /**
   * @generated from field: mono.datagateway.v1.AnchorMappingCounts mapping_counts = 4;
   */ _define_property(this, "mappingCounts", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.RelatedAnchor related = 5;
   */ _define_property(this, "related", []), /**
   * @generated from field: repeated mono.datagateway.v1.AnchorUsageRow usage = 6;
   */ _define_property(this, "usage", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLaborCategoryAnchorDossierResponse, "runtime", proto3);
_define_property(GetLaborCategoryAnchorDossierResponse, "typeName", "mono.datagateway.v1.GetLaborCategoryAnchorDossierResponse");
_define_property(GetLaborCategoryAnchorDossierResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "anchor",
            kind: "message",
            T: AnchorFacts
        },
        {
            no: 2,
            name: "counts",
            kind: "message",
            T: AnchorCounts
        },
        {
            no: 3,
            name: "rows",
            kind: "message",
            T: AnchorEntryRow,
            repeated: true
        },
        {
            no: 4,
            name: "mapping_counts",
            kind: "message",
            T: AnchorMappingCounts
        },
        {
            no: 5,
            name: "related",
            kind: "message",
            T: RelatedAnchor,
            repeated: true
        },
        {
            no: 6,
            name: "usage",
            kind: "message",
            T: AnchorUsageRow,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListAnchorRatePointsRequest
 */ export class ListAnchorRatePointsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListAnchorRatePointsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAnchorRatePointsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAnchorRatePointsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAnchorRatePointsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string anchor_id = 1;
   */ _define_property(this, "anchorId", ""), /**
   * empty = all (FY25/FY26/Both toggle)
   *
   * @generated from field: repeated int32 fiscal_years = 2;
   */ _define_property(this, "fiscalYears", []), /**
   * default all
   *
   * @generated from field: repeated string relations = 3;
   */ _define_property(this, "relations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAnchorRatePointsRequest, "runtime", proto3);
_define_property(ListAnchorRatePointsRequest, "typeName", "mono.datagateway.v1.ListAnchorRatePointsRequest");
_define_property(ListAnchorRatePointsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "fiscal_years",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            repeated: true
        },
        {
            no: 3,
            name: "relations",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RatePoint
 */ export class RatePoint extends Message {
    static fromBinary(bytes, options) {
        return new RatePoint().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RatePoint().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RatePoint().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RatePoint, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string observation_id = 1;
   */ _define_property(this, "observationId", ""), /**
   * @generated from field: string observation_type = 2;
   */ _define_property(this, "observationType", ""), /**
   * @generated from field: double amount = 3;
   */ _define_property(this, "amount", 0), /**
   * @generated from field: string rate_unit = 4;
   */ _define_property(this, "rateUnit", ""), /**
   * @generated from field: string burden_basis = 5;
   */ _define_property(this, "burdenBasis", ""), /**
   * @generated from field: string currency = 6;
   */ _define_property(this, "currency", ""), /**
   * @generated from field: string period_label = 7;
   */ _define_property(this, "periodLabel", ""), /**
   * resolved (period coercion applied)
   *
   * @generated from field: string normalized_period_key = 8;
   */ _define_property(this, "normalizedPeriodKey", ""), /**
   * @generated from field: string worksite = 9;
   */ _define_property(this, "worksite", ""), /**
   * @generated from field: string source_label = 10;
   */ _define_property(this, "sourceLabel", ""), /**
   * 0 = unaligned (no bounds)
   *
   * @generated from field: int32 fiscal_year = 11;
   */ _define_property(this, "fiscalYear", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RatePoint, "runtime", proto3);
_define_property(RatePoint, "typeName", "mono.datagateway.v1.RatePoint");
_define_property(RatePoint, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "observation_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "rate_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "burden_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "normalized_period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "worksite",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "fiscal_year",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RateLane
 */ export class RateLane extends Message {
    static fromBinary(bytes, options) {
        return new RateLane().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateLane().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateLane().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateLane, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryRef company = 1;
   */ _define_property(this, "company", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryRef vehicle = 2;
   */ _define_property(this, "vehicle", void 0), /**
   * @generated from field: string relation = 3;
   */ _define_property(this, "relation", ""), /**
   * @generated from field: string mapping_status = 4;
   */ _define_property(this, "mappingStatus", ""), /**
   * false for BROADER/NARROWER/non-approved
   *
   * @generated from field: bool used_for_suggestion = 5;
   */ _define_property(this, "usedForSuggestion", false), /**
   * @generated from field: repeated mono.datagateway.v1.RatePoint points = 6;
   */ _define_property(this, "points", []), /**
   * (min real − max ceiling)/max ceiling × 100; only when has_gap
   *
   * @generated from field: double gap_percent = 7;
   */ _define_property(this, "gapPercent", 0), /**
   * @generated from field: bool has_gap = 8;
   */ _define_property(this, "hasGap", false), /**
   * e.g. "burden basis not stated" when no gap can be computed
   *
   * @generated from field: string note = 9;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateLane, "runtime", proto3);
_define_property(RateLane, "typeName", "mono.datagateway.v1.RateLane");
_define_property(RateLane, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 2,
            name: "vehicle",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 3,
            name: "relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "mapping_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "used_for_suggestion",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "points",
            kind: "message",
            T: RatePoint,
            repeated: true
        },
        {
            no: 7,
            name: "gap_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "has_gap",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RateBenchmark
 */ export class RateBenchmark extends Message {
    static fromBinary(bytes, options) {
        return new RateBenchmark().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateBenchmark().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateBenchmark().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateBenchmark, a, b);
    }
    constructor(data){
        super(), /**
   * CALC_PLUS_MEDIAN
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: double amount = 2;
   */ _define_property(this, "amount", 0), /**
   * @generated from field: int32 n = 3;
   */ _define_property(this, "n", 0), /**
   * @generated from field: string period_key = 4;
   */ _define_property(this, "periodKey", ""), /**
   * @generated from field: google.protobuf.Timestamp retrieved_at = 6;
   */ _define_property(this, "retrievedAt", void 0), /**
   * MAS contract numbers the median was computed over
   *
   * @generated from field: repeated string idv_piids = 7;
   */ _define_property(this, "idvPiids", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateBenchmark, "runtime", proto3);
_define_property(RateBenchmark, "typeName", "mono.datagateway.v1.RateBenchmark");
_define_property(RateBenchmark, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "n",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "retrieved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "idv_piids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RateSuggestionBand
 */ export class RateSuggestionBand extends Message {
    static fromBinary(bytes, options) {
        return new RateSuggestionBand().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateSuggestionBand().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateSuggestionBand().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateSuggestionBand, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: double low = 1;
   */ _define_property(this, "low", 0), /**
   * @generated from field: double high = 2;
   */ _define_property(this, "high", 0), /**
   * @generated from field: string rule_id = 3;
   */ _define_property(this, "ruleId", ""), /**
   * @generated from field: string rule_label = 4;
   */ _define_property(this, "ruleLabel", ""), /**
   * @generated from field: repeated string input_observation_ids = 5;
   */ _define_property(this, "inputObservationIds", []), /**
   * @generated from field: bool requires_choice = 6;
   */ _define_property(this, "requiresChoice", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateSuggestionBand, "runtime", proto3);
_define_property(RateSuggestionBand, "typeName", "mono.datagateway.v1.RateSuggestionBand");
_define_property(RateSuggestionBand, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "low",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "high",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "rule_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "rule_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "input_observation_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "requires_choice",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListAnchorRatePointsResponse
 */ export class ListAnchorRatePointsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListAnchorRatePointsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAnchorRatePointsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAnchorRatePointsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAnchorRatePointsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RateLane lanes = 1;
   */ _define_property(this, "lanes", []), /**
   * no normalized period key; never dropped
   *
   * @generated from field: repeated mono.datagateway.v1.RatePoint unaligned_points = 2;
   */ _define_property(this, "unalignedPoints", []), /**
   * unset when no CALC+ data
   *
   * @generated from field: mono.datagateway.v1.RateBenchmark benchmark = 3;
   */ _define_property(this, "benchmark", void 0), /**
   * unset when no input
   *
   * @generated from field: mono.datagateway.v1.RateSuggestionBand suggestion = 4;
   */ _define_property(this, "suggestion", void 0), /**
   * dominant comparable unit plotted (HOURLY)
   *
   * @generated from field: string rate_unit = 5;
   */ _define_property(this, "rateUnit", ""), /**
   * points omitted because unit/burden/currency differ
   *
   * @generated from field: int32 excluded_not_comparable = 6;
   */ _define_property(this, "excludedNotComparable", 0), /**
   * suggestion warnings, e.g. BURDEN_NOT_STATED
   *
   * @generated from field: repeated string warnings = 7;
   */ _define_property(this, "warnings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAnchorRatePointsResponse, "runtime", proto3);
_define_property(ListAnchorRatePointsResponse, "typeName", "mono.datagateway.v1.ListAnchorRatePointsResponse");
_define_property(ListAnchorRatePointsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "lanes",
            kind: "message",
            T: RateLane,
            repeated: true
        },
        {
            no: 2,
            name: "unaligned_points",
            kind: "message",
            T: RatePoint,
            repeated: true
        },
        {
            no: 3,
            name: "benchmark",
            kind: "message",
            T: RateBenchmark
        },
        {
            no: 4,
            name: "suggestion",
            kind: "message",
            T: RateSuggestionBand
        },
        {
            no: 5,
            name: "rate_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "excluded_not_comparable",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListAnchorPeopleRequest
 */ export class ListAnchorPeopleRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListAnchorPeopleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAnchorPeopleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAnchorPeopleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAnchorPeopleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string anchor_id = 1;
   */ _define_property(this, "anchorId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAnchorPeopleRequest, "runtime", proto3);
_define_property(ListAnchorPeopleRequest, "typeName", "mono.datagateway.v1.ListAnchorPeopleRequest");
_define_property(ListAnchorPeopleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AnchorPerson
 */ export class AnchorPerson extends Message {
    static fromBinary(bytes, options) {
        return new AnchorPerson().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnchorPerson().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnchorPerson().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnchorPerson, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contact_id = 1;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string title_as_written = 3;
   */ _define_property(this, "titleAsWritten", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef company = 4;
   */ _define_property(this, "company", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryRef program = 5;
   */ _define_property(this, "program", void 0), /**
   * @generated from field: google.protobuf.Timestamp start_date = 6;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 7;
   */ _define_property(this, "endDate", void 0), /**
   * "Sr. Systems Engineer (Blue Ridge) → Program Manager (Northwind)"
   *
   * @generated from field: string trajectory_note = 8;
   */ _define_property(this, "trajectoryNote", ""), /**
   * @generated from field: mono.datagateway.v1.RestrictedRateTrail rate_trail = 9;
   */ _define_property(this, "rateTrail", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnchorPerson, "runtime", proto3);
_define_property(AnchorPerson, "typeName", "mono.datagateway.v1.AnchorPerson");
_define_property(AnchorPerson, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title_as_written",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 5,
            name: "program",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 6,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "trajectory_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "rate_trail",
            kind: "message",
            T: RestrictedRateTrail
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListAnchorPeopleResponse
 */ export class ListAnchorPeopleResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListAnchorPeopleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAnchorPeopleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAnchorPeopleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAnchorPeopleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.AnchorPerson people = 1;
   */ _define_property(this, "people", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAnchorPeopleResponse, "runtime", proto3);
_define_property(ListAnchorPeopleResponse, "typeName", "mono.datagateway.v1.ListAnchorPeopleResponse");
_define_property(ListAnchorPeopleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "people",
            kind: "message",
            T: AnchorPerson,
            repeated: true
        }
    ]));
/**
 * ======================= Vehicle =======================
 *
 * @generated from message mono.datagateway.v1.GetVehicleDossierRequest
 */ export class GetVehicleDossierRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetVehicleDossierRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetVehicleDossierRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetVehicleDossierRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetVehicleDossierRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string vehicle_id = 1;
   */ _define_property(this, "vehicleId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetVehicleDossierRequest, "runtime", proto3);
_define_property(GetVehicleDossierRequest, "typeName", "mono.datagateway.v1.GetVehicleDossierRequest");
_define_property(GetVehicleDossierRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.VehicleLineageEdge
 */ export class VehicleLineageEdge extends Message {
    static fromBinary(bytes, options) {
        return new VehicleLineageEdge().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VehicleLineageEdge().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VehicleLineageEdge().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VehicleLineageEdge, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef predecessor = 2;
   */ _define_property(this, "predecessor", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryRef successor = 3;
   */ _define_property(this, "successor", void 0), /**
   * @generated from field: string relation = 4;
   */ _define_property(this, "relation", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 5;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: string source_basis = 6;
   */ _define_property(this, "sourceBasis", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef source_artifact = 7;
   */ _define_property(this, "sourceArtifact", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * unset while live; only returned with include_archived
   *
   * @generated from field: google.protobuf.Timestamp archived_at = 9;
   */ _define_property(this, "archivedAt", void 0), /**
   * @generated from field: string archive_reason = 10;
   */ _define_property(this, "archiveReason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(VehicleLineageEdge, "runtime", proto3);
_define_property(VehicleLineageEdge, "typeName", "mono.datagateway.v1.VehicleLineageEdge");
_define_property(VehicleLineageEdge, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "predecessor",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 3,
            name: "successor",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 4,
            name: "relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "source_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_artifact",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "archived_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "archive_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.VehicleLcatAnchorRow
 */ export class VehicleLcatAnchorRow extends Message {
    static fromBinary(bytes, options) {
        return new VehicleLcatAnchorRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VehicleLcatAnchorRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VehicleLcatAnchorRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VehicleLcatAnchorRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryRef anchor = 1;
   */ _define_property(this, "anchor", void 0), /**
   * @generated from field: int32 solicitation_count = 2;
   */ _define_property(this, "solicitationCount", 0), /**
   * @generated from field: int32 holders_priced = 3;
   */ _define_property(this, "holdersPriced", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(VehicleLcatAnchorRow, "runtime", proto3);
_define_property(VehicleLcatAnchorRow, "typeName", "mono.datagateway.v1.VehicleLcatAnchorRow");
_define_property(VehicleLcatAnchorRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "anchor",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 2,
            name: "solicitation_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "holders_priced",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.VehicleMismatchSummary
 */ export class VehicleMismatchSummary extends Message {
    static fromBinary(bytes, options) {
        return new VehicleMismatchSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VehicleMismatchSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VehicleMismatchSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VehicleMismatchSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 count = 1;
   */ _define_property(this, "count", 0), /**
   * "RFI #2 asks for 2 categories that only exist on GSA MAS"
   *
   * @generated from field: string sample_text = 2;
   */ _define_property(this, "sampleText", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(VehicleMismatchSummary, "runtime", proto3);
_define_property(VehicleMismatchSummary, "typeName", "mono.datagateway.v1.VehicleMismatchSummary");
_define_property(VehicleMismatchSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "sample_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.VehicleNoticeRow
 */ export class VehicleNoticeRow extends Message {
    static fromBinary(bytes, options) {
        return new VehicleNoticeRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VehicleNoticeRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VehicleNoticeRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VehicleNoticeRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryRef notice = 1;
   */ _define_property(this, "notice", void 0), /**
   * "due 6 Nov", "watching", "new"
   *
   * @generated from field: string status_text = 2;
   */ _define_property(this, "statusText", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(VehicleNoticeRow, "runtime", proto3);
_define_property(VehicleNoticeRow, "typeName", "mono.datagateway.v1.VehicleNoticeRow");
_define_property(VehicleNoticeRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 2,
            name: "status_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetVehicleDossierResponse
 */ export class GetVehicleDossierResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetVehicleDossierResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetVehicleDossierResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetVehicleDossierResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetVehicleDossierResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string vehicle_id = 1;
   */ _define_property(this, "vehicleId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string full_name = 3;
   */ _define_property(this, "fullName", ""), /**
   * @generated from field: string vehicle_type = 4;
   */ _define_property(this, "vehicleType", ""), /**
   * @generated from field: string ordering_eligibility = 5;
   */ _define_property(this, "orderingEligibility", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef awarding_org = 6;
   */ _define_property(this, "awardingOrg", void 0), /**
   * @generated from field: mono.datagateway.v1.VehicleOurStatus our_status = 7;
   */ _define_property(this, "ourStatus", void 0), /**
   * @generated from field: google.protobuf.Timestamp ordering_start = 8;
   */ _define_property(this, "orderingStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp ordering_end = 9;
   */ _define_property(this, "orderingEnd", void 0), /**
   * 0 = unknown
   *
   * @generated from field: double max_ceiling_value = 10;
   */ _define_property(this, "maxCeilingValue", 0), /**
   * @generated from field: string facts_source_note = 11;
   */ _define_property(this, "factsSourceNote", ""), /**
   * @generated from field: int32 holder_count = 12;
   */ _define_property(this, "holderCount", 0), /**
   * @generated from field: repeated mono.datagateway.v1.VehicleLineageEdge successors = 13;
   */ _define_property(this, "successors", []), /**
   * @generated from field: repeated mono.datagateway.v1.VehicleLineageEdge predecessors = 14;
   */ _define_property(this, "predecessors", []), /**
   * reused shape; issuer company in title
   *
   * @generated from field: repeated mono.datagateway.v1.CompanyPricingSheetRow pricing_sheets = 15;
   */ _define_property(this, "pricingSheets", []), /**
   * @generated from field: int32 entries_as_written = 16;
   */ _define_property(this, "entriesAsWritten", 0), /**
   * @generated from field: int32 entries_mapped = 17;
   */ _define_property(this, "entriesMapped", 0), /**
   * top 10 by solicitation_count
   *
   * @generated from field: repeated mono.datagateway.v1.VehicleLcatAnchorRow anchors = 18;
   */ _define_property(this, "anchors", []), /**
   * @generated from field: mono.datagateway.v1.VehicleMismatchSummary mismatch = 19;
   */ _define_property(this, "mismatch", void 0), /**
   * empty until Market read exists (Q6)
   *
   * @generated from field: repeated mono.datagateway.v1.VehicleNoticeRow open_notices = 20;
   */ _define_property(this, "openNotices", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetVehicleDossierResponse, "runtime", proto3);
_define_property(GetVehicleDossierResponse, "typeName", "mono.datagateway.v1.GetVehicleDossierResponse");
_define_property(GetVehicleDossierResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "full_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "vehicle_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "ordering_eligibility",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "awarding_org",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 7,
            name: "our_status",
            kind: "message",
            T: VehicleOurStatus
        },
        {
            no: 8,
            name: "ordering_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "ordering_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "max_ceiling_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "facts_source_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "holder_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "successors",
            kind: "message",
            T: VehicleLineageEdge,
            repeated: true
        },
        {
            no: 14,
            name: "predecessors",
            kind: "message",
            T: VehicleLineageEdge,
            repeated: true
        },
        {
            no: 15,
            name: "pricing_sheets",
            kind: "message",
            T: CompanyPricingSheetRow,
            repeated: true
        },
        {
            no: 16,
            name: "entries_as_written",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 17,
            name: "entries_mapped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 18,
            name: "anchors",
            kind: "message",
            T: VehicleLcatAnchorRow,
            repeated: true
        },
        {
            no: 19,
            name: "mismatch",
            kind: "message",
            T: VehicleMismatchSummary
        },
        {
            no: 20,
            name: "open_notices",
            kind: "message",
            T: VehicleNoticeRow,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListVehicleHoldersRequest
 */ export class ListVehicleHoldersRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListVehicleHoldersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVehicleHoldersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVehicleHoldersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVehicleHoldersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string vehicle_id = 1;
   */ _define_property(this, "vehicleId", ""), /**
   * default = first live SUCCESSOR
   *
   * @generated from field: string compare_vehicle_id = 2;
   */ _define_property(this, "compareVehicleId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVehicleHoldersRequest, "runtime", proto3);
_define_property(ListVehicleHoldersRequest, "typeName", "mono.datagateway.v1.ListVehicleHoldersRequest");
_define_property(ListVehicleHoldersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "compare_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.VehicleHolderRow
 */ export class VehicleHolderRow extends Message {
    static fromBinary(bytes, options) {
        return new VehicleHolderRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VehicleHolderRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VehicleHolderRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VehicleHolderRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryRef company = 1;
   */ _define_property(this, "company", void 0), /**
   * @generated from field: bool company_is_own = 2;
   */ _define_property(this, "companyIsOwn", false), /**
   * HOLDER (live, unexpired direct_holder/jv_participant) | THROUGH (team_member) | PRICE_LIST_ONLY | NOT_ON_IT
   *
   * @generated from field: string holding_this = 3;
   */ _define_property(this, "holdingThis", ""), /**
   * same set | "" when no compare vehicle
   *
   * @generated from field: string holding_compare = 4;
   */ _define_property(this, "holdingCompare", ""), /**
   * "Our list v2 · 42 categories"
   *
   * @generated from field: string pricing_on_file_label = 5;
   */ _define_property(this, "pricingOnFileLabel", ""), /**
   * "uploaded Jan 2024"
   *
   * @generated from field: string pricing_on_file_detail = 6;
   */ _define_property(this, "pricingOnFileDetail", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef pricing_generation = 7;
   */ _define_property(this, "pricingGeneration", void 0), /**
   * @generated from field: int32 lcat_count = 8;
   */ _define_property(this, "lcatCount", 0), /**
   * @generated from field: int32 task_order_count = 9;
   */ _define_property(this, "taskOrderCount", 0), /**
   * @generated from field: bool is_teammate = 10;
   */ _define_property(this, "isTeammate", false), /**
   * vehicle_company_access.verification_status, verbatim; FE marks unverified holdings
   *
   * @generated from field: string holding_verification = 11;
   */ _define_property(this, "holdingVerification", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(VehicleHolderRow, "runtime", proto3);
_define_property(VehicleHolderRow, "typeName", "mono.datagateway.v1.VehicleHolderRow");
_define_property(VehicleHolderRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 2,
            name: "company_is_own",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "holding_this",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "holding_compare",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "pricing_on_file_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "pricing_on_file_detail",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "pricing_generation",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 8,
            name: "lcat_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "task_order_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "is_teammate",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "holding_verification",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListVehicleHoldersResponse
 */ export class ListVehicleHoldersResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListVehicleHoldersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVehicleHoldersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVehicleHoldersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVehicleHoldersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.VehicleHolderRow rows = 1;
   */ _define_property(this, "rows", []), /**
   * @generated from field: mono.datagateway.v1.RegistryRef compare_vehicle = 2;
   */ _define_property(this, "compareVehicle", void 0), /**
   * "Blue Ridge holds T4NG but not T4NG2. …"
   *
   * @generated from field: repeated string callouts = 3;
   */ _define_property(this, "callouts", []), /**
   * parallel to callouts (pursuit thread), empty kind = none
   *
   * @generated from field: repeated mono.datagateway.v1.RegistryRef callout_links = 4;
   */ _define_property(this, "calloutLinks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVehicleHoldersResponse, "runtime", proto3);
_define_property(ListVehicleHoldersResponse, "typeName", "mono.datagateway.v1.ListVehicleHoldersResponse");
_define_property(ListVehicleHoldersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: VehicleHolderRow,
            repeated: true
        },
        {
            no: 2,
            name: "compare_vehicle",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 3,
            name: "callouts",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "callout_links",
            kind: "message",
            T: RegistryRef,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListVehicleTaskOrderRoundsRequest
 */ export class ListVehicleTaskOrderRoundsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListVehicleTaskOrderRoundsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVehicleTaskOrderRoundsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVehicleTaskOrderRoundsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVehicleTaskOrderRoundsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string vehicle_id = 1;
   */ _define_property(this, "vehicleId", ""), /**
   * @generated from field: int32 from_year = 2;
   */ _define_property(this, "fromYear", 0), /**
   * @generated from field: int32 to_year = 3;
   */ _define_property(this, "toYear", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVehicleTaskOrderRoundsRequest, "runtime", proto3);
_define_property(ListVehicleTaskOrderRoundsRequest, "typeName", "mono.datagateway.v1.ListVehicleTaskOrderRoundsRequest");
_define_property(ListVehicleTaskOrderRoundsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "from_year",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "to_year",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.TaskOrderRound
 */ export class TaskOrderRound extends Message {
    static fromBinary(bytes, options) {
        return new TaskOrderRound().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TaskOrderRound().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TaskOrderRound().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TaskOrderRound, a, b);
    }
    constructor(data){
        super(), /**
   * GRW round id
   *
   * @generated from field: string round_key = 1;
   */ _define_property(this, "roundKey", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef holder = 2;
   */ _define_property(this, "holder", void 0), /**
   * US | COMPETITOR | PRIOR | UNKNOWN
   *
   * @generated from field: string holder_kind = 3;
   */ _define_property(this, "holderKind", ""), /**
   * @generated from field: google.protobuf.Timestamp start = 4;
   */ _define_property(this, "start", void 0), /**
   * @generated from field: google.protobuf.Timestamp end = 5;
   */ _define_property(this, "end", void 0), /**
   * @generated from field: google.protobuf.Timestamp options_end = 6;
   */ _define_property(this, "optionsEnd", void 0), /**
   * PRIOR | CURRENT | FUTURE_OPTIONS | OUR_FUTURE_POP
   *
   * @generated from field: string status = 7;
   */ _define_property(this, "status", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef contract = 8;
   */ _define_property(this, "contract", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TaskOrderRound, "runtime", proto3);
_define_property(TaskOrderRound, "typeName", "mono.datagateway.v1.TaskOrderRound");
_define_property(TaskOrderRound, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "round_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "holder",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 3,
            name: "holder_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "options_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "contract",
            kind: "message",
            T: RegistryRef
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.TaskOrderRequirement
 */ export class TaskOrderRequirement extends Message {
    static fromBinary(bytes, options) {
        return new TaskOrderRequirement().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TaskOrderRequirement().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TaskOrderRequirement().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TaskOrderRequirement, a, b);
    }
    constructor(data){
        super(), /**
   * GRW seat key, or "contract:{registry_contract_id}" for an unseated task order
   *
   * @generated from field: string seat_key = 1;
   */ _define_property(this, "seatKey", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef customer = 3;
   */ _define_property(this, "customer", void 0), /**
   * "$112M"
   *
   * @generated from field: string value_label = 4;
   */ _define_property(this, "valueLabel", ""), /**
   * @generated from field: repeated mono.datagateway.v1.TaskOrderRound rounds = 5;
   */ _define_property(this, "rounds", []), /**
   * @generated from field: google.protobuf.Timestamp next_round_expected_at = 6;
   */ _define_property(this, "nextRoundExpectedAt", void 0), /**
   * successor vehicle when ordering closes first
   *
   * @generated from field: mono.datagateway.v1.RegistryRef next_round_vehicle = 7;
   */ _define_property(this, "nextRoundVehicle", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TaskOrderRequirement, "runtime", proto3);
_define_property(TaskOrderRequirement, "typeName", "mono.datagateway.v1.TaskOrderRequirement");
_define_property(TaskOrderRequirement, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seat_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "customer",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 4,
            name: "value_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rounds",
            kind: "message",
            T: TaskOrderRound,
            repeated: true
        },
        {
            no: 6,
            name: "next_round_expected_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "next_round_vehicle",
            kind: "message",
            T: RegistryRef
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListVehicleTaskOrderRoundsResponse
 */ export class ListVehicleTaskOrderRoundsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListVehicleTaskOrderRoundsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVehicleTaskOrderRoundsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVehicleTaskOrderRoundsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVehicleTaskOrderRoundsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: google.protobuf.Timestamp ordering_end = 1;
   */ _define_property(this, "orderingEnd", void 0), /**
   * @generated from field: google.protobuf.Timestamp now = 2;
   */ _define_property(this, "now", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.TaskOrderRequirement requirements = 3;
   */ _define_property(this, "requirements", []), /**
   * viewer lacks the GRW-24 landscape read (opportunity `read` at tenant root): no seat data returned
   *
   * @generated from field: bool growth_hidden = 4;
   */ _define_property(this, "growthHidden", false), /**
   * content-free hint: only when growth_hidden, a visible program's recompete pursuit opted in (GRW-04) and delivery.growth_hint.view allows; no ids or counts
   *
   * @generated from field: bool growth_presence = 5;
   */ _define_property(this, "growthPresence", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVehicleTaskOrderRoundsResponse, "runtime", proto3);
_define_property(ListVehicleTaskOrderRoundsResponse, "typeName", "mono.datagateway.v1.ListVehicleTaskOrderRoundsResponse");
_define_property(ListVehicleTaskOrderRoundsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "ordering_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 2,
            name: "now",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "requirements",
            kind: "message",
            T: TaskOrderRequirement,
            repeated: true
        },
        {
            no: 4,
            name: "growth_hidden",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "growth_presence",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListVehicleLineageRequest
 */ export class ListVehicleLineageRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListVehicleLineageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVehicleLineageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVehicleLineageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVehicleLineageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string vehicle_id = 1;
   */ _define_property(this, "vehicleId", ""), /**
   * @generated from field: bool include_archived = 2;
   */ _define_property(this, "includeArchived", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVehicleLineageRequest, "runtime", proto3);
_define_property(ListVehicleLineageRequest, "typeName", "mono.datagateway.v1.ListVehicleLineageRequest");
_define_property(ListVehicleLineageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_archived",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListVehicleLineageResponse
 */ export class ListVehicleLineageResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListVehicleLineageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVehicleLineageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVehicleLineageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVehicleLineageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.VehicleLineageEdge edges = 1;
   */ _define_property(this, "edges", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVehicleLineageResponse, "runtime", proto3);
_define_property(ListVehicleLineageResponse, "typeName", "mono.datagateway.v1.ListVehicleLineageResponse");
_define_property(ListVehicleLineageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "edges",
            kind: "message",
            T: VehicleLineageEdge,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveVehicleLineageRequest
 */ export class SaveVehicleLineageRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveVehicleLineageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveVehicleLineageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveVehicleLineageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveVehicleLineageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * caller-generated uuid (create only; lineage is not edited, it is archived + re-saved)
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string predecessor_vehicle_id = 2;
   */ _define_property(this, "predecessorVehicleId", ""), /**
   * @generated from field: string successor_vehicle_id = 3;
   */ _define_property(this, "successorVehicleId", ""), /**
   * @generated from field: string relation = 4;
   */ _define_property(this, "relation", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 5;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: string source_basis = 6;
   */ _define_property(this, "sourceBasis", ""), /**
   * @generated from field: string source_artifact_id = 7;
   */ _define_property(this, "sourceArtifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveVehicleLineageRequest, "runtime", proto3);
_define_property(SaveVehicleLineageRequest, "typeName", "mono.datagateway.v1.SaveVehicleLineageRequest");
_define_property(SaveVehicleLineageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "predecessor_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "successor_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "source_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveVehicleLineageResponse
 */ export class SaveVehicleLineageResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveVehicleLineageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveVehicleLineageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveVehicleLineageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveVehicleLineageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.VehicleLineageEdge edge = 1;
   */ _define_property(this, "edge", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveVehicleLineageResponse, "runtime", proto3);
_define_property(SaveVehicleLineageResponse, "typeName", "mono.datagateway.v1.SaveVehicleLineageResponse");
_define_property(SaveVehicleLineageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "edge",
            kind: "message",
            T: VehicleLineageEdge
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ArchiveVehicleLineageRequest
 */ export class ArchiveVehicleLineageRequest extends Message {
    static fromBinary(bytes, options) {
        return new ArchiveVehicleLineageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ArchiveVehicleLineageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ArchiveVehicleLineageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ArchiveVehicleLineageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ArchiveVehicleLineageRequest, "runtime", proto3);
_define_property(ArchiveVehicleLineageRequest, "typeName", "mono.datagateway.v1.ArchiveVehicleLineageRequest");
_define_property(ArchiveVehicleLineageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ArchiveVehicleLineageResponse
 */ export class ArchiveVehicleLineageResponse extends Message {
    static fromBinary(bytes, options) {
        return new ArchiveVehicleLineageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ArchiveVehicleLineageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ArchiveVehicleLineageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ArchiveVehicleLineageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.VehicleLineageEdge edge = 1;
   */ _define_property(this, "edge", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ArchiveVehicleLineageResponse, "runtime", proto3);
_define_property(ArchiveVehicleLineageResponse, "typeName", "mono.datagateway.v1.ArchiveVehicleLineageResponse");
_define_property(ArchiveVehicleLineageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "edge",
            kind: "message",
            T: VehicleLineageEdge
        }
    ]));
/**
 * ======================= Government org =======================
 *
 * @generated from message mono.datagateway.v1.GetGovernmentOrgDossierRequest
 */ export class GetGovernmentOrgDossierRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetGovernmentOrgDossierRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGovernmentOrgDossierRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGovernmentOrgDossierRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGovernmentOrgDossierRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string org_id = 1;
   */ _define_property(this, "orgId", ""), /**
   * @generated from field: bool include_descendants = 2;
   */ _define_property(this, "includeDescendants", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGovernmentOrgDossierRequest, "runtime", proto3);
_define_property(GetGovernmentOrgDossierRequest, "typeName", "mono.datagateway.v1.GetGovernmentOrgDossierRequest");
_define_property(GetGovernmentOrgDossierRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_descendants",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GovOrgAskRow
 */ export class GovOrgAskRow extends Message {
    static fromBinary(bytes, options) {
        return new GovOrgAskRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovOrgAskRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovOrgAskRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovOrgAskRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryRef anchor = 1;
   */ _define_property(this, "anchor", void 0), /**
   * @generated from field: int32 solicitation_count = 2;
   */ _define_property(this, "solicitationCount", 0), /**
   * @generated from field: int32 since_year = 3;
   */ _define_property(this, "sinceYear", 0), /**
   * RISING | FLAT | FALLING | ""
   *
   * @generated from field: string trend = 4;
   */ _define_property(this, "trend", ""), /**
   * @generated from field: int32 trend_since_year = 5;
   */ _define_property(this, "trendSinceYear", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovOrgAskRow, "runtime", proto3);
_define_property(GovOrgAskRow, "typeName", "mono.datagateway.v1.GovOrgAskRow");
_define_property(GovOrgAskRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "anchor",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 2,
            name: "solicitation_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "since_year",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "trend",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "trend_since_year",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GovOrgRelationshipFacts
 */ export class GovOrgRelationshipFacts extends Message {
    static fromBinary(bytes, options) {
        return new GovOrgRelationshipFacts().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovOrgRelationshipFacts().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovOrgRelationshipFacts().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovOrgRelationshipFacts, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 visible_touchpoints_this_year = 1;
   */ _define_property(this, "visibleTouchpointsThisYear", 0), /**
   * @generated from field: int32 known_people = 2;
   */ _define_property(this, "knownPeople", 0), /**
   * @generated from field: mono.datagateway.v1.ContactLastTouch last_contact = 3;
   */ _define_property(this, "lastContact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovOrgRelationshipFacts, "runtime", proto3);
_define_property(GovOrgRelationshipFacts, "typeName", "mono.datagateway.v1.GovOrgRelationshipFacts");
_define_property(GovOrgRelationshipFacts, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "visible_touchpoints_this_year",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "known_people",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "last_contact",
            kind: "message",
            T: ContactLastTouch
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetGovernmentOrgDossierResponse
 */ export class GetGovernmentOrgDossierResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetGovernmentOrgDossierResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGovernmentOrgDossierResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGovernmentOrgDossierResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGovernmentOrgDossierResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string org_id = 1;
   */ _define_property(this, "orgId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string acronym = 3;
   */ _define_property(this, "acronym", ""), /**
   * @generated from field: string display_type = 4;
   */ _define_property(this, "displayType", ""), /**
   * root first; v2.3: registry parent_id (REG-58 tree), never the graph
   *
   * @generated from field: repeated mono.datagateway.v1.RegistryRef ancestors = 5;
   */ _define_property(this, "ancestors", []), /**
   * customer orgs of programs it contracts for
   *
   * @generated from field: repeated mono.datagateway.v1.RegistryRef buys_for = 6;
   */ _define_property(this, "buysFor", []), /**
   * @generated from field: repeated mono.datagateway.v1.RegistryRef vehicles_awarded = 7;
   */ _define_property(this, "vehiclesAwarded", []), /**
   * @generated from field: repeated mono.datagateway.v1.RegistryAppearanceCard appearances = 8;
   */ _define_property(this, "appearances", []), /**
   * @generated from field: mono.datagateway.v1.GovOrgRelationshipFacts relationship = 9;
   */ _define_property(this, "relationship", void 0), /**
   * @generated from field: string office_code = 10;
   */ _define_property(this, "officeCode", ""), /**
   * @generated from field: string location_text = 11;
   */ _define_property(this, "locationText", ""), /**
   * @generated from field: string reference_source = 12;
   */ _define_property(this, "referenceSource", ""), /**
   * @generated from field: bool read_only_reference = 13;
   */ _define_property(this, "readOnlyReference", false), /**
   * @generated from field: repeated mono.datagateway.v1.GovOrgAskRow asks = 14;
   */ _define_property(this, "asks", []), /**
   * v2.1 (OD-54), from DAT-19 MorgansService.GetOfficeEvaluationStyles
   *
   * @generated from field: mono.datagateway.v1.GovOrgEvaluationStyle evaluation_style = 15;
   */ _define_property(this, "evaluationStyle", void 0), /**
   * v2.3: always "registry" (kept for wire compatibility; v2.2 "graph"/"pending" withdrawn)
   *
   * @generated from field: string hierarchy_source = 16;
   */ _define_property(this, "hierarchySource", ""), /**
   * v2.3: the registry-keyed gov_org node (REG-57), '' when none
   *
   * @generated from field: string graph_node_id = 17;
   */ _define_property(this, "graphNodeId", ""), /**
   * v2.3: public org_parent edges that disagree with the registry parent
   *
   * @generated from field: repeated mono.datagateway.v1.GovOrgPublicParent public_parent_claims = 18;
   */ _define_property(this, "publicParentClaims", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGovernmentOrgDossierResponse, "runtime", proto3);
_define_property(GetGovernmentOrgDossierResponse, "typeName", "mono.datagateway.v1.GetGovernmentOrgDossierResponse");
_define_property(GetGovernmentOrgDossierResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "display_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "ancestors",
            kind: "message",
            T: RegistryRef,
            repeated: true
        },
        {
            no: 6,
            name: "buys_for",
            kind: "message",
            T: RegistryRef,
            repeated: true
        },
        {
            no: 7,
            name: "vehicles_awarded",
            kind: "message",
            T: RegistryRef,
            repeated: true
        },
        {
            no: 8,
            name: "appearances",
            kind: "message",
            T: RegistryAppearanceCard,
            repeated: true
        },
        {
            no: 9,
            name: "relationship",
            kind: "message",
            T: GovOrgRelationshipFacts
        },
        {
            no: 10,
            name: "office_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "location_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "reference_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "read_only_reference",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 14,
            name: "asks",
            kind: "message",
            T: GovOrgAskRow,
            repeated: true
        },
        {
            no: 15,
            name: "evaluation_style",
            kind: "message",
            T: GovOrgEvaluationStyle
        },
        {
            no: 16,
            name: "hierarchy_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "graph_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "public_parent_claims",
            kind: "message",
            T: GovOrgPublicParent,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GovOrgEvaluationStyle
 */ export class GovOrgEvaluationStyle extends Message {
    static fromBinary(bytes, options) {
        return new GovOrgEvaluationStyle().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovOrgEvaluationStyle().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovOrgEvaluationStyle().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovOrgEvaluationStyle, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string label = 1;
   */ _define_property(this, "label", ""), /**
   * @generated from field: int32 matching = 2;
   */ _define_property(this, "matching", 0), /**
   * @generated from field: int32 considered = 3;
   */ _define_property(this, "considered", 0), /**
   * @generated from field: string family = 4;
   */ _define_property(this, "family", ""), /**
   * @generated from field: string source_note = 5;
   */ _define_property(this, "sourceNote", ""), /**
   * @generated from field: int32 pending = 6;
   */ _define_property(this, "pending", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovOrgEvaluationStyle, "runtime", proto3);
_define_property(GovOrgEvaluationStyle, "typeName", "mono.datagateway.v1.GovOrgEvaluationStyle");
_define_property(GovOrgEvaluationStyle, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "matching",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "considered",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "family",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "pending",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetGovernmentOrgAwardSeriesRequest
 */ export class GetGovernmentOrgAwardSeriesRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetGovernmentOrgAwardSeriesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGovernmentOrgAwardSeriesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGovernmentOrgAwardSeriesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGovernmentOrgAwardSeriesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string org_id = 1;
   */ _define_property(this, "orgId", ""), /**
   * @generated from field: bool include_descendants = 2;
   */ _define_property(this, "includeDescendants", false), /**
   * @generated from field: int32 from_fiscal_year = 3;
   */ _define_property(this, "fromFiscalYear", 0), /**
   * @generated from field: int32 to_fiscal_year = 4;
   */ _define_property(this, "toFiscalYear", 0), /**
   * default 3, max 6
   *
   * @generated from field: int32 top_n = 5;
   */ _define_property(this, "topN", 0), /**
   * only "obligations" accepted in v1 (default): award total obligations, bucketed by the award's start FY (the fact period), scope prime. "action_obligations" (true per-FY spend) reserved for a transaction feed
   *
   * @generated from field: string measure = 6;
   */ _define_property(this, "measure", ""), /**
   * v2.1 (OD-53, REG-24): fields 7–9 replace the former reservation
   *
   * @generated from field: repeated string naics_prefixes = 7;
   */ _define_property(this, "naicsPrefixes", []), /**
   * @generated from field: repeated string psc_prefixes = 8;
   */ _define_property(this, "pscPrefixes", []), /**
   * "" | IT_SERVICES
   *
   * @generated from field: string scope_preset = 9;
   */ _define_property(this, "scopePreset", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGovernmentOrgAwardSeriesRequest, "runtime", proto3);
_define_property(GetGovernmentOrgAwardSeriesRequest, "typeName", "mono.datagateway.v1.GetGovernmentOrgAwardSeriesRequest");
_define_property(GetGovernmentOrgAwardSeriesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_descendants",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "from_fiscal_year",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "to_fiscal_year",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "top_n",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "measure",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "naics_prefixes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "psc_prefixes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "scope_preset",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AwardSegment
 */ export class AwardSegment extends Message {
    static fromBinary(bytes, options) {
        return new AwardSegment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardSegment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardSegment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardSegment, a, b);
    }
    constructor(data){
        super(), /**
   * company id, "us", or "others"
   *
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * unset for "others"
   *
   * @generated from field: mono.datagateway.v1.RegistryRef company = 2;
   */ _define_property(this, "company", void 0), /**
   * @generated from field: bool is_us = 3;
   */ _define_property(this, "isUs", false), /**
   * @generated from field: double amount = 4;
   */ _define_property(this, "amount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardSegment, "runtime", proto3);
_define_property(AwardSegment, "typeName", "mono.datagateway.v1.AwardSegment");
_define_property(AwardSegment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 3,
            name: "is_us",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AwardYear
 */ export class AwardYear extends Message {
    static fromBinary(bytes, options) {
        return new AwardYear().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardYear().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardYear().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardYear, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 fiscal_year = 1;
   */ _define_property(this, "fiscalYear", 0), /**
   * @generated from field: double total = 2;
   */ _define_property(this, "total", 0), /**
   * @generated from field: repeated mono.datagateway.v1.AwardSegment segments = 3;
   */ _define_property(this, "segments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardYear, "runtime", proto3);
_define_property(AwardYear, "typeName", "mono.datagateway.v1.AwardYear");
_define_property(AwardYear, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "fiscal_year",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "segments",
            kind: "message",
            T: AwardSegment,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetGovernmentOrgAwardSeriesResponse
 */ export class GetGovernmentOrgAwardSeriesResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetGovernmentOrgAwardSeriesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGovernmentOrgAwardSeriesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGovernmentOrgAwardSeriesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGovernmentOrgAwardSeriesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.AwardYear years = 1;
   */ _define_property(this, "years", []), /**
   * legend order (us first, then top_n)
   *
   * @generated from field: repeated mono.datagateway.v1.RegistryRef winners = 2;
   */ _define_property(this, "winners", []), /**
   * "USAspending · SAM awards · award value, not a labor rate"
   *
   * @generated from field: string source_note = 3;
   */ _define_property(this, "sourceNote", ""), /**
   * @generated from field: int32 unknown_value_count = 4;
   */ _define_property(this, "unknownValueCount", 0), /**
   * > 2000 contracts scanned
   *
   * @generated from field: bool truncated = 5;
   */ _define_property(this, "truncated", false), /**
   * v2.1: excluded from a filtered series (no NAICS and no PSC)
   *
   * @generated from field: int32 unclassified_count = 6;
   */ _define_property(this, "unclassifiedCount", 0), /**
   * v2.1 (OD-53)
   *
   * @generated from field: mono.datagateway.v1.AwardSetAsideShare set_aside = 7;
   */ _define_property(this, "setAside", void 0), /**
   * v2.1: top NAICS/PSC codes in the org set
   *
   * @generated from field: repeated mono.datagateway.v1.AwardCodeFacet facets = 8;
   */ _define_property(this, "facets", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGovernmentOrgAwardSeriesResponse, "runtime", proto3);
_define_property(GetGovernmentOrgAwardSeriesResponse, "typeName", "mono.datagateway.v1.GetGovernmentOrgAwardSeriesResponse");
_define_property(GetGovernmentOrgAwardSeriesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "years",
            kind: "message",
            T: AwardYear,
            repeated: true
        },
        {
            no: 2,
            name: "winners",
            kind: "message",
            T: RegistryRef,
            repeated: true
        },
        {
            no: 3,
            name: "source_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "unknown_value_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "truncated",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "unclassified_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "set_aside",
            kind: "message",
            T: AwardSetAsideShare
        },
        {
            no: 8,
            name: "facets",
            kind: "message",
            T: AwardCodeFacet,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AwardSetAsideShare
 */ export class AwardSetAsideShare extends Message {
    static fromBinary(bytes, options) {
        return new AwardSetAsideShare().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardSetAsideShare().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardSetAsideShare().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardSetAsideShare, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 awards_with_known_set_aside = 1;
   */ _define_property(this, "awardsWithKnownSetAside", 0), /**
   * @generated from field: int32 small_business_set_aside_awards = 2;
   */ _define_property(this, "smallBusinessSetAsideAwards", 0), /**
   * @generated from field: int32 percent_rounded_5 = 3;
   */ _define_property(this, "percentRounded5", 0), /**
   * @generated from field: bool enough_data = 4;
   */ _define_property(this, "enoughData", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardSetAsideShare, "runtime", proto3);
_define_property(AwardSetAsideShare, "typeName", "mono.datagateway.v1.AwardSetAsideShare");
_define_property(AwardSetAsideShare, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "awards_with_known_set_aside",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "small_business_set_aside_awards",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "percent_rounded_5",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "enough_data",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AwardCodeFacet
 */ export class AwardCodeFacet extends Message {
    static fromBinary(bytes, options) {
        return new AwardCodeFacet().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardCodeFacet().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardCodeFacet().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardCodeFacet, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string code = 2;
   */ _define_property(this, "code", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: int32 award_count = 4;
   */ _define_property(this, "awardCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardCodeFacet, "runtime", proto3);
_define_property(AwardCodeFacet, "typeName", "mono.datagateway.v1.AwardCodeFacet");
_define_property(AwardCodeFacet, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "award_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ======================= Hearsay =======================
 * v2.3 (D-SOR 5): IntelClaimSubject is replaced by IntelClaimLink (one shape for subjects and contexts).
 *
 * @generated from message mono.datagateway.v1.IntelClaimLink
 */ export class IntelClaimLink extends Message {
    static fromBinary(bytes, options) {
        return new IntelClaimLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IntelClaimLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IntelClaimLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IntelClaimLink, a, b);
    }
    constructor(data){
        super(), /**
   * ABOUT | HEARD_FROM | HEARD_AT | RELEVANT_TO ("" on a filter = any role)
   *
   * @generated from field: string link_role = 1;
   */ _define_property(this, "linkRole", ""), /**
   * per the govcon.intel_claim_links CHECK
   *
   * @generated from field: string target_kind = 2;
   */ _define_property(this, "targetKind", ""), /**
   * as stored (may be a merged loser)
   *
   * @generated from field: string target_id = 3;
   */ _define_property(this, "targetId", ""), /**
   * output: survivor / context label
   *
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * output: registry survivor id (= target_id for contexts and unmerged rows)
   *
   * @generated from field: string resolved_target_id = 5;
   */ _define_property(this, "resolvedTargetId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(IntelClaimLink, "runtime", proto3);
_define_property(IntelClaimLink, "typeName", "mono.datagateway.v1.IntelClaimLink");
_define_property(IntelClaimLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "resolved_target_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * v2.3 (REG-56): competitor facets
 *
 * @generated from message mono.datagateway.v1.IntelClaimFacet
 */ export class IntelClaimFacet extends Message {
    static fromBinary(bytes, options) {
        return new IntelClaimFacet().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IntelClaimFacet().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IntelClaimFacet().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IntelClaimFacet, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string claim_type = 1;
   */ _define_property(this, "claimType", ""), /**
   * @generated from field: string stance = 2;
   */ _define_property(this, "stance", ""), /**
   * @generated from field: string basis = 3;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: string origin_source_kind = 4;
   */ _define_property(this, "originSourceKind", ""), /**
   * @generated from field: string origin_source_ref = 5;
   */ _define_property(this, "originSourceRef", ""), /**
   * @generated from field: string inference_assumptions = 6;
   */ _define_property(this, "inferenceAssumptions", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(IntelClaimFacet, "runtime", proto3);
_define_property(IntelClaimFacet, "typeName", "mono.datagateway.v1.IntelClaimFacet");
_define_property(IntelClaimFacet, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "claim_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "stance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "origin_source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "origin_source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "inference_assumptions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * A claim is NEVER a fact. Never present `statement` as fact. Consumers that
 * build LLM context MUST prefix `[hearsay, unverified · {audience.summary}]`.
 * Hearsay may be paraphrased into drafts and MUST NOT be quoted verbatim in any
 * government-facing text. Visibility = the author, or the FND-25 ceiling
 * `hearsay.read` AND the claim's audience; Assist runs as the user (REG-02).
 *
 * @generated from message mono.datagateway.v1.IntelClaim
 */ export class IntelClaim extends Message {
    static fromBinary(bytes, options) {
        return new IntelClaim().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IntelClaim().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IntelClaim().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IntelClaim, a, b);
    }
    constructor(data){
        super(), /**
   * head row id
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string lineage_id = 2;
   */ _define_property(this, "lineageId", ""), /**
   * @generated from field: string statement = 3;
   */ _define_property(this, "statement", ""), /**
   * INTEL | HANDLING_NOTE
   *
   * @generated from field: string claim_kind = 4;
   */ _define_property(this, "claimKind", ""), /**
   * HEARSAY | ANALYST_RESEARCH | DOCUMENT
   *
   * @generated from field: string source_type = 5;
   */ _define_property(this, "sourceType", ""), /**
   * v2.3: survivor of the HEARD_FROM link, else empty (then heard_from_text)
   *
   * @generated from field: mono.datagateway.v1.RegistryRef heard_from = 6;
   */ _define_property(this, "heardFrom", void 0), /**
   * @generated from field: string heard_from_text = 7;
   */ _define_property(this, "heardFromText", ""), /**
   * @generated from field: string venue_text = 8;
   */ _define_property(this, "venueText", ""), /**
   * @generated from field: google.protobuf.Timestamp heard_on = 9;
   */ _define_property(this, "heardOn", void 0), /**
   * @generated from field: string recorded_by_name = 10;
   */ _define_property(this, "recordedByName", ""), /**
   * LOW | MEDIUM | HIGH
   *
   * @generated from field: string confidence = 11;
   */ _define_property(this, "confidence", ""), /**
   * UNVERIFIED | CORROBORATED | CONTRADICTED | RETRACTED
   *
   * @generated from field: string verification = 12;
   */ _define_property(this, "verification", ""), /**
   * @generated from field: string verification_note = 13;
   */ _define_property(this, "verificationNote", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef corroborated_by = 14;
   */ _define_property(this, "corroboratedBy", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryRef source_artifact = 15;
   */ _define_property(this, "sourceArtifact", void 0), /**
   * INTERNAL_ONLY | CITABLE
   *
   * @generated from field: string citability = 16;
   */ _define_property(this, "citability", ""), /**
   * @generated from field: google.protobuf.Timestamp expires_on = 17;
   */ _define_property(this, "expiresOn", void 0), /**
   * @generated from field: bool is_expired = 18;
   */ _define_property(this, "isExpired", false), /**
   * v2.3: all roles (was `subjects`)
   *
   * @generated from field: repeated mono.datagateway.v1.IntelClaimLink links = 19;
   */ _define_property(this, "links", []), /**
   * @generated from field: google.protobuf.Timestamp created_at = 20;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: int32 version_count = 21;
   */ _define_property(this, "versionCount", 0), /**
   * v2.2 (I-11)
   *
   * @generated from field: mono.datagateway.v1.IntelClaimAudience audience = 22;
   */ _define_property(this, "audience", void 0), /**
   * @generated from field: bool viewer_is_author = 23;
   */ _define_property(this, "viewerIsAuthor", false), /**
   * Only set when viewer_is_author and the audience is PERSONAL: the one-click
   * "Share with team" target (REG-02 rule); empty kind = no single obvious team.
   *
   * @generated from field: mono.datagateway.v1.IntelClaimAudienceTarget suggested_team = 24;
   */ _define_property(this, "suggestedTeam", void 0), /**
   * author (root row); lets clients render "You"
   *
   * @generated from field: string recorded_by_user_id = 25;
   */ _define_property(this, "recordedByUserId", ""), /**
   * v2.3: EVENT / MEETING of the HEARD_AT link, else empty (then venue_text)
   *
   * @generated from field: mono.datagateway.v1.RegistryRef heard_at = 26;
   */ _define_property(this, "heardAt", void 0), /**
   * v2.3: set only for REG-56 competitor statements
   *
   * @generated from field: mono.datagateway.v1.IntelClaimFacet facet = 27;
   */ _define_property(this, "facet", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IntelClaim, "runtime", proto3);
_define_property(IntelClaim, "typeName", "mono.datagateway.v1.IntelClaim");
_define_property(IntelClaim, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "lineage_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "statement",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "claim_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "heard_from",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 7,
            name: "heard_from_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "venue_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "heard_on",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "recorded_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "verification",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "verification_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "corroborated_by",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 15,
            name: "source_artifact",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 16,
            name: "citability",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "expires_on",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "is_expired",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 19,
            name: "links",
            kind: "message",
            T: IntelClaimLink,
            repeated: true
        },
        {
            no: 20,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 21,
            name: "version_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 22,
            name: "audience",
            kind: "message",
            T: IntelClaimAudience
        },
        {
            no: 23,
            name: "viewer_is_author",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 24,
            name: "suggested_team",
            kind: "message",
            T: IntelClaimAudienceTarget
        },
        {
            no: 25,
            name: "recorded_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "heard_at",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 27,
            name: "facet",
            kind: "message",
            T: IntelClaimFacet
        }
    ]));
/**
 * v2.2 (I-11): audience model. kind USER = identity.users.id; SCOPE_NODE =
 * authz.scope_node.id (a team: everyone assigned at or below it); PRINCIPAL_GROUP
 * = authz.principal_group.id. Same target kinds as Library release audiences.
 *
 * @generated from message mono.datagateway.v1.IntelClaimAudienceTarget
 */ export class IntelClaimAudienceTarget extends Message {
    static fromBinary(bytes, options) {
        return new IntelClaimAudienceTarget().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IntelClaimAudienceTarget().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IntelClaimAudienceTarget().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IntelClaimAudienceTarget, a, b);
    }
    constructor(data){
        super(), /**
   * USER | SCOPE_NODE | PRINCIPAL_GROUP
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * output only; "" for a deleted target (rendered "Removed group")
   *
   * @generated from field: string display_name = 3;
   */ _define_property(this, "displayName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(IntelClaimAudienceTarget, "runtime", proto3);
_define_property(IntelClaimAudienceTarget, "typeName", "mono.datagateway.v1.IntelClaimAudienceTarget");
_define_property(IntelClaimAudienceTarget, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.IntelClaimAudience
 */ export class IntelClaimAudience extends Message {
    static fromBinary(bytes, options) {
        return new IntelClaimAudience().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IntelClaimAudience().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IntelClaimAudience().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IntelClaimAudience, a, b);
    }
    constructor(data){
        super(), /**
   * head row of govcon.intel_claim_audiences
   *
   * @generated from field: string audience_id = 1;
   */ _define_property(this, "audienceId", ""), /**
   * PERSONAL | TEAM | PEOPLE | EVERYONE
   *
   * @generated from field: string level = 2;
   */ _define_property(this, "level", ""), /**
   * only returned to the author; others get [] (they see `summary`)
   *
   * @generated from field: repeated mono.datagateway.v1.IntelClaimAudienceTarget targets = 3;
   */ _define_property(this, "targets", []), /**
   * "Only you" | "Only {author}" | "{team}" | "{team} + 2 more" | "{n} people" | "{n} people, {m} teams" | "Everyone who can see intel"
   *
   * @generated from field: string summary = 4;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: google.protobuf.Timestamp changed_at = 5;
   */ _define_property(this, "changedAt", void 0), /**
   * @generated from field: string changed_by_name = 6;
   */ _define_property(this, "changedByName", ""), /**
   * audience versions in the lineage (1 = never changed)
   *
   * @generated from field: int32 change_count = 7;
   */ _define_property(this, "changeCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IntelClaimAudience, "runtime", proto3);
_define_property(IntelClaimAudience, "typeName", "mono.datagateway.v1.IntelClaimAudience");
_define_property(IntelClaimAudience, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audience_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "targets",
            kind: "message",
            T: IntelClaimAudienceTarget,
            repeated: true
        },
        {
            no: 4,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "changed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "changed_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "change_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.IntelClaimAudienceInput
 */ export class IntelClaimAudienceInput extends Message {
    static fromBinary(bytes, options) {
        return new IntelClaimAudienceInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IntelClaimAudienceInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IntelClaimAudienceInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IntelClaimAudienceInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool everyone = 1;
   */ _define_property(this, "everyone", false), /**
   * ≤ 25; display_name ignored; empty + everyone=false = PERSONAL
   *
   * @generated from field: repeated mono.datagateway.v1.IntelClaimAudienceTarget targets = 2;
   */ _define_property(this, "targets", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IntelClaimAudienceInput, "runtime", proto3);
_define_property(IntelClaimAudienceInput, "typeName", "mono.datagateway.v1.IntelClaimAudienceInput");
_define_property(IntelClaimAudienceInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "everyone",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "targets",
            kind: "message",
            T: IntelClaimAudienceTarget,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetIntelClaimAudienceRequest
 */ export class SetIntelClaimAudienceRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetIntelClaimAudienceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetIntelClaimAudienceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetIntelClaimAudienceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetIntelClaimAudienceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * any version id of the lineage
   *
   * @generated from field: string claim_id = 1;
   */ _define_property(this, "claimId", ""), /**
   * @generated from field: mono.datagateway.v1.IntelClaimAudienceInput audience = 2;
   */ _define_property(this, "audience", void 0), /**
   * optimistic concurrency: must equal the current head (else Aborted)
   *
   * @generated from field: string expected_audience_id = 3;
   */ _define_property(this, "expectedAudienceId", ""), /**
   * optional, ≤ 500 ("ready for the capture team")
   *
   * @generated from field: string note = 4;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetIntelClaimAudienceRequest, "runtime", proto3);
_define_property(SetIntelClaimAudienceRequest, "typeName", "mono.datagateway.v1.SetIntelClaimAudienceRequest");
_define_property(SetIntelClaimAudienceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "claim_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "audience",
            kind: "message",
            T: IntelClaimAudienceInput
        },
        {
            no: 3,
            name: "expected_audience_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetIntelClaimAudienceResponse
 */ export class SetIntelClaimAudienceResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetIntelClaimAudienceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetIntelClaimAudienceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetIntelClaimAudienceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetIntelClaimAudienceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.IntelClaim claim = 1;
   */ _define_property(this, "claim", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetIntelClaimAudienceResponse, "runtime", proto3);
_define_property(SetIntelClaimAudienceResponse, "typeName", "mono.datagateway.v1.SetIntelClaimAudienceResponse");
_define_property(SetIntelClaimAudienceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "claim",
            kind: "message",
            T: IntelClaim
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListIntelClaimAudienceHistoryRequest
 */ export class ListIntelClaimAudienceHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListIntelClaimAudienceHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListIntelClaimAudienceHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListIntelClaimAudienceHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListIntelClaimAudienceHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string claim_id = 1;
   */ _define_property(this, "claimId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListIntelClaimAudienceHistoryRequest, "runtime", proto3);
_define_property(ListIntelClaimAudienceHistoryRequest, "typeName", "mono.datagateway.v1.ListIntelClaimAudienceHistoryRequest");
_define_property(ListIntelClaimAudienceHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "claim_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.IntelClaimAudienceChange
 */ export class IntelClaimAudienceChange extends Message {
    static fromBinary(bytes, options) {
        return new IntelClaimAudienceChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IntelClaimAudienceChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IntelClaimAudienceChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IntelClaimAudienceChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string audience_id = 1;
   */ _define_property(this, "audienceId", ""), /**
   * @generated from field: string level = 2;
   */ _define_property(this, "level", ""), /**
   * @generated from field: string summary = 3;
   */ _define_property(this, "summary", ""), /**
   * author only (else [])
   *
   * @generated from field: repeated mono.datagateway.v1.IntelClaimAudienceTarget targets = 4;
   */ _define_property(this, "targets", []), /**
   * @generated from field: string changed_by_name = 5;
   */ _define_property(this, "changedByName", ""), /**
   * @generated from field: google.protobuf.Timestamp changed_at = 6;
   */ _define_property(this, "changedAt", void 0), /**
   * @generated from field: string note = 7;
   */ _define_property(this, "note", ""), /**
   * CREATED | WIDENED | NARROWED | CHANGED
   *
   * @generated from field: string direction = 8;
   */ _define_property(this, "direction", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(IntelClaimAudienceChange, "runtime", proto3);
_define_property(IntelClaimAudienceChange, "typeName", "mono.datagateway.v1.IntelClaimAudienceChange");
_define_property(IntelClaimAudienceChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audience_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "targets",
            kind: "message",
            T: IntelClaimAudienceTarget,
            repeated: true
        },
        {
            no: 5,
            name: "changed_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "changed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "direction",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListIntelClaimAudienceHistoryResponse
 */ export class ListIntelClaimAudienceHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListIntelClaimAudienceHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListIntelClaimAudienceHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListIntelClaimAudienceHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListIntelClaimAudienceHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.IntelClaimAudienceChange changes = 1;
   */ _define_property(this, "changes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListIntelClaimAudienceHistoryResponse, "runtime", proto3);
_define_property(ListIntelClaimAudienceHistoryResponse, "typeName", "mono.datagateway.v1.ListIntelClaimAudienceHistoryResponse");
_define_property(ListIntelClaimAudienceHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "changes",
            kind: "message",
            T: IntelClaimAudienceChange,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateIntelClaimRequest
 */ export class CreateIntelClaimRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateIntelClaimRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateIntelClaimRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateIntelClaimRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateIntelClaimRequest, a, b);
    }
    constructor(data){
        super(), /**
   * caller uuid (idempotent create)
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string statement = 2;
   */ _define_property(this, "statement", ""), /**
   * @generated from field: string claim_kind = 3;
   */ _define_property(this, "claimKind", ""), /**
   * @generated from field: string source_type = 4;
   */ _define_property(this, "sourceType", ""), /**
   * v2.3: convenience — stored as a HEARD_FROM CONTACT link
   *
   * @generated from field: string heard_from_contact_id = 5;
   */ _define_property(this, "heardFromContactId", ""), /**
   * fallback byline
   *
   * @generated from field: string heard_from_text = 6;
   */ _define_property(this, "heardFromText", ""), /**
   * fallback venue
   *
   * @generated from field: string venue_text = 7;
   */ _define_property(this, "venueText", ""), /**
   * @generated from field: google.protobuf.Timestamp heard_on = 8;
   */ _define_property(this, "heardOn", void 0), /**
   * @generated from field: string confidence = 9;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: google.protobuf.Timestamp expires_on = 10;
   */ _define_property(this, "expiresOn", void 0), /**
   * @generated from field: string source_artifact_id = 11;
   */ _define_property(this, "sourceArtifactId", ""), /**
   * v2.3 (was subjects): ≥1 ABOUT or RELEVANT_TO, ≤20 total; name/resolved ignored on input
   *
   * @generated from field: repeated mono.datagateway.v1.IntelClaimLink links = 12;
   */ _define_property(this, "links", []), /**
   * v2.2: unset = PERSONAL ("Only me")
   *
   * @generated from field: mono.datagateway.v1.IntelClaimAudienceInput audience = 13;
   */ _define_property(this, "audience", void 0), /**
   * v2.3: REG-56 capture handler only
   *
   * @generated from field: mono.datagateway.v1.IntelClaimFacet facet = 14;
   */ _define_property(this, "facet", void 0), /**
   * v2.3 convenience ⇒ HEARD_AT EVENT link (GRW-36)
   *
   * @generated from field: string heard_at_event_id = 15;
   */ _define_property(this, "heardAtEventId", ""), /**
   * v2.3 convenience ⇒ HEARD_AT MEETING link (customer_interactions.id)
   *
   * @generated from field: string heard_at_meeting_id = 16;
   */ _define_property(this, "heardAtMeetingId", ""), /**
   * REG-02: the author declined to resolve the typed "heard from" name. When
   * false and heard_from_text names registry people, a REG-54 candidate
   * ("Is this …?", visible to the author only) is filed so confirming it
   * later adds the HEARD_FROM link as a new version.
   *
   * @generated from field: bool heard_from_keep_text = 17;
   */ _define_property(this, "heardFromKeepText", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateIntelClaimRequest, "runtime", proto3);
_define_property(CreateIntelClaimRequest, "typeName", "mono.datagateway.v1.CreateIntelClaimRequest");
_define_property(CreateIntelClaimRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "statement",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "claim_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "heard_from_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "heard_from_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "venue_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "heard_on",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "expires_on",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "links",
            kind: "message",
            T: IntelClaimLink,
            repeated: true
        },
        {
            no: 13,
            name: "audience",
            kind: "message",
            T: IntelClaimAudienceInput
        },
        {
            no: 14,
            name: "facet",
            kind: "message",
            T: IntelClaimFacet
        },
        {
            no: 15,
            name: "heard_at_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "heard_at_meeting_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "heard_from_keep_text",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateIntelClaimResponse
 */ export class CreateIntelClaimResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateIntelClaimResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateIntelClaimResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateIntelClaimResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateIntelClaimResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.IntelClaim claim = 1;
   */ _define_property(this, "claim", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateIntelClaimResponse, "runtime", proto3);
_define_property(CreateIntelClaimResponse, "typeName", "mono.datagateway.v1.CreateIntelClaimResponse");
_define_property(CreateIntelClaimResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "claim",
            kind: "message",
            T: IntelClaim
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListIntelClaimsRequest
 */ export class ListIntelClaimsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListIntelClaimsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListIntelClaimsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListIntelClaimsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListIntelClaimsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string subject_kind = 1;
   */ _define_property(this, "subjectKind", ""), /**
   * @generated from field: string subject_id = 2;
   */ _define_property(this, "subjectId", ""), /**
   * @generated from field: bool include_expired = 3;
   */ _define_property(this, "includeExpired", false), /**
   * @generated from field: bool include_retracted = 4;
   */ _define_property(this, "includeRetracted", false), /**
   * default 20
   *
   * @generated from field: int32 limit = 5;
   */ _define_property(this, "limit", 0), /**
   * v2.3: "" = any role; subject_kind/subject_id now mean target_kind/target_id (merge chains expanded)
   *
   * @generated from field: string link_role = 6;
   */ _define_property(this, "linkRole", ""), /**
   * v2.3 reconcile: OR-ed targets (≤ 50; GRW-25 seat + merged seats, GRW-20 pursuit + linked RFIs); when set, fields 1, 2, 6 are ignored
   *
   * @generated from field: repeated mono.datagateway.v1.IntelClaimLink links = 7;
   */ _define_property(this, "links", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListIntelClaimsRequest, "runtime", proto3);
_define_property(ListIntelClaimsRequest, "typeName", "mono.datagateway.v1.ListIntelClaimsRequest");
_define_property(ListIntelClaimsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "subject_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "subject_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "include_expired",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "include_retracted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "link_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "links",
            kind: "message",
            T: IntelClaimLink,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListIntelClaimsResponse
 */ export class ListIntelClaimsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListIntelClaimsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListIntelClaimsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListIntelClaimsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListIntelClaimsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.IntelClaim claims = 1;
   */ _define_property(this, "claims", []), /**
   * REG-03 / REG-43: FND-25 hearsay.write for the caller (the FE never
   * re-implements the rule; the server re-checks on every write).
   *
   * @generated from field: bool can_create = 3;
   */ _define_property(this, "canCreate", false), /**
   * "KIND/SOURCE" pairs the caller may create (every pair when can_create;
   * hearsay.write is not per kind today, so a later per-kind key needs no
   * proto change).
   *
   * @generated from field: repeated string can_create_kinds = 4;
   */ _define_property(this, "canCreateKinds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListIntelClaimsResponse, "runtime", proto3);
_define_property(ListIntelClaimsResponse, "typeName", "mono.datagateway.v1.ListIntelClaimsResponse");
_define_property(ListIntelClaimsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "claims",
            kind: "message",
            T: IntelClaim,
            repeated: true
        },
        {
            no: 3,
            name: "can_create",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "can_create_kinds",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * Internal read (DeliveryGatewayService.ListIntelClaimsForSubjects, REG-02).
 *
 * @generated from message mono.datagateway.v1.ListIntelClaimsForSubjectsRequest
 */ export class ListIntelClaimsForSubjectsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListIntelClaimsForSubjectsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListIntelClaimsForSubjectsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListIntelClaimsForSubjectsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListIntelClaimsForSubjectsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * 1–200 OR-ed {link_role?, target_kind, target_id} ("" role = any); merge
   * chains are expanded (REG-55). The caller vouches that the viewer may read
   * every target it passes.
   *
   * @generated from field: repeated mono.datagateway.v1.IntelClaimLink links = 2;
   */ _define_property(this, "links", []), /**
   * @generated from field: bool include_expired = 3;
   */ _define_property(this, "includeExpired", false), /**
   * WRT/PRP: true ⇒ only CITABLE (never HEARSAY)
   *
   * @generated from field: bool citable_only = 4;
   */ _define_property(this, "citableOnly", false), /**
   * Required (InvalidArgument when empty — fail closed). The § 4.1 rule is
   * evaluated for this user: own claims always, others under the hearsay.read
   * ceiling AND the audience. Assist runs as the user, so it sees exactly what
   * the user sees, including the user's personal claims.
   *
   * @generated from field: string viewer_user_id = 5;
   */ _define_property(this, "viewerUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListIntelClaimsForSubjectsRequest, "runtime", proto3);
_define_property(ListIntelClaimsForSubjectsRequest, "typeName", "mono.datagateway.v1.ListIntelClaimsForSubjectsRequest");
_define_property(ListIntelClaimsForSubjectsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "links",
            kind: "message",
            T: IntelClaimLink,
            repeated: true
        },
        {
            no: 3,
            name: "include_expired",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "citable_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "viewer_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Each claim carries audience.level + summary (label "[hearsay, unverified ·
 * {summary}]"), links, heard_from and heard_at. Names of access-controlled
 * links the request did not name are blank (the caller vouched only for the
 * targets it asked about).
 *
 * @generated from message mono.datagateway.v1.ListIntelClaimsForSubjectsResponse
 */ export class ListIntelClaimsForSubjectsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListIntelClaimsForSubjectsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListIntelClaimsForSubjectsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListIntelClaimsForSubjectsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListIntelClaimsForSubjectsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.IntelClaim claims = 1;
   */ _define_property(this, "claims", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListIntelClaimsForSubjectsResponse, "runtime", proto3);
_define_property(ListIntelClaimsForSubjectsResponse, "typeName", "mono.datagateway.v1.ListIntelClaimsForSubjectsResponse");
_define_property(ListIntelClaimsForSubjectsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "claims",
            kind: "message",
            T: IntelClaim,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateIntelClaimVerificationRequest
 */ export class UpdateIntelClaimVerificationRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateIntelClaimVerificationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateIntelClaimVerificationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateIntelClaimVerificationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateIntelClaimVerificationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * must be the current head
   *
   * @generated from field: string claim_id = 1;
   */ _define_property(this, "claimId", ""), /**
   * CORROBORATED | CONTRADICTED | UNVERIFIED
   *
   * @generated from field: string verification = 2;
   */ _define_property(this, "verification", ""), /**
   * @generated from field: string corroborated_by_artifact_id = 3;
   */ _define_property(this, "corroboratedByArtifactId", ""), /**
   * @generated from field: string note = 4;
   */ _define_property(this, "note", ""), /**
   * optional: CITABLE allowed only per DB check
   *
   * @generated from field: string citability = 5;
   */ _define_property(this, "citability", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateIntelClaimVerificationRequest, "runtime", proto3);
_define_property(UpdateIntelClaimVerificationRequest, "typeName", "mono.datagateway.v1.UpdateIntelClaimVerificationRequest");
_define_property(UpdateIntelClaimVerificationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "claim_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "verification",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "corroborated_by_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "citability",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateIntelClaimVerificationResponse
 */ export class UpdateIntelClaimVerificationResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateIntelClaimVerificationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateIntelClaimVerificationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateIntelClaimVerificationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateIntelClaimVerificationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.IntelClaim claim = 1;
   */ _define_property(this, "claim", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateIntelClaimVerificationResponse, "runtime", proto3);
_define_property(UpdateIntelClaimVerificationResponse, "typeName", "mono.datagateway.v1.UpdateIntelClaimVerificationResponse");
_define_property(UpdateIntelClaimVerificationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "claim",
            kind: "message",
            T: IntelClaim
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RetractIntelClaimRequest
 */ export class RetractIntelClaimRequest extends Message {
    static fromBinary(bytes, options) {
        return new RetractIntelClaimRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetractIntelClaimRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetractIntelClaimRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetractIntelClaimRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string claim_id = 1;
   */ _define_property(this, "claimId", ""), /**
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetractIntelClaimRequest, "runtime", proto3);
_define_property(RetractIntelClaimRequest, "typeName", "mono.datagateway.v1.RetractIntelClaimRequest");
_define_property(RetractIntelClaimRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "claim_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RetractIntelClaimResponse
 */ export class RetractIntelClaimResponse extends Message {
    static fromBinary(bytes, options) {
        return new RetractIntelClaimResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetractIntelClaimResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetractIntelClaimResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetractIntelClaimResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.IntelClaim claim = 1;
   */ _define_property(this, "claim", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetractIntelClaimResponse, "runtime", proto3);
_define_property(RetractIntelClaimResponse, "typeName", "mono.datagateway.v1.RetractIntelClaimResponse");
_define_property(RetractIntelClaimResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "claim",
            kind: "message",
            T: IntelClaim
        }
    ]));
/**
 * ======================= Review queue =======================
 *
 * @generated from message mono.datagateway.v1.ListRegistryReviewItemsRequest
 */ export class ListRegistryReviewItemsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRegistryReviewItemsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRegistryReviewItemsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRegistryReviewItemsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRegistryReviewItemsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * LCAT_CANDIDATE | MAPPING | PERIOD_COERCION | ENTITY_MATCH; empty = all implemented kinds
   *
   * @generated from field: repeated string kinds = 1;
   */ _define_property(this, "kinds", []), /**
   * @generated from field: string after_cursor = 2;
   */ _define_property(this, "afterCursor", ""), /**
   * default 50
   *
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRegistryReviewItemsRequest, "runtime", proto3);
_define_property(ListRegistryReviewItemsRequest, "typeName", "mono.datagateway.v1.ListRegistryReviewItemsRequest");
_define_property(ListRegistryReviewItemsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kinds",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 2,
            name: "after_cursor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviewField
 */ export class ReviewField extends Message {
    static fromBinary(bytes, options) {
        return new ReviewField().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewField().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewField().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewField, a, b);
    }
    constructor(data){
        super(), /**
   * "company", "vehicle", "education", "experience", "clearance"
   *
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string value = 3;
   */ _define_property(this, "value", ""), /**
   * SAME | DIFFERENT | NA
   *
   * @generated from field: string match = 4;
   */ _define_property(this, "match", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewField, "runtime", proto3);
_define_property(ReviewField, "typeName", "mono.datagateway.v1.ReviewField");
_define_property(ReviewField, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "match",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviewSide
 */ export class ReviewSide extends Message {
    static fromBinary(bytes, options) {
        return new ReviewSide().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewSide().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewSide().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewSide, a, b);
    }
    constructor(data){
        super(), /**
   * "As written", "Anchor", "Row A"
   *
   * @generated from field: string eyebrow = 1;
   */ _define_property(this, "eyebrow", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ReviewField fields = 3;
   */ _define_property(this, "fields", []), /**
   * @generated from field: mono.datagateway.v1.RegistryRef ref = 4;
   */ _define_property(this, "ref", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewSide, "runtime", proto3);
_define_property(ReviewSide, "typeName", "mono.datagateway.v1.ReviewSide");
_define_property(ReviewSide, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "eyebrow",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "fields",
            kind: "message",
            T: ReviewField,
            repeated: true
        },
        {
            no: 4,
            name: "ref",
            kind: "message",
            T: RegistryRef
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviewEvidence
 */ export class ReviewEvidence extends Message {
    static fromBinary(bytes, options) {
        return new ReviewEvidence().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewEvidence().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewEvidence().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewEvidence, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string text = 1;
   */ _define_property(this, "text", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef source = 2;
   */ _define_property(this, "source", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewEvidence, "runtime", proto3);
_define_property(ReviewEvidence, "typeName", "mono.datagateway.v1.ReviewEvidence");
_define_property(ReviewEvidence, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source",
            kind: "message",
            T: RegistryRef
        }
    ]));
/**
 * Ordered RPC steps. Payload is protobuf JSON; input_fields name values the
 * reviewer must supply. Later steps consume the prior response when named.
 *
 * @generated from message mono.datagateway.v1.ReviewAction
 */ export class ReviewAction extends Message {
    static fromBinary(bytes, options) {
        return new ReviewAction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewAction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewAction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewAction, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rpc = 1;
   */ _define_property(this, "rpc", ""), /**
   * @generated from field: string payload_json = 2;
   */ _define_property(this, "payloadJson", ""), /**
   * @generated from field: repeated string input_fields = 3;
   */ _define_property(this, "inputFields", []), /**
   * @generated from field: string revision_from_response = 4;
   */ _define_property(this, "revisionFromResponse", ""), /**
   * request field -> previous response field path
   *
   * @generated from field: map<string, string> payload_from_response = 5;
   */ _define_property(this, "payloadFromResponse", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewAction, "runtime", proto3);
_define_property(ReviewAction, "typeName", "mono.datagateway.v1.ReviewAction");
_define_property(ReviewAction, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rpc",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "payload_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "input_fields",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "revision_from_response",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "payload_from_response",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 9 /* ScalarType.STRING */ 
            }
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviewDecision
 */ export class ReviewDecision extends Message {
    static fromBinary(bytes, options) {
        return new ReviewDecision().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewDecision().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewDecision().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewDecision, a, b);
    }
    constructor(data){
        super(), /**
   * per kind, see REG-29 table
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: bool primary = 3;
   */ _define_property(this, "primary", false), /**
   * @generated from field: bool destructive = 4;
   */ _define_property(this, "destructive", false), /**
   * @generated from field: repeated mono.datagateway.v1.ReviewAction actions = 5;
   */ _define_property(this, "actions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewDecision, "runtime", proto3);
_define_property(ReviewDecision, "typeName", "mono.datagateway.v1.ReviewDecision");
_define_property(ReviewDecision, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "destructive",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "actions",
            kind: "message",
            T: ReviewAction,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegistryReviewItem
 */ export class RegistryReviewItem extends Message {
    static fromBinary(bytes, options) {
        return new RegistryReviewItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryReviewItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryReviewItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryReviewItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * the underlying row id (candidate / mapping / coercion)
   *
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * "{document} extraction", "proposed by {name}", "price-list parser", "people graph", "COR appointment letter"
   *
   * @generated from field: string source_label = 3;
   */ _define_property(this, "sourceLabel", ""), /**
   * 0 = none
   *
   * @generated from field: double confidence = 4;
   */ _define_property(this, "confidence", 0), /**
   * LOW | MEDIUM | HIGH | ""
   *
   * @generated from field: string confidence_band = 5;
   */ _define_property(this, "confidenceBand", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string subtitle = 7;
   */ _define_property(this, "subtitle", ""), /**
   * @generated from field: string question = 8;
   */ _define_property(this, "question", ""), /**
   * @generated from field: mono.datagateway.v1.ReviewSide left = 9;
   */ _define_property(this, "left", void 0), /**
   * @generated from field: mono.datagateway.v1.ReviewSide right = 10;
   */ _define_property(this, "right", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.ReviewEvidence evidence = 11;
   */ _define_property(this, "evidence", []), /**
   * @generated from field: string warning = 12;
   */ _define_property(this, "warning", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ReviewDecision decisions = 13;
   */ _define_property(this, "decisions", []), /**
   * @generated from field: string consequence_note = 14;
   */ _define_property(this, "consequenceNote", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 15;
   */ _define_property(this, "createdAt", void 0), /**
   * optimistic concurrency token passed back on decide
   *
   * @generated from field: int64 revision = 16;
   */ _define_property(this, "revision", protoInt64.zero), /**
   * @generated from field: string context_href = 17;
   */ _define_property(this, "contextHref", ""), /**
   * other ENTITY_MATCH candidates, each with its registry ref
   *
   * @generated from field: repeated mono.datagateway.v1.ReviewSide alternatives = 18;
   */ _define_property(this, "alternatives", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryReviewItem, "runtime", proto3);
_define_property(RegistryReviewItem, "typeName", "mono.datagateway.v1.RegistryReviewItem");
_define_property(RegistryReviewItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "confidence_band",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "subtitle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "question",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "left",
            kind: "message",
            T: ReviewSide
        },
        {
            no: 10,
            name: "right",
            kind: "message",
            T: ReviewSide
        },
        {
            no: 11,
            name: "evidence",
            kind: "message",
            T: ReviewEvidence,
            repeated: true
        },
        {
            no: 12,
            name: "warning",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "decisions",
            kind: "message",
            T: ReviewDecision,
            repeated: true
        },
        {
            no: 14,
            name: "consequence_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 17,
            name: "context_href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "alternatives",
            kind: "message",
            T: ReviewSide,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviewKindCount
 */ export class ReviewKindCount extends Message {
    static fromBinary(bytes, options) {
        return new ReviewKindCount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewKindCount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewKindCount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewKindCount, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: int32 count = 2;
   */ _define_property(this, "count", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewKindCount, "runtime", proto3);
_define_property(ReviewKindCount, "typeName", "mono.datagateway.v1.ReviewKindCount");
_define_property(ReviewKindCount, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRegistryReviewItemsResponse
 */ export class ListRegistryReviewItemsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRegistryReviewItemsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRegistryReviewItemsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRegistryReviewItemsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRegistryReviewItemsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RegistryReviewItem items = 1;
   */ _define_property(this, "items", []), /**
   * over items the caller may DECIDE
   *
   * @generated from field: repeated mono.datagateway.v1.ReviewKindCount counts = 2;
   */ _define_property(this, "counts", []), /**
   * @generated from field: string next_cursor = 3;
   */ _define_property(this, "nextCursor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRegistryReviewItemsResponse, "runtime", proto3);
_define_property(ListRegistryReviewItemsResponse, "typeName", "mono.datagateway.v1.ListRegistryReviewItemsResponse");
_define_property(ListRegistryReviewItemsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "items",
            kind: "message",
            T: RegistryReviewItem,
            repeated: true
        },
        {
            no: 2,
            name: "counts",
            kind: "message",
            T: ReviewKindCount,
            repeated: true
        },
        {
            no: 3,
            name: "next_cursor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRegistryReviewItemRequest
 */ export class GetRegistryReviewItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRegistryReviewItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRegistryReviewItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRegistryReviewItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRegistryReviewItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRegistryReviewItemRequest, "runtime", proto3);
_define_property(GetRegistryReviewItemRequest, "typeName", "mono.datagateway.v1.GetRegistryReviewItemRequest");
_define_property(GetRegistryReviewItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRegistryReviewItemResponse
 */ export class GetRegistryReviewItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRegistryReviewItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRegistryReviewItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRegistryReviewItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRegistryReviewItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryReviewItem item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRegistryReviewItemResponse, "runtime", proto3);
_define_property(GetRegistryReviewItemResponse, "typeName", "mono.datagateway.v1.GetRegistryReviewItemResponse");
_define_property(GetRegistryReviewItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: RegistryReviewItem
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DecideContactMergeCandidateRequest
 */ export class DecideContactMergeCandidateRequest extends Message {
    static fromBinary(bytes, options) {
        return new DecideContactMergeCandidateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideContactMergeCandidateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideContactMergeCandidateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideContactMergeCandidateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * MERGE | KEEP_SEPARATE
   *
   * @generated from field: string decision = 2;
   */ _define_property(this, "decision", ""), /**
   * MERGE only; must be contact_a or contact_b
   *
   * @generated from field: string survivor_contact_id = 3;
   */ _define_property(this, "survivorContactId", ""), /**
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideContactMergeCandidateRequest, "runtime", proto3);
_define_property(DecideContactMergeCandidateRequest, "typeName", "mono.datagateway.v1.DecideContactMergeCandidateRequest");
_define_property(DecideContactMergeCandidateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "survivor_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DecideContactMergeCandidateResponse
 */ export class DecideContactMergeCandidateResponse extends Message {
    static fromBinary(bytes, options) {
        return new DecideContactMergeCandidateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideContactMergeCandidateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideContactMergeCandidateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideContactMergeCandidateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryReviewItem item = 1;
   */ _define_property(this, "item", void 0), /**
   * @generated from field: string merge_event_id = 2;
   */ _define_property(this, "mergeEventId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideContactMergeCandidateResponse, "runtime", proto3);
_define_property(DecideContactMergeCandidateResponse, "typeName", "mono.datagateway.v1.DecideContactMergeCandidateResponse");
_define_property(DecideContactMergeCandidateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: RegistryReviewItem
        },
        {
            no: 2,
            name: "merge_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DecideContactEmploymentCandidateRequest
 */ export class DecideContactEmploymentCandidateRequest extends Message {
    static fromBinary(bytes, options) {
        return new DecideContactEmploymentCandidateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideContactEmploymentCandidateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideContactEmploymentCandidateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideContactEmploymentCandidateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * ACCEPT | REJECT
   *
   * @generated from field: string decision = 2;
   */ _define_property(this, "decision", ""), /**
   * ACCEPT: override the suggested bind target; "" = use candidate's
   *
   * @generated from field: string bind_contact_id = 3;
   */ _define_property(this, "bindContactId", ""), /**
   * ACCEPT: create a new contact from proposed_contact
   *
   * @generated from field: bool mint_new_contact = 4;
   */ _define_property(this, "mintNewContact", false), /**
   * ACCEPT: end end_previous_employment_id at start_date−1
   *
   * @generated from field: bool end_previous = 5;
   */ _define_property(this, "endPrevious", false), /**
   * @generated from field: string reason = 6;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideContactEmploymentCandidateRequest, "runtime", proto3);
_define_property(DecideContactEmploymentCandidateRequest, "typeName", "mono.datagateway.v1.DecideContactEmploymentCandidateRequest");
_define_property(DecideContactEmploymentCandidateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "bind_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "mint_new_contact",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "end_previous",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DecideContactEmploymentCandidateResponse
 */ export class DecideContactEmploymentCandidateResponse extends Message {
    static fromBinary(bytes, options) {
        return new DecideContactEmploymentCandidateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideContactEmploymentCandidateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideContactEmploymentCandidateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideContactEmploymentCandidateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryReviewItem item = 1;
   */ _define_property(this, "item", void 0), /**
   * @generated from field: string employment_id = 2;
   */ _define_property(this, "employmentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideContactEmploymentCandidateResponse, "runtime", proto3);
_define_property(DecideContactEmploymentCandidateResponse, "typeName", "mono.datagateway.v1.DecideContactEmploymentCandidateResponse");
_define_property(DecideContactEmploymentCandidateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: RegistryReviewItem
        },
        {
            no: 2,
            name: "employment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRatePeriodCoercionsRequest
 */ export class ListRatePeriodCoercionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRatePeriodCoercionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRatePeriodCoercionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRatePeriodCoercionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRatePeriodCoercionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string generation_id = 1;
   */ _define_property(this, "generationId", ""), /**
   * @generated from field: string status = 2;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRatePeriodCoercionsRequest, "runtime", proto3);
_define_property(ListRatePeriodCoercionsRequest, "typeName", "mono.datagateway.v1.ListRatePeriodCoercionsRequest");
_define_property(ListRatePeriodCoercionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "generation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RatePeriodCoercion
 */ export class RatePeriodCoercion extends Message {
    static fromBinary(bytes, options) {
        return new RatePeriodCoercion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RatePeriodCoercion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RatePeriodCoercion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RatePeriodCoercion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string generation_id = 2;
   */ _define_property(this, "generationId", ""), /**
   * @generated from field: string generation_title = 3;
   */ _define_property(this, "generationTitle", ""), /**
   * @generated from field: string period_label = 4;
   */ _define_property(this, "periodLabel", ""), /**
   * @generated from field: string column_key = 5;
   */ _define_property(this, "columnKey", ""), /**
   * @generated from field: string suggested_kind = 6;
   */ _define_property(this, "suggestedKind", ""), /**
   * @generated from field: google.protobuf.Timestamp suggested_start = 7;
   */ _define_property(this, "suggestedStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp suggested_end = 8;
   */ _define_property(this, "suggestedEnd", void 0), /**
   * @generated from field: string suggested_rule = 9;
   */ _define_property(this, "suggestedRule", ""), /**
   * @generated from field: double suggested_confidence = 10;
   */ _define_property(this, "suggestedConfidence", 0), /**
   * @generated from field: string alternatives_json = 11;
   */ _define_property(this, "alternativesJson", ""), /**
   * @generated from field: string conflict_notes_json = 12;
   */ _define_property(this, "conflictNotesJson", ""), /**
   * @generated from field: string status = 13;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string decided_kind = 14;
   */ _define_property(this, "decidedKind", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_start = 15;
   */ _define_property(this, "decidedStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp decided_end = 16;
   */ _define_property(this, "decidedEnd", void 0), /**
   * @generated from field: string decided_rule = 17;
   */ _define_property(this, "decidedRule", ""), /**
   * @generated from field: string decided_by_name = 18;
   */ _define_property(this, "decidedByName", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 19;
   */ _define_property(this, "decidedAt", void 0), /**
   * @generated from field: int32 affected_observation_count = 20;
   */ _define_property(this, "affectedObservationCount", 0), /**
   * @generated from field: string supersedes_id = 21;
   */ _define_property(this, "supersedesId", ""), /**
   * @generated from field: string decided_by = 22;
   */ _define_property(this, "decidedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RatePeriodCoercion, "runtime", proto3);
_define_property(RatePeriodCoercion, "typeName", "mono.datagateway.v1.RatePeriodCoercion");
_define_property(RatePeriodCoercion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "generation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "generation_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "column_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "suggested_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "suggested_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "suggested_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "suggested_rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "suggested_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "alternatives_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "conflict_notes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "decided_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "decided_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "decided_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "decided_rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "decided_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 20,
            name: "affected_observation_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 21,
            name: "supersedes_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRatePeriodCoercionsResponse
 */ export class ListRatePeriodCoercionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRatePeriodCoercionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRatePeriodCoercionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRatePeriodCoercionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRatePeriodCoercionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RatePeriodCoercion coercions = 1;
   */ _define_property(this, "coercions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRatePeriodCoercionsResponse, "runtime", proto3);
_define_property(ListRatePeriodCoercionsResponse, "typeName", "mono.datagateway.v1.ListRatePeriodCoercionsResponse");
_define_property(ListRatePeriodCoercionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "coercions",
            kind: "message",
            T: RatePeriodCoercion,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DecideRatePeriodCoercionRequest
 */ export class DecideRatePeriodCoercionRequest extends Message {
    static fromBinary(bytes, options) {
        return new DecideRatePeriodCoercionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideRatePeriodCoercionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideRatePeriodCoercionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideRatePeriodCoercionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * HUMAN_FY | HUMAN_CONTRACT_YEAR | HUMAN_MANUAL
   *
   * @generated from field: string decided_rule = 2;
   */ _define_property(this, "decidedRule", ""), /**
   * HUMAN_MANUAL only (others derive)
   *
   * @generated from field: google.protobuf.Timestamp start = 3;
   */ _define_property(this, "start", void 0), /**
   * @generated from field: google.protobuf.Timestamp end = 4;
   */ _define_property(this, "end", void 0), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideRatePeriodCoercionRequest, "runtime", proto3);
_define_property(DecideRatePeriodCoercionRequest, "typeName", "mono.datagateway.v1.DecideRatePeriodCoercionRequest");
_define_property(DecideRatePeriodCoercionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "decided_rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DecideRatePeriodCoercionResponse
 */ export class DecideRatePeriodCoercionResponse extends Message {
    static fromBinary(bytes, options) {
        return new DecideRatePeriodCoercionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideRatePeriodCoercionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideRatePeriodCoercionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideRatePeriodCoercionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RatePeriodCoercion coercion = 1;
   */ _define_property(this, "coercion", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideRatePeriodCoercionResponse, "runtime", proto3);
_define_property(DecideRatePeriodCoercionResponse, "typeName", "mono.datagateway.v1.DecideRatePeriodCoercionResponse");
_define_property(DecideRatePeriodCoercionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "coercion",
            kind: "message",
            T: RatePeriodCoercion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegistryRecordServiceSetPricingSheetContractStartRequest
 */ export class RegistryRecordServiceSetPricingSheetContractStartRequest extends Message {
    static fromBinary(bytes, options) {
        return new RegistryRecordServiceSetPricingSheetContractStartRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryRecordServiceSetPricingSheetContractStartRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryRecordServiceSetPricingSheetContractStartRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryRecordServiceSetPricingSheetContractStartRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string generation_id = 1;
   */ _define_property(this, "generationId", ""), /**
   * @generated from field: google.protobuf.Timestamp contract_start = 2;
   */ _define_property(this, "contractStart", void 0), /**
   * required when a start is already set
   *
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryRecordServiceSetPricingSheetContractStartRequest, "runtime", proto3);
_define_property(RegistryRecordServiceSetPricingSheetContractStartRequest, "typeName", "mono.datagateway.v1.RegistryRecordServiceSetPricingSheetContractStartRequest");
_define_property(RegistryRecordServiceSetPricingSheetContractStartRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "generation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegistryRecordServiceSetPricingSheetContractStartResponse
 */ export class RegistryRecordServiceSetPricingSheetContractStartResponse extends Message {
    static fromBinary(bytes, options) {
        return new RegistryRecordServiceSetPricingSheetContractStartResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryRecordServiceSetPricingSheetContractStartResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryRecordServiceSetPricingSheetContractStartResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryRecordServiceSetPricingSheetContractStartResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: google.protobuf.Timestamp contract_start = 1;
   */ _define_property(this, "contractStart", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.RatePeriodCoercion coercions = 2;
   */ _define_property(this, "coercions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryRecordServiceSetPricingSheetContractStartResponse, "runtime", proto3);
_define_property(RegistryRecordServiceSetPricingSheetContractStartResponse, "typeName", "mono.datagateway.v1.RegistryRecordServiceSetPricingSheetContractStartResponse");
_define_property(RegistryRecordServiceSetPricingSheetContractStartResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 2,
            name: "coercions",
            kind: "message",
            T: RatePeriodCoercion,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DecideRateBurdenBasisRequest
 */ export class DecideRateBurdenBasisRequest extends Message {
    static fromBinary(bytes, options) {
        return new DecideRateBurdenBasisRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideRateBurdenBasisRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideRateBurdenBasisRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideRateBurdenBasisRequest, a, b);
    }
    constructor(data){
        super(), /**
   * rate_burden_decisions.id
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * FULLY_BURDENED | BURDENED_NO_FEE | UNBURDENED | UNKNOWN
   *
   * @generated from field: string burden_basis = 2;
   */ _define_property(this, "burdenBasis", ""), /**
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideRateBurdenBasisRequest, "runtime", proto3);
_define_property(DecideRateBurdenBasisRequest, "typeName", "mono.datagateway.v1.DecideRateBurdenBasisRequest");
_define_property(DecideRateBurdenBasisRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "burden_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DecideRateBurdenBasisResponse
 */ export class DecideRateBurdenBasisResponse extends Message {
    static fromBinary(bytes, options) {
        return new DecideRateBurdenBasisResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideRateBurdenBasisResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideRateBurdenBasisResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideRateBurdenBasisResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryReviewItem item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideRateBurdenBasisResponse, "runtime", proto3);
_define_property(DecideRateBurdenBasisResponse, "typeName", "mono.datagateway.v1.DecideRateBurdenBasisResponse");
_define_property(DecideRateBurdenBasisResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: RegistryReviewItem
        }
    ]));
/**
 * ======================= People movement =======================
 *
 * @generated from message mono.datagateway.v1.ListOrgSeatsRequest
 */ export class ListOrgSeatsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOrgSeatsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOrgSeatsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOrgSeatsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOrgSeatsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * COMPANY | GOVERNMENT_ORG
   *
   * @generated from field: string employer_kind = 1;
   */ _define_property(this, "employerKind", ""), /**
   * @generated from field: string employer_id = 2;
   */ _define_property(this, "employerId", ""), /**
   * unset = today; used for kpis + vacancy labels
   *
   * @generated from field: google.protobuf.Timestamp as_of = 3;
   */ _define_property(this, "asOf", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOrgSeatsRequest, "runtime", proto3);
_define_property(ListOrgSeatsRequest, "typeName", "mono.datagateway.v1.ListOrgSeatsRequest");
_define_property(ListOrgSeatsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "employer_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "employer_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "as_of",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SeatHolder
 */ export class SeatHolder extends Message {
    static fromBinary(bytes, options) {
        return new SeatHolder().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SeatHolder().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SeatHolder().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SeatHolder, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string employment_id = 1;
   */ _define_property(this, "employmentId", ""), /**
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string contact_name = 3;
   */ _define_property(this, "contactName", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: google.protobuf.Timestamp start_date = 5;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 6;
   */ _define_property(this, "endDate", void 0), /**
   * derived origin; empty = none known
   *
   * @generated from field: mono.datagateway.v1.RegistryRef came_from = 7;
   */ _define_property(this, "cameFrom", void 0), /**
   * derived destination
   *
   * @generated from field: mono.datagateway.v1.RegistryRef went_to = 8;
   */ _define_property(this, "wentTo", void 0), /**
   * "Retired" when no registry employer
   *
   * @generated from field: string went_to_text = 9;
   */ _define_property(this, "wentToText", ""), /**
   * @generated from field: string end_reason = 10;
   */ _define_property(this, "endReason", ""), /**
   * @generated from field: mono.datagateway.v1.RegistrySourceLabel source = 11;
   */ _define_property(this, "source", void 0), /**
   * stated | inferred | unknown (start_date unset = unknown, never invented)
   *
   * @generated from field: string date_basis = 12;
   */ _define_property(this, "dateBasis", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SeatHolder, "runtime", proto3);
_define_property(SeatHolder, "typeName", "mono.datagateway.v1.SeatHolder");
_define_property(SeatHolder, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "employment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contact_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "came_from",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 8,
            name: "went_to",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 9,
            name: "went_to_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "end_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "source",
            kind: "message",
            T: RegistrySourceLabel
        },
        {
            no: 12,
            name: "date_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.OrgSeat
 */ export class OrgSeat extends Message {
    static fromBinary(bytes, options) {
        return new OrgSeat().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OrgSeat().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OrgSeat().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OrgSeat, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string parent_seat_id = 2;
   */ _define_property(this, "parentSeatId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: int32 sort_order = 4;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: google.protobuf.Timestamp created_on = 5;
   */ _define_property(this, "createdOn", void 0), /**
   * @generated from field: google.protobuf.Timestamp retired_on = 6;
   */ _define_property(this, "retiredOn", void 0), /**
   * oldest first
   *
   * @generated from field: repeated mono.datagateway.v1.SeatHolder holders = 7;
   */ _define_property(this, "holders", []), /**
   * @generated from field: int64 revision = 8;
   */ _define_property(this, "revision", protoInt64.zero), /**
   * v2.2: '' | contracting_officer | contract_specialist | cor | program_manager | stakeholder (GOVERNMENT_ORG seats only)
   *
   * @generated from field: string graph_role = 9;
   */ _define_property(this, "graphRole", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OrgSeat, "runtime", proto3);
_define_property(OrgSeat, "typeName", "mono.datagateway.v1.OrgSeat");
_define_property(OrgSeat, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "parent_seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "created_on",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "retired_on",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "holders",
            kind: "message",
            T: SeatHolder,
            repeated: true
        },
        {
            no: 8,
            name: "revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 9,
            name: "graph_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GovOrgPublicParent
 */ export class GovOrgPublicParent extends Message {
    static fromBinary(bytes, options) {
        return new GovOrgPublicParent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovOrgPublicParent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovOrgPublicParent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovOrgPublicParent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryRef parent = 1;
   */ _define_property(this, "parent", void 0), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string source = 3;
   */ _define_property(this, "source", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovOrgPublicParent, "runtime", proto3);
_define_property(GovOrgPublicParent, "typeName", "mono.datagateway.v1.GovOrgPublicParent");
_define_property(GovOrgPublicParent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "parent",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * v2.3 (D-SOR, was GraphRoleHolder): a PUBLIC record of a person at this office (REG-58
 * public_record people, e.g. a SAM notice POC) who is not in the registry — shown with
 * "Add to registry" (REG-54 promote), never copied into seats or employments.
 *
 * @generated from message mono.datagateway.v1.PublicRoleRecord
 */ export class PublicRoleRecord extends Message {
    static fromBinary(bytes, options) {
        return new PublicRoleRecord().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PublicRoleRecord().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PublicRoleRecord().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PublicRoleRecord, a, b);
    }
    constructor(data){
        super(), /**
   * REG-54 grammar, e.g. notice_poc:<notice>:<email>
   *
   * @generated from field: string public_key = 7;
   */ _define_property(this, "publicKey", ""), /**
   * always '' (registry people are seat holders or employments)
   *
   * @generated from field: string contact_id = 1;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string display_name = 2;
   */ _define_property(this, "displayName", ""), /**
   * role edge_type
   *
   * @generated from field: string role = 3;
   */ _define_property(this, "role", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 4;
   */ _define_property(this, "effectiveDate", void 0), /**
   * edge source (USAspending | SAM.gov | user:<id> | registry_seat)
   *
   * @generated from field: string source = 5;
   */ _define_property(this, "source", ""), /**
   * @generated from field: double confidence = 6;
   */ _define_property(this, "confidence", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PublicRoleRecord, "runtime", proto3);
_define_property(PublicRoleRecord, "typeName", "mono.datagateway.v1.PublicRoleRecord");
_define_property(PublicRoleRecord, "fields", proto3.util.newFieldList(()=>[
        {
            no: 7,
            name: "public_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 1,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.OrgSeatKpis
 */ export class OrgSeatKpis extends Message {
    static fromBinary(bytes, options) {
        return new OrgSeatKpis().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OrgSeatKpis().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OrgSeatKpis().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OrgSeatKpis, a, b);
    }
    constructor(data){
        super(), /**
   * seats existing at as_of with a current holder
   *
   * @generated from field: int32 roles_filled = 1;
   */ _define_property(this, "rolesFilled", 0), /**
   * seats existing at as_of (created_on ≤ as_of, not retired)
   *
   * @generated from field: int32 roles_total = 2;
   */ _define_property(this, "rolesTotal", 0), /**
   * current holders with a came_from
   *
   * @generated from field: int32 came_from_outside = 3;
   */ _define_property(this, "cameFromOutside", 0), /**
   * start year == as_of year
   *
   * @generated from field: repeated mono.datagateway.v1.SeatHolder joined = 4;
   */ _define_property(this, "joined", []), /**
   * end year == as_of year
   *
   * @generated from field: repeated mono.datagateway.v1.SeatHolder left = 5;
   */ _define_property(this, "left", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OrgSeatKpis, "runtime", proto3);
_define_property(OrgSeatKpis, "typeName", "mono.datagateway.v1.OrgSeatKpis");
_define_property(OrgSeatKpis, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "roles_filled",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "roles_total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "came_from_outside",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "joined",
            kind: "message",
            T: SeatHolder,
            repeated: true
        },
        {
            no: 5,
            name: "left",
            kind: "message",
            T: SeatHolder,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOrgSeatsResponse
 */ export class ListOrgSeatsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOrgSeatsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOrgSeatsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOrgSeatsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOrgSeatsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryRef employer = 1;
   */ _define_property(this, "employer", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.OrgSeat seats = 2;
   */ _define_property(this, "seats", []), /**
   * @generated from field: mono.datagateway.v1.OrgSeatKpis kpis = 3;
   */ _define_property(this, "kpis", void 0), /**
   * employer is our own company (Locked 2)
   *
   * @generated from field: bool seats_not_allowed = 4;
   */ _define_property(this, "seatsNotAllowed", false), /**
   * v2.3 (was graph_role_holders): GOVERNMENT_ORG employers only
   *
   * @generated from field: repeated mono.datagateway.v1.PublicRoleRecord public_people = 5;
   */ _define_property(this, "publicPeople", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOrgSeatsResponse, "runtime", proto3);
_define_property(ListOrgSeatsResponse, "typeName", "mono.datagateway.v1.ListOrgSeatsResponse");
_define_property(ListOrgSeatsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "employer",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 2,
            name: "seats",
            kind: "message",
            T: OrgSeat,
            repeated: true
        },
        {
            no: 3,
            name: "kpis",
            kind: "message",
            T: OrgSeatKpis
        },
        {
            no: 4,
            name: "seats_not_allowed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "public_people",
            kind: "message",
            T: PublicRoleRecord,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveOrgSeatRequest
 */ export class SaveOrgSeatRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveOrgSeatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveOrgSeatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveOrgSeatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveOrgSeatRequest, a, b);
    }
    constructor(data){
        super(), /**
   * caller uuid; create when new
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string employer_kind = 2;
   */ _define_property(this, "employerKind", ""), /**
   * @generated from field: string employer_id = 3;
   */ _define_property(this, "employerId", ""), /**
   * @generated from field: string parent_seat_id = 4;
   */ _define_property(this, "parentSeatId", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: int32 sort_order = 6;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: google.protobuf.Timestamp created_on = 7;
   */ _define_property(this, "createdOn", void 0), /**
   * stored in evidence.citation_text; empty keeps the stored note on update
   *
   * @generated from field: string source_note = 8;
   */ _define_property(this, "sourceNote", ""), /**
   * 0 creates
   *
   * @generated from field: int64 expected_revision = 9;
   */ _define_property(this, "expectedRevision", protoInt64.zero), /**
   * v2.2: GOVERNMENT_ORG only (InvalidArgument for COMPANY)
   *
   * @generated from field: string graph_role = 10;
   */ _define_property(this, "graphRole", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveOrgSeatRequest, "runtime", proto3);
_define_property(SaveOrgSeatRequest, "typeName", "mono.datagateway.v1.SaveOrgSeatRequest");
_define_property(SaveOrgSeatRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "employer_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "employer_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "parent_seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "created_on",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "source_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 10,
            name: "graph_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveOrgSeatResponse
 */ export class SaveOrgSeatResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveOrgSeatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveOrgSeatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveOrgSeatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveOrgSeatResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OrgSeat seat = 1;
   */ _define_property(this, "seat", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveOrgSeatResponse, "runtime", proto3);
_define_property(SaveOrgSeatResponse, "typeName", "mono.datagateway.v1.SaveOrgSeatResponse");
_define_property(SaveOrgSeatResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seat",
            kind: "message",
            T: OrgSeat
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RetireOrgSeatRequest
 */ export class RetireOrgSeatRequest extends Message {
    static fromBinary(bytes, options) {
        return new RetireOrgSeatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetireOrgSeatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetireOrgSeatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetireOrgSeatRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: google.protobuf.Timestamp retired_on = 2;
   */ _define_property(this, "retiredOn", void 0), /**
   * @generated from field: int64 expected_revision = 3;
   */ _define_property(this, "expectedRevision", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetireOrgSeatRequest, "runtime", proto3);
_define_property(RetireOrgSeatRequest, "typeName", "mono.datagateway.v1.RetireOrgSeatRequest");
_define_property(RetireOrgSeatRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "retired_on",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RetireOrgSeatResponse
 */ export class RetireOrgSeatResponse extends Message {
    static fromBinary(bytes, options) {
        return new RetireOrgSeatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetireOrgSeatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetireOrgSeatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetireOrgSeatResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OrgSeat seat = 1;
   */ _define_property(this, "seat", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetireOrgSeatResponse, "runtime", proto3);
_define_property(RetireOrgSeatResponse, "typeName", "mono.datagateway.v1.RetireOrgSeatResponse");
_define_property(RetireOrgSeatResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seat",
            kind: "message",
            T: OrgSeat
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteOrgSeatRequest
 */ export class DeleteOrgSeatRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteOrgSeatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteOrgSeatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteOrgSeatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteOrgSeatRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteOrgSeatRequest, "runtime", proto3);
_define_property(DeleteOrgSeatRequest, "typeName", "mono.datagateway.v1.DeleteOrgSeatRequest");
_define_property(DeleteOrgSeatRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteOrgSeatResponse
 */ export class DeleteOrgSeatResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteOrgSeatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteOrgSeatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteOrgSeatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteOrgSeatResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteOrgSeatResponse, "runtime", proto3);
_define_property(DeleteOrgSeatResponse, "typeName", "mono.datagateway.v1.DeleteOrgSeatResponse");
_define_property(DeleteOrgSeatResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.AssignEmploymentToSeatRequest
 */ export class AssignEmploymentToSeatRequest extends Message {
    static fromBinary(bytes, options) {
        return new AssignEmploymentToSeatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssignEmploymentToSeatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssignEmploymentToSeatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssignEmploymentToSeatRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string employment_id = 1;
   */ _define_property(this, "employmentId", ""), /**
   * @generated from field: string seat_id = 2;
   */ _define_property(this, "seatId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AssignEmploymentToSeatRequest, "runtime", proto3);
_define_property(AssignEmploymentToSeatRequest, "typeName", "mono.datagateway.v1.AssignEmploymentToSeatRequest");
_define_property(AssignEmploymentToSeatRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "employment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AssignEmploymentToSeatResponse
 */ export class AssignEmploymentToSeatResponse extends Message {
    static fromBinary(bytes, options) {
        return new AssignEmploymentToSeatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssignEmploymentToSeatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssignEmploymentToSeatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssignEmploymentToSeatResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.EmploymentSpan employment = 1;
   */ _define_property(this, "employment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AssignEmploymentToSeatResponse, "runtime", proto3);
_define_property(AssignEmploymentToSeatResponse, "typeName", "mono.datagateway.v1.AssignEmploymentToSeatResponse");
_define_property(AssignEmploymentToSeatResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "employment",
            kind: "message",
            T: EmploymentSpan
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPeopleMovesRequest
 */ export class ListPeopleMovesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPeopleMovesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPeopleMovesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPeopleMovesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPeopleMovesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: google.protobuf.Timestamp from_date = 1;
   */ _define_property(this, "fromDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp to_date = 2;
   */ _define_property(this, "toDate", void 0), /**
   * empty = all orgs with ≥1 move
   *
   * @generated from field: repeated mono.datagateway.v1.RegistryRef employer_filters = 3;
   */ _define_property(this, "employerFilters", []), /**
   * @generated from field: bool include_acquisitions = 4;
   */ _define_property(this, "includeAcquisitions", false), /**
   * default 24
   *
   * @generated from field: int32 max_gap_months = 5;
   */ _define_property(this, "maxGapMonths", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPeopleMovesRequest, "runtime", proto3);
_define_property(ListPeopleMovesRequest, "typeName", "mono.datagateway.v1.ListPeopleMovesRequest");
_define_property(ListPeopleMovesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "from_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 2,
            name: "to_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "employer_filters",
            kind: "message",
            T: RegistryRef,
            repeated: true
        },
        {
            no: 4,
            name: "include_acquisitions",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "max_gap_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PeopleMove
 */ export class PeopleMove extends Message {
    static fromBinary(bytes, options) {
        return new PeopleMove().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PeopleMove().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PeopleMove().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PeopleMove, a, b);
    }
    constructor(data){
        super(), /**
   * employment_id of the destination row, or relationship id for acquisitions
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * EMPLOYMENT_PAIR | ACQUISITION
   *
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * "" for ACQUISITION
   *
   * @generated from field: string contact_id = 3;
   */ _define_property(this, "contactId", ""), /**
   * "Pinecrest staff (acquisition)" for ACQUISITION
   *
   * @generated from field: string contact_name = 4;
   */ _define_property(this, "contactName", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef from = 5;
   */ _define_property(this, "from", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryRef to = 6;
   */ _define_property(this, "to", void 0), /**
   * @generated from field: string to_text = 7;
   */ _define_property(this, "toText", ""), /**
   * @generated from field: google.protobuf.Timestamp moved_on = 8;
   */ _define_property(this, "movedOn", void 0), /**
   * 1, or transferred_headcount
   *
   * @generated from field: int32 headcount = 9;
   */ _define_property(this, "headcount", 0), /**
   * @generated from field: mono.datagateway.v1.RegistrySourceLabel source = 10;
   */ _define_property(this, "source", void 0), /**
   * a date is missing: moved_on unset, excluded from KPIs and flow nodes
   *
   * @generated from field: bool undated = 11;
   */ _define_property(this, "undated", false), /**
   * moved_on inferred from the previous job's end (never written)
   *
   * @generated from field: bool start_inferred = 12;
   */ _define_property(this, "startInferred", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PeopleMove, "runtime", proto3);
_define_property(PeopleMove, "typeName", "mono.datagateway.v1.PeopleMove");
_define_property(PeopleMove, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contact_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "from",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 6,
            name: "to",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 7,
            name: "to_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "moved_on",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "headcount",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "source",
            kind: "message",
            T: RegistrySourceLabel
        },
        {
            no: 11,
            name: "undated",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "start_inferred",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PeopleFlowNode
 */ export class PeopleFlowNode extends Message {
    static fromBinary(bytes, options) {
        return new PeopleFlowNode().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PeopleFlowNode().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PeopleFlowNode().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PeopleFlowNode, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryRef org = 1;
   */ _define_property(this, "org", void 0), /**
   * @generated from field: int32 left_count = 2;
   */ _define_property(this, "leftCount", 0), /**
   * @generated from field: int32 joined_count = 3;
   */ _define_property(this, "joinedCount", 0), /**
   * @generated from field: bool is_us = 4;
   */ _define_property(this, "isUs", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PeopleFlowNode, "runtime", proto3);
_define_property(PeopleFlowNode, "typeName", "mono.datagateway.v1.PeopleFlowNode");
_define_property(PeopleFlowNode, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "org",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 2,
            name: "left_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "joined_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "is_us",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPeopleMovesResponse
 */ export class ListPeopleMovesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPeopleMovesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPeopleMovesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPeopleMovesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPeopleMovesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * newest first
   *
   * @generated from field: repeated mono.datagateway.v1.PeopleMove moves = 1;
   */ _define_property(this, "moves", []), /**
   * @generated from field: repeated mono.datagateway.v1.PeopleFlowNode nodes = 2;
   */ _define_property(this, "nodes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPeopleMovesResponse, "runtime", proto3);
_define_property(ListPeopleMovesResponse, "typeName", "mono.datagateway.v1.ListPeopleMovesResponse");
_define_property(ListPeopleMovesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "moves",
            kind: "message",
            T: PeopleMove,
            repeated: true
        },
        {
            no: 2,
            name: "nodes",
            kind: "message",
            T: PeopleFlowNode,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPersonCareerPanelRequest
 */ export class GetPersonCareerPanelRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPersonCareerPanelRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPersonCareerPanelRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPersonCareerPanelRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPersonCareerPanelRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contact_id = 1;
   */ _define_property(this, "contactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPersonCareerPanelRequest, "runtime", proto3);
_define_property(GetPersonCareerPanelRequest, "typeName", "mono.datagateway.v1.GetPersonCareerPanelRequest");
_define_property(GetPersonCareerPanelRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPersonCareerPanelResponse
 */ export class GetPersonCareerPanelResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPersonCareerPanelResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPersonCareerPanelResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPersonCareerPanelResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPersonCareerPanelResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contact_id = 1;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * "Program Manager, VA.gov · Northwind Federal"
   *
   * @generated from field: string now_line = 3;
   */ _define_property(this, "nowLine", ""), /**
   * oldest first
   *
   * @generated from field: repeated mono.datagateway.v1.EmploymentSpan career = 4;
   */ _define_property(this, "career", []), /**
   * @generated from field: repeated mono.datagateway.v1.ContactWhoKnows who_knows = 5;
   */ _define_property(this, "whoKnows", []), /**
   * @generated from field: repeated mono.datagateway.v1.RegistryRef shows_up_on = 6;
   */ _define_property(this, "showsUpOn", []), /**
   * HANDLING_NOTE + INTEL heads, max 3
   *
   * @generated from field: repeated mono.datagateway.v1.IntelClaim notes = 7;
   */ _define_property(this, "notes", []), /**
   * @generated from field: mono.datagateway.v1.RestrictedRateTrail rate_trail = 8;
   */ _define_property(this, "rateTrail", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPersonCareerPanelResponse, "runtime", proto3);
_define_property(GetPersonCareerPanelResponse, "typeName", "mono.datagateway.v1.GetPersonCareerPanelResponse");
_define_property(GetPersonCareerPanelResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "now_line",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "career",
            kind: "message",
            T: EmploymentSpan,
            repeated: true
        },
        {
            no: 5,
            name: "who_knows",
            kind: "message",
            T: ContactWhoKnows,
            repeated: true
        },
        {
            no: 6,
            name: "shows_up_on",
            kind: "message",
            T: RegistryRef,
            repeated: true
        },
        {
            no: 7,
            name: "notes",
            kind: "message",
            T: IntelClaim,
            repeated: true
        },
        {
            no: 8,
            name: "rate_trail",
            kind: "message",
            T: RestrictedRateTrail
        }
    ]));
/**
 * ======================= Vault foundation =======================
 *
 * @generated from message mono.datagateway.v1.ListPersonRateTrailRequest
 */ export class ListPersonRateTrailRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPersonRateTrailRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPersonRateTrailRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPersonRateTrailRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPersonRateTrailRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contact_id = 1;
   */ _define_property(this, "contactId", ""), /**
   * optional narrowing
   *
   * @generated from field: string company_profile_id = 2;
   */ _define_property(this, "companyProfileId", ""), /**
   * DOSSIER | COMPANY_PEOPLE | ANCHOR_PEOPLE | PEOPLE_MAP | STAFFING_DRAWER | REVIEW_MERGE | API
   *
   * @generated from field: string surface = 3;
   */ _define_property(this, "surface", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPersonRateTrailRequest, "runtime", proto3);
_define_property(ListPersonRateTrailRequest, "typeName", "mono.datagateway.v1.ListPersonRateTrailRequest");
_define_property(ListPersonRateTrailRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "surface",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PersonRateObservation
 */ export class PersonRateObservation extends Message {
    static fromBinary(bytes, options) {
        return new PersonRateObservation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PersonRateObservation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PersonRateObservation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PersonRateObservation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string observation_id = 1;
   */ _define_property(this, "observationId", ""), /**
   * PAY | BILLED | INFERRED | PROPOSED | SUBK_AGREED (person-scoped)
   *
   * @generated from field: string observation_type = 2;
   */ _define_property(this, "observationType", ""), /**
   * @generated from field: double amount = 3;
   */ _define_property(this, "amount", 0), /**
   * @generated from field: string currency = 4;
   */ _define_property(this, "currency", ""), /**
   * @generated from field: string rate_unit = 5;
   */ _define_property(this, "rateUnit", ""), /**
   * @generated from field: string burden_basis = 6;
   */ _define_property(this, "burdenBasis", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef company = 7;
   */ _define_property(this, "company", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryRef lcat_entry = 8;
   */ _define_property(this, "lcatEntry", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryRef program = 9;
   */ _define_property(this, "program", void 0), /**
   * @generated from field: string period_label = 10;
   */ _define_property(this, "periodLabel", ""), /**
   * @generated from field: string normalized_period_key = 11;
   */ _define_property(this, "normalizedPeriodKey", ""), /**
   * INFERRED
   *
   * @generated from field: bool is_estimate = 12;
   */ _define_property(this, "isEstimate", false), /**
   * @generated from field: string source_label = 13;
   */ _define_property(this, "sourceLabel", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PersonRateObservation, "runtime", proto3);
_define_property(PersonRateObservation, "typeName", "mono.datagateway.v1.PersonRateObservation");
_define_property(PersonRateObservation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "observation_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rate_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "burden_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "company",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 8,
            name: "lcat_entry",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 9,
            name: "program",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 10,
            name: "period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "normalized_period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "is_estimate",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPersonRateTrailResponse
 */ export class ListPersonRateTrailResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPersonRateTrailResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPersonRateTrailResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPersonRateTrailResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPersonRateTrailResponse, a, b);
    }
    constructor(data){
        super(), /**
   * only granted entities; no count of hidden rows
   *
   * @generated from field: repeated mono.datagateway.v1.PersonRateObservation observations = 1;
   */ _define_property(this, "observations", []), /**
   * @generated from field: string read_event_id = 2;
   */ _define_property(this, "readEventId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPersonRateTrailResponse, "runtime", proto3);
_define_property(ListPersonRateTrailResponse, "typeName", "mono.datagateway.v1.ListPersonRateTrailResponse");
_define_property(ListPersonRateTrailResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "observations",
            kind: "message",
            T: PersonRateObservation,
            repeated: true
        },
        {
            no: 2,
            name: "read_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SensitiveRateGrant
 */ export class SensitiveRateGrant extends Message {
    static fromBinary(bytes, options) {
        return new SensitiveRateGrant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SensitiveRateGrant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SensitiveRateGrant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SensitiveRateGrant, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string principal_id = 2;
   */ _define_property(this, "principalId", ""), /**
   * @generated from field: string principal_name = 3;
   */ _define_property(this, "principalName", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryRef company = 4;
   */ _define_property(this, "company", void 0), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string granted_by_name = 6;
   */ _define_property(this, "grantedByName", ""), /**
   * @generated from field: google.protobuf.Timestamp granted_at = 7;
   */ _define_property(this, "grantedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp expires_at = 8;
   */ _define_property(this, "expiresAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp revoked_at = 9;
   */ _define_property(this, "revokedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SensitiveRateGrant, "runtime", proto3);
_define_property(SensitiveRateGrant, "typeName", "mono.datagateway.v1.SensitiveRateGrant");
_define_property(SensitiveRateGrant, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "principal_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "principal_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "granted_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "granted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "expires_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "revoked_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSensitiveRateGrantsRequest
 */ export class ListSensitiveRateGrantsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSensitiveRateGrantsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSensitiveRateGrantsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSensitiveRateGrantsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSensitiveRateGrantsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_profile_id = 1;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: bool include_revoked = 2;
   */ _define_property(this, "includeRevoked", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSensitiveRateGrantsRequest, "runtime", proto3);
_define_property(ListSensitiveRateGrantsRequest, "typeName", "mono.datagateway.v1.ListSensitiveRateGrantsRequest");
_define_property(ListSensitiveRateGrantsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_revoked",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSensitiveRateGrantsResponse
 */ export class ListSensitiveRateGrantsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSensitiveRateGrantsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSensitiveRateGrantsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSensitiveRateGrantsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSensitiveRateGrantsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.SensitiveRateGrant grants = 1;
   */ _define_property(this, "grants", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSensitiveRateGrantsResponse, "runtime", proto3);
_define_property(ListSensitiveRateGrantsResponse, "typeName", "mono.datagateway.v1.ListSensitiveRateGrantsResponse");
_define_property(ListSensitiveRateGrantsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "grants",
            kind: "message",
            T: SensitiveRateGrant,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GrantSensitiveRatesRequest
 */ export class GrantSensitiveRatesRequest extends Message {
    static fromBinary(bytes, options) {
        return new GrantSensitiveRatesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GrantSensitiveRatesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GrantSensitiveRatesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GrantSensitiveRatesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string principal_user_id = 2;
   */ _define_property(this, "principalUserId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: google.protobuf.Timestamp expires_at = 5;
   */ _define_property(this, "expiresAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GrantSensitiveRatesRequest, "runtime", proto3);
_define_property(GrantSensitiveRatesRequest, "typeName", "mono.datagateway.v1.GrantSensitiveRatesRequest");
_define_property(GrantSensitiveRatesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "principal_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "expires_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GrantSensitiveRatesResponse
 */ export class GrantSensitiveRatesResponse extends Message {
    static fromBinary(bytes, options) {
        return new GrantSensitiveRatesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GrantSensitiveRatesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GrantSensitiveRatesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GrantSensitiveRatesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SensitiveRateGrant grant = 1;
   */ _define_property(this, "grant", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GrantSensitiveRatesResponse, "runtime", proto3);
_define_property(GrantSensitiveRatesResponse, "typeName", "mono.datagateway.v1.GrantSensitiveRatesResponse");
_define_property(GrantSensitiveRatesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "grant",
            kind: "message",
            T: SensitiveRateGrant
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RevokeSensitiveRatesRequest
 */ export class RevokeSensitiveRatesRequest extends Message {
    static fromBinary(bytes, options) {
        return new RevokeSensitiveRatesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RevokeSensitiveRatesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RevokeSensitiveRatesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RevokeSensitiveRatesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RevokeSensitiveRatesRequest, "runtime", proto3);
_define_property(RevokeSensitiveRatesRequest, "typeName", "mono.datagateway.v1.RevokeSensitiveRatesRequest");
_define_property(RevokeSensitiveRatesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RevokeSensitiveRatesResponse
 */ export class RevokeSensitiveRatesResponse extends Message {
    static fromBinary(bytes, options) {
        return new RevokeSensitiveRatesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RevokeSensitiveRatesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RevokeSensitiveRatesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RevokeSensitiveRatesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SensitiveRateGrant grant = 1;
   */ _define_property(this, "grant", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RevokeSensitiveRatesResponse, "runtime", proto3);
_define_property(RevokeSensitiveRatesResponse, "typeName", "mono.datagateway.v1.RevokeSensitiveRatesResponse");
_define_property(RevokeSensitiveRatesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "grant",
            kind: "message",
            T: SensitiveRateGrant
        }
    ]));
